(function () {
    'use strict';

    angular.module('app.survey.scheme', ['textAngular']).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.survey_scheme', {
            url: '/survey/scheme',
            views: {
                'content@app': {
                    templateUrl: 'app/main/survey/scheme/scheme.html',
                    controller: 'SurveySchemeController as vm',
                },
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function ($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.survey_scheme')
                            .then(function () {
                                defer.resolve();
                            })
                            .catch(function (state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    },
                ],
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.survey.scheme')
        .controller('FormSurveySchemeController', FormSurveySchemeController);

    /** @ngInject */
    function FormSurveySchemeController(
        apiService,
        $mdDialog,
        theme,
        refData,
        dialogType,
        $scope,
        $timeout,
        $q
    ) {
        // data
        var vm = this;
        var SurveyScheme = apiService.SurveyScheme();
        var Ref = apiService.Reference();
        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.theme = theme;
        vm.form = {};
        vm.dialogType = dialogType;
        vm.data = {
            survey_scheme_category: [],
        };
        vm.listCategory = [];
        vm.selectedCategory = null;
        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;
        vm.update = update;
        vm.doAddCategory = doAddCategory;
        vm.doRemoveCategory = doRemoveCategory;

        init();

        function init() {
            if (vm.dialogType === 'UPDATE') {
                vm.data.id = refData.id;
                vm.data.name = refData.name;
                vm.data.description = refData.description;
                refData.survey_scheme_category.map(function (val) {
                    vm.data.survey_scheme_category.push({
                        id: val.survey_category.id,
                        description: val.survey_category.description,
                        type: val.survey_category.type,
                    });
                });
                loadSurveyCategory().then(function () {
                    vm.isLoading = false;
                });
            } else {
                vm.data.survey_scheme_category = [];
                loadSurveyCategory().then(function () {
                    vm.isLoading = false;
                });
            }
        }

        function setForm(form) {
            vm.form = form;
        }

        function submit(ev, form) {
            var request = SurveyScheme.create(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Submitting Request';
            request.$promise.then(function (res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function (err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function update(ev, form) {
            var request = SurveyScheme.update(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Updating Request';
            request.$promise.then(function (res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function (err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function () {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function loadSurveyCategory() {
            var defer = $q.defer();
            var request = Ref.surveyCategory({ has_all: false });
            request.$promise.then(function (res) {
                vm.listCategory = res;
                defer.resolve(res);
            });
            request.$promise.catch(function (err) {
                vm.listCategory = [];
                defer.resolve([]);
            });
            return defer.promise;
        }

        function doAddCategory(item) {
            var exists = false;
            for (var i = 0; i < vm.data.survey_scheme_category.length; i++) {
                var el = vm.data.survey_scheme_category[i];
                if (el.id == item.id) {
                    exists = true;
                    break;
                }
            }
            if (!exists) {
                vm.data.survey_scheme_category.push(item);
            }
        }

        function doRemoveCategory(idx) {
            vm.data.survey_scheme_category.splice(idx, 1);
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.survey.category', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.survey_category', {
            url: '/survey/category',
            views: {
                'content@app': {
                    templateUrl: 'app/main/survey/category/category.html',
                    controller: 'SurveyCategoryController as vm',
                },
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function ($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.survey_category')
                            .then(function () {
                                defer.resolve();
                            })
                            .catch(function (state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    },
                ],
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.survey.category')
        .controller('FormSurveyCategoryController', FormSurveyCategoryController);

    /** @ngInject */
    function FormSurveyCategoryController(
        apiService,
        $mdDialog,
        theme,
        refData,
        dialogType,
        $scope,
        $timeout,
        $q
    ) {
        // data
        var vm = this;
        var SurveyCategory = apiService.SurveyCategory();
        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.theme = theme;
        vm.form = {};
        vm.dialogType = dialogType;
        vm.data = {
            name: '',
            description: '',
            type: 'normal',
        };

        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;
        vm.update = update;
        vm.listType = ['normal', 'essay'];
        vm.confirmDialog = confirmDialog;
        vm.safeActions = safeActions;
        vm.isSafeActions = true;
        vm.confirmUpdate = confirmUpdate;

        init();

        function init() {
            if (vm.dialogType === 'UPDATE') {
                vm.data.id = refData.id;
                vm.data.name = refData.name;
                vm.data.description = refData.description;
                vm.data.type = refData.type;
                safeActions(refData.id).then(function (isSafe) {
                    console.log(isSafe);
                    vm.isSafeActions = isSafe;
                    vm.isLoading = false;
                });
            } else {
                $timeout(function () {
                    vm.isLoading = false;
                }, 1000);
            }
        }

        function submit(ev, form) {
            var request = SurveyCategory.create(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Submitting Request';
            request.$promise.then(function (res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function (err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function update(ev, form) {
            var request = SurveyCategory.update(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Updating Request';
            request.$promise.then(function (res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function (err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function confirmUpdate(ev, form) {
            if (!vm.isSafeActions) {
                var config = {
                    title: 'Category is used in questions',
                    message:
                        "We detect this category has been used, \n if you choose to update this category, all questions that having a reference to this category will be updated. \n if you won't to change the reference, please choose create options instead.",
                    textOK: 'UPDATE',
                    textCancel: 'CREATE',
                };
                confirmDialog(
                    ev,
                    config,
                    function () {
                        var config = {
                            title: 'Are you sure ?',
                            message:
                                "Data will be updated, you can't revert this action",
                            textOK: 'OK',
                            textCancel: 'CANCEL',
                        };
                        confirmDialog(
                            ev,
                            config,
                            update.bind(this, ev, form),
                            function () {
                                console.log('confirm cancel update');
                            }
                        );
                    },
                    function () {
                        var config = {
                            title: 'Are you sure ?',
                            message: 'Data will be created',
                            textOK: 'OK',
                            textCancel: 'CANCEL',
                        };
                        confirmDialog(
                            ev,
                            config,
                            submit.bind(this, ev, form),
                            function () {
                                console.log('confirm cancel create');
                            }
                        );
                    }
                );
                return;
            }

            update(ev, form);
        }

        function setForm(form) {
            vm.form = form;
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function () {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function confirmDialog(ev, config, callbackConfirm, callbackCancel) {
            var confirm = $mdDialog
                .confirm()
                .title(config.title)
                .textContent(config.message)
                .ariaLabel('Confirmation')
                .targetEvent(ev)
                .multiple(true)
                .ok(config.textOK)
                .cancel(config.textCancel);

            $mdDialog.show(confirm).then(
                function () {
                    callbackConfirm();
                },
                function () {
                    callbackCancel();
                }
            );
        }

        function safeActions(id) {
            var defer = $q.defer();
            var request = SurveyCategory.safeActions({ id: id });
            request.$promise.then(function (res) {
                console.log(res);
                defer.resolve(res.data.is_safe);
            });
            request.$promise.catch(function (err) {
                defer.resolve(false);
            });
            return defer.promise;
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.survey.question', ['textAngular']).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.survey_question', {
            url: '/survey/question',
            views: {
                'content@app': {
                    templateUrl: 'app/main/survey/question/question.html',
                    controller: 'SurveyQuestionController as vm',
                },
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function ($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.survey_question')
                            .then(function () {
                                defer.resolve();
                            })
                            .catch(function (state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    },
                ],
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.survey.question')
        .controller('FormSurveyQuestionController', FormSurveyQuestionController);

    /** @ngInject */
    function FormSurveyQuestionController(
        apiService,
        $mdDialog,
        theme,
        refData,
        dialogType,
        $scope,
        $timeout,
        $q
    ) {
        // data
        var vm = this;
        var SurveyQuestion = apiService.SurveyQuestion();
        var Ref = apiService.Reference();
        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.theme = theme;
        vm.form = {};
        vm.dialogType = dialogType;
        vm.data = {};
        vm.isSafeActions = true;
        vm.listCategory = [];
        vm.selectedCategory = null;
        vm.showState = {
            essay: false,
            normal: false,
        };
        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;
        vm.update = update;
        vm.confirmDialog = confirmDialog;
        vm.safeActions = safeActions;
        vm.confirmUpdate = confirmUpdate;
        vm.onChangeCategory = onChangeCategory;

        init();

        function init() {
            if (vm.dialogType === 'UPDATE') {
                vm.data.id = refData.id;
                vm.data.question_order = refData.question_order;
                vm.data.survey_category_id = refData.survey_category_id;
                vm.data.question = refData.question;
                vm.data.point_value = refData.point_value;
                vm.selectedCategory = refData.survey_category;
                loadSurveyCategory()
                    .then(safeActions.bind(this, refData.id))
                    .then(function (isSafe) {
                        onChangeCategory();
                        vm.isSafeActions = isSafe;
                        vm.isLoading = false;
                    });
            } else {
                loadSurveyCategory().then(function () {
                    vm.isLoading = false;
                });
            }
        }

        function submit(ev, form) {
            vm.data.survey_category_id = vm.selectedCategory.id;
            var request = SurveyQuestion.create(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Submitting Request';
            request.$promise.then(function (res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function (err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function update(ev, form) {
            var request = SurveyQuestion.update(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Updating Request';
            request.$promise.then(function (res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function (err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function confirmUpdate(ev, form) {
            if (!vm.isSafeActions) {
                var config = {
                    title: 'Category is used in questions',
                    message:
                        "We detect this question has been used in the result, \n if you choose to update this question, all results that having a reference to this question will be updated. \n if you won't to change the reference, please choose create options instead.",
                    textOK: 'UPDATE',
                    textCancel: 'CREATE',
                };
                confirmDialog(
                    ev,
                    config,
                    function () {
                        var config = {
                            title: 'Are you sure ?',
                            message:
                                "Data will be updated, you can't revert this action",
                            textOK: 'OK',
                            textCancel: 'CANCEL',
                        };
                        confirmDialog(
                            ev,
                            config,
                            update.bind(this, ev, form),
                            function () {
                                console.log('confirm cancel update');
                            }
                        );
                    },
                    function () {
                        var config = {
                            title: 'Are you sure ?',
                            message: 'Data will be created',
                            textOK: 'OK',
                            textCancel: 'CANCEL',
                        };
                        confirmDialog(
                            ev,
                            config,
                            submit.bind(this, ev, form),
                            function () {
                                console.log('confirm cancel create');
                            }
                        );
                    }
                );
                return;
            }

            update(ev, form);
        }

        function setForm(form) {
            vm.form = form;
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function () {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function confirmDialog(ev, config, callbackConfirm, callbackCancel) {
            var confirm = $mdDialog
                .confirm()
                .title(config.title)
                .textContent(config.message)
                .ariaLabel('Confirmation')
                .targetEvent(ev)
                .multiple(true)
                .ok(config.textOK)
                .cancel(config.textCancel);

            $mdDialog.show(confirm).then(
                function () {
                    callbackConfirm();
                },
                function () {
                    callbackCancel();
                }
            );
        }

        function safeActions(id) {
            var defer = $q.defer();
            var request = SurveyQuestion.safeActions({ id: id });
            request.$promise.then(function (res) {
                defer.resolve(res.data.is_safe);
            });
            request.$promise.catch(function (err) {
                defer.resolve(false);
            });
            return defer.promise;
        }

        function loadSurveyCategory() {
            var defer = $q.defer();
            var request = Ref.surveyCategory({ has_all: false });
            request.$promise.then(function (res) {
                vm.listCategory = res;
                defer.resolve(res);
            });
            request.$promise.catch(function (err) {
                vm.listCategory = [];
                defer.resolve([]);
            });
            return defer.promise;
        }

        function onChangeCategory() {
            if (vm.selectedCategory.type === 'essay') {
                vm.showState.essay = true;
                vm.showState.normal = false;
            } else {
                vm.showState.essay = false;
                vm.showState.normal = true;
            }
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.report.general.detail', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.report_general_detail', {
            url: '/detail/{achievement_id}',
            views: {
                'content@app': {
                    templateUrl:
                        'app/main/report/general/view-detail/view-detail.html',
                    controller: 'ReportViewDetailController as vm',
                },
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report.general.detail')
        .controller('ReportViewDetailController', ReportViewDetailController);

    /** @ngInject */
    function ReportViewDetailController(
        apiService,
        fuseTheming,
        $timeout,
        blockUI,
        $window,
        appConfig,
        authService,
        $location,
        $stateParams,
        $state
    ) {
        var vm = this;
        var Report = apiService.Report();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.achievementId = 0;
        vm.data = {
            achievement: {},
            detail: [],
            current: 1,
        };
        vm.filter = {
            valid: false,
            invalid: false,
            not_answered: false,
        };

        // method
        vm.renderIconFlag = renderIconFlag;
        vm.backToReport = backToReport;
        vm.filteredFlag = filteredFlag;
        vm.loadData = loadData;

        activate();

        function activate() {
            vm.achievementId = $stateParams.achievement_id;
            loadData();
        }

        function loadData() {
            blockView.start({ message: 'Loading Report' });
            var request = Report.detail({ type: 'general', id: vm.achievementId });
            request.$promise.then(function (res) {
                vm.data = res.data;
                console.log(res);
                $timeout(function () {
                    blockView.stop();
                }, 1000);
            });
            request.$promise.catch(function () {
                vm.data = {
                    achievement: {},
                    detail: [],
                };
                $timeout(function () {
                    blockView.stop();
                }, 1000);
            });
            return request.$promise;
        }

        function exportData() {
            var tmpStart = angular.copy(vm.tempStart);
            var tmpEnd = angular.copy(vm.tempEnd);
            var startDate = moment(tmpStart).format('YYYY-MM-DD');
            var endDate = moment(tmpEnd).format('YYYY-MM-DD');
            var protocol = $location.protocol();
            var host = $location.host();
            var url =
                appConfig.apiUrl +
                'report/export?start_date=' +
                startDate +
                '&end_date=' +
                endDate +
                '&token=' +
                authService.getToken();

            $window.open(protocol + '://' + host + url, '_blank');
        }

        function renderIconFlag(flag) {
            var icon = 'icon-alert-circle';
            switch (flag) {
                case 'VALID':
                    icon = 'icon-check green-400-fg';
                    break;
                case 'INVALID':
                    icon = 'icon-close red-400-fg';
                    break;
                case 'NOT_ANSWERED':
                    icon = 'icon-alert-circle grey-400-fg';
                    break;
            }
            return icon;
        }

        function backToReport() {
            $state.go('app.report_general');
        }

        function filteredFlag(item) {
            var filter = [];
            Object.keys(vm.filter).forEach(function (key) {
                if (vm.filter[key]) {
                    filter.push(key.toUpperCase());
                }
            });

            if (filter.length === 0) {
                return true;
            }

            return filter.indexOf(item.flag) !== -1;
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.report.survey', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.report_survey', {
            url: '/report-survey',
            views: {
                'content@app': {
                    templateUrl: 'app/main/report/survey/survey.html',
                    controller: 'ReportSurveyController as vm',
                },
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function ($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.report_survey')
                            .then(function () {
                                defer.resolve();
                            })
                            .catch(function (state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    },
                ],
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report.survey')
        .controller('ReportDetailSurveyController', ReportDetailSurveyController);

    /** @ngInject */
    function ReportDetailSurveyController($mdDialog, theme, refData) {
        var vm = this;
        vm.theme = theme;
        vm.refData = angular.copy(refData);
        vm.hide = hide;
        vm.cancel = cancel;
        vm.results = [];

        activate();

        function activate() {
            vm.results = vm.refData.results;
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.report.papikostik', ['chart.js']).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.report_papikostik', {
            url: '/report-papikostik',
            views: {
                'content@app': {
                    templateUrl: 'app/main/report/papikostik/papikostik.html',
                    controller: 'ReportPapikostikController as vm',
                },
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function ($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.report_papikostik')
                            .then(function () {
                                defer.resolve();
                            })
                            .catch(function (state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    },
                ],
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report.papikostik')
        .controller(
            'ReportViewDetailPapikostikController',
            ReportViewDetailPapikostikController
        );

    /** @ngInject */
    function ReportViewDetailPapikostikController($mdDialog, theme, refData) {
        var vm = this;
        vm.theme = theme;
        vm.refData = angular.copy(refData);
        vm.hide = hide;
        vm.cancel = cancel;
        vm.detail = refData.detail;
        vm.charts = {
            data: [],
            labels: [],
            options: {
                legend: {
                    display: false,
                    labels: {
                        fontColor: 'rgb(255, 99, 132)',
                    },
                },
                scale: {
                    display: true,
                    gridLines: {
                        display: true,
                        circular: true,
                        lineWidth: 1,
                    },
                    angleLines: {
                        display: true,
                        lineWidth: 1,
                    },
                    ticks: {
                        display: true,
                        suggestedMin: 0,
                        suggestedMax: 9,
                        beginAtZero: true,
                        stepSize: 1,
                        fontColor: '#000',
                        fontSize: 14,
                        drawTicks: true,
                    },
                },
                scaleLabel: {
                    fontColor: '#000',
                    fontSize: 18,
                },
                maintainAspectRatio: true,
                responsive: true,
            },
            override: {
                borderWidth: 3,
                fill: true, // for filling area with color in the bottom line
                borderColor: 'rgba(236,63,122,1)',
                pointBackgroundColor: 'rgba(255,255,255,1)',
                pointHoverBackgroundColor: 'rgba(236,63,122,1)',
                pointHoverBorderColor: 'rgba(236,63,122,1)',
                backgroundColor: 'rgba(236,63,122,0.1)',
                type: 'radar',
                borderCapStyle: 'round',
                pointBorderWidth: 1,
                pointBorderColor: '#000',
            },
        };

        activate();

        function activate() {
            console.log(refData)
            console.log(vm.detail);
            // buildChartData(vm.detail);
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function buildChartData(data) {
            for (var i = 0; i < data.length; i++) {
                for (var j = 0; j < data[i].ref_detail.length; j++) {
                    vm.charts.data.push(data[i].ref_detail[j].total);
                    vm.charts.labels.push(data[i].ref_detail[j].abjact);
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.report.case_study', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.report_case_study', {
            url: '/report-case-study',
            views: {
                'content@app': {
                    templateUrl: 'app/main/report/case-study/case-study.html',
                    controller: 'ReportCaseStudyController as vm',
                },
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function ($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.report_case_study')
                            .then(function () {
                                defer.resolve();
                            })
                            .catch(function (state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    },
                ],
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report.case_study')
        .controller(
            'ReportDetailCaseStudyController',
            ReportDetailCaseStudyController
        );

    /** @ngInject */
    function ReportDetailCaseStudyController(
        $mdDialog,
        theme,
        refData,
        $timeout,
        $localStorage,
        $sce,
        appConfig
    ) {
        var vm = this;
        vm.theme = theme;
        vm.refData = angular.copy(refData);
        vm.hide = hide;
        vm.cancel = cancel;
        vm.isLoading = false;
        vm.loadingMessage = 'Please Wait';
        vm.results = [];
        vm.getResource = getResource;
        vm.trustResource = trustResource;

        activate();

        function activate() {
            vm.isLoading = true;
            vm.results = vm.refData.results;
            $timeout(function () {
                vm.isLoading = false;
            }, 2000);
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function trustResource(item) {
            return $sce.trustAsHtml(item);
        }

        function getResource(filename) {
            var token = $localStorage.token;
            var url =
                appConfig.apiUrl +
                'assessment/getResource?filename=' +
                filename +
                '&session_type=case_study&token=' +
                token +
                '&page=hsn#toolbar=0';
            return $sce.trustAsResourceUrl(url);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.questions_papikostik', ['textAngular'])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.qa_questions_papikostik', {
            url: '/qa/questions_papikostik',
            views: {
                'content@app': {
                    templateUrl: 'app/main/qa/qa-papikostik/qa-papikostik.html',
                    controller: 'QaPapikostikController as vm'
                }
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.qa_questions_papikostik')
                            .then(function() {
                                defer.resolve();
                            })
                            .catch(function(state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    }
                ]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.questions_papikostik')
        .controller('FormQaPapikostikController', FormQaPapikostikController);

    /** @ngInject */
    function FormQaPapikostikController(
        apiService,
        $mdDialog,
        theme,
        refData,
        dialogType,
        $scope,
        $timeout
    ) {
        // data
        var vm = this;
        var QuestionPapikostik = apiService.QuestionPapikostik();
        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.theme = theme;
        vm.form = {};
        vm.dialogType = dialogType;
        vm.data = {};

        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;
        vm.update = update;

        init();

        function init() {
            vm.data = angular.copy(refData);
            $timeout(function() {
                vm.isLoading = false;
            }, 1000);
        }

        function submit(ev, form) {
            var request = QuestionPapikostik.create(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Submitting Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function update(ev, form) {
            console.log(form);
            console.log(vm.data);
            var request = QuestionPapikostik.update(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Updating Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function setForm(form) {
            vm.form = form;
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function() {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.qa.competency', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.qa_competency', {
            url: '/qa/competency',
            views: {
                'content@app': {
                    templateUrl: 'app/main/qa/competency/competency.html',
                    controller: 'QaCompetencyController as vm'
                }
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.qa_competency')
                            .then(function() {
                                defer.resolve();
                            })
                            .catch(function(state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    }
                ]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.competency')
        .controller('FormCompetencyController', FormCompetencyController);

    /** @ngInject */
    function FormCompetencyController(
        apiService,
        $mdDialog,
        theme,
        refData,
        dialogType,
        $scope,
        $timeout
    ) {
        // data
        var vm = this;
        var Competency = apiService.Competency();
        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.theme = theme;
        vm.form = {};
        vm.dialogType = dialogType;
        vm.data = {
            name: '',
            description: '',
            code: ''
        };

        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;
        vm.update = update;

        init();

        function init() {
            if (vm.dialogType === 'UPDATE') {
                vm.data.id = refData.id;
                vm.data.name = refData.name;
                vm.data.description = refData.description;
            }

            $timeout(function() {
                vm.isLoading = false;
            }, 1000);
        }

        function submit(ev, form) {
            var request = Competency.create(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Submitting Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function update(ev, form) {
            var request = Competency.update(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Updating Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function setForm(form) {
            vm.form = form;
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function() {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.questions_general', ['ngFileUpload', 'textAngular'])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.qa_questions_general', {
            url: '/qa/questions_general',
            views: {
                'content@app': {
                    templateUrl: 'app/main/qa/qa-general/qa-general.html',
                    controller: 'QaGeneralController as vm'
                }
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.qa_questions_general')
                            .then(function() {
                                defer.resolve();
                            })
                            .catch(function(state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    }
                ]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.questions_general')
        .controller('QuestionUploadController', QuestionUploadController);

    /** @ngInject */
    function QuestionUploadController(
        apiService,
        $mdDialog,
        theme,
        $scope,
        $timeout,
        Upload,
        $q
    ) {
        // data
        var vm = this;
        var QuestionGeneral = apiService.QuestionGeneral();
        var Ref = apiService.Reference();
        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.isErrorUpload = false;
        vm.theme = theme;
        vm.form = {};
        vm.data = {
            file: null,
            pool_id: null
        };
        vm.listQuestionPool = [];
        vm.tempFile = undefined;
        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;
        vm.validationLog = [];

        init();

        function init() {
            loadQuestionPool()
                .then(setQuestionPool)
                .finally(function() {
                    $timeout(function() {
                        vm.isLoading = false;
                    }, 2000);
                });
        }

        function submit(ev, form) {
            vm.isLoading = true;
            vm.loadingMessage = 'Uploading Request';
            var fd = new FormData();
            for (var key in vm.data) {
                fd.append(key, vm.data[key]);
            }
            var request = QuestionGeneral.upload({}, fd);
            request.$promise.then(function(res) {
                vm.isLoading = false;
                vm.isErrorUpload = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                vm.isLoading = false;
                vm.validationLog = err.data.errors;
                vm.isErrorUpload = true;
                showDialog(ev, false, err.data);
            });
        }

        function loadQuestionPool() {
            var request = Ref.questionPool({ has_all: false });
            return request.$promise;
        }

        function setQuestionPool(data) {
            var defer = $q.defer();
            vm.listQuestionPool = data;
            defer.resolve(true);
            return defer.promise;
        }

        function setForm(form) {
            vm.form = form;
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function() {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.questions_general')
        .controller('FormQaGeneralController', FormQaGeneralController);

    /** @ngInject */
    function FormQaGeneralController(
        apiService,
        $mdDialog,
        theme,
        refData,
        dialogType,
        $scope,
        $timeout,
        $q,
        Upload
    ) {
        // data
        var vm = this;
        var QuestionGeneral = apiService.QuestionGeneral();
        var Ref = apiService.Reference();
        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.errorInit = false;
        vm.theme = theme;
        vm.form = {};
        vm.dialogType = dialogType;
        vm.data = {
            question: 'Write your question here',
            question_type: 'multiple',
            answers: [
                {
                    answer: '',
                    flag: 0,
                    is_update: false
                }
            ],
            image_temp: null
        };
        vm.listQuestionPool = [];
        vm.listQuestionCategory = [];
        vm.listCompetencies = [];

        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;
        vm.update = update;
        vm.addAnswer = addAnswer;
        vm.minAnswer = minAnswer;
        vm.indexToAbjact = indexToAbjact;

        init();

        function init() {
            loadQuestionCategory()
                .then(setQuestionCategory)
                .then(loadQuestionPool)
                .then(setQuestionPool)
                .then(loadCompetencies)
                .then(setCompetencies)
                .then(initFormData)
                .then(function() {
                    $timeout(function() {
                        vm.isLoading = false;
                    }, 1000);
                })
                .catch(function(err) {
                    vm.errorInit = true;
                    vm.errorMessage = 'Failed initializing data';
                    $timeout(function() {
                        vm.isLoading = false;
                    }, 1000);
                });
        }

        function initFormData() {
            var defer = $q.defer();
            if (vm.dialogType === 'UPDATE') {
                vm.data.id = refData.id;
                vm.data.category_id = refData.question_category_id;
                vm.data.pool_id = refData.question_pool_id;
                vm.data.question_id = refData.question_id;
                vm.data.question = refData.question.question;
                vm.data.question_type = refData.question.type;
                vm.data.competency_id = refData.competency_id;
                vm.data.answers = [];
                refData.answers.map(function(val) {
                    vm.data.answers.push({
                        id: val.id,
                        flag: val.flag,
                        answer: val.answer,
                        is_update: true
                    });
                });
                if (refData.question.having_images == 1) {
                    loadImages(refData.question.images).then(function(images) {
                        vm.data.image_temp = images.data;
                    });
                }
                defer.resolve(true);
            } else {
                defer.resolve(true);
            }
            return defer.promise;
        }

        function addAnswer() {
            vm.data.answers.push({
                flag: false,
                answer: '',
                is_update: false
            });
        }

        function minAnswer(idx) {
            vm.data.answers.splice(idx, 1);
        }

        function loadImages(images) {
            var request = QuestionGeneral.images({ path: images });
            return request.$promise;
        }

        function submit(ev, form) {
            vm.isLoading = true;
            var checkImage = havingImages(vm.data);
            checkImage.then(function(res) {
                if (res.status) {
                    vm.data.image = res.image;
                }
                var request = QuestionGeneral.create(vm.data);
                vm.loadingMessage = 'Submitting Request';
                request.$promise.then(function(res) {
                    vm.isLoading = false;
                    showDialog(ev, true, res);
                });
                request.$promise.catch(function(err) {
                    form.$setPristine();
                    form.$setUntouched();
                    vm.isLoading = false;
                    showDialog(ev, false, err.data);
                });
            });
        }

        function update(ev, form) {
            vm.isLoading = true;
            var checkImage = havingImages(vm.data);
            checkImage.then(function(res) {
                if (res.status) {
                    vm.data.image = res.image;
                }
                var request = QuestionGeneral.update(vm.data);
                vm.loadingMessage = 'Updating Request';
                request.$promise.then(function(res) {
                    vm.isLoading = false;
                    showDialog(ev, true, res);
                });
                request.$promise.catch(function(err) {
                    form.$setPristine();
                    form.$setUntouched();
                    vm.isLoading = false;
                    showDialog(ev, false, err.data);
                });
            });
        }

        function havingImages(ref) {
            var defer = $q.defer();
            if (ref.image_temp) {
                Upload.dataUrl(ref.image_temp, true).then(function(url) {
                    defer.resolve({ status: true, image: url });
                });
            } else {
                defer.resolve({ status: false, image: null });
            }
            return defer.promise;
        }

        function loadCompetencies() {
            var request = Ref.competencies({ has_all: false });
            return request.$promise;
        }

        function loadQuestionPool() {
            var request = Ref.questionPool({ has_all: false });
            return request.$promise;
        }

        function loadQuestionCategory() {
            var request = Ref.questionCategory({ has_all: false });
            return request.$promise;
        }

        function setQuestionPool(data) {
            var defer = $q.defer();
            vm.listQuestionPool = data;
            defer.resolve(true);
            return defer.promise;
        }

        function setQuestionCategory(data) {
            var defer = $q.defer();
            vm.listQuestionCategory = data;
            defer.resolve(true);
            return defer.promise;
        }

        function setCompetencies(data) {
            var defer = $q.defer();
            vm.listCompetencies = data;
            defer.resolve(true);
            return defer.promise;
        }

        function setForm(form) {
            vm.form = form;
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function() {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function indexToAbjact(idx) {
            var abjacts = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
            return abjacts[idx];
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.qa.pool', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.qa_pool', {
            url: '/qa/pool',
            views: {
                'content@app': {
                    templateUrl: 'app/main/qa/pool/pool.html',
                    controller: 'QaPoolController as vm'
                }
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.qa_pool')
                            .then(function() {
                                defer.resolve();
                            })
                            .catch(function(state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    }
                ]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.pool')
        .controller('FormQaPoolController', FormQaPoolController);

    /** @ngInject */
    function FormQaPoolController(
        apiService,
        $mdDialog,
        theme,
        refData,
        dialogType,
        $scope,
        $timeout
    ) {
        // data
        var vm = this;
        var Pool = apiService.Pool();
        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.theme = theme;
        vm.form = {};
        vm.dialogType = dialogType;
        vm.data = {
            name: '',
            description: '',
            type: 'general'
        };
        vm.listType = ['papikostik','general','tiki'];

        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;
        vm.update = update;

        init();

        function init() {
            if (vm.dialogType === 'UPDATE') {
                vm.data.id = refData.id;
                vm.data.name = refData.name;
                vm.data.description = refData.description;
                vm.data.type = refData.type;
            }

            $timeout(function() {
                vm.isLoading = false;
            }, 1000);
        }

        function submit(ev, form) {
            var request = Pool.create(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Submitting Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function update(ev, form) {
            var request = Pool.update(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Updating Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function setForm(form) {
            vm.form = form;
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function() {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.qa.category', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.qa_category', {
            url: '/qa/category',
            views: {
                'content@app': {
                    templateUrl: 'app/main/qa/category/category.html',
                    controller: 'QaCategoryController as vm'
                }
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.qa_category')
                            .then(function() {
                                defer.resolve();
                            })
                            .catch(function(state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    }
                ]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.category')
        .controller('FormCategoryController', FormCategoryController);

    /** @ngInject */
    function FormCategoryController(
        apiService,
        $mdDialog,
        theme,
        refData,
        dialogType,
        $scope,
        $timeout
    ) {
        // data
        var vm = this;
        var Category = apiService.Category();
        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.theme = theme;
        vm.form = {};
        vm.dialogType = dialogType;
        vm.data = {
            name: '',
            description: '',
            code: ''
        };

        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;
        vm.update = update;

        init();

        function init() {
            if (vm.dialogType === 'UPDATE') {
                vm.data.id = refData.id;
                vm.data.name = refData.name;
                vm.data.description = refData.description;
                vm.data.code = refData.code;
            }

            $timeout(function() {
                vm.isLoading = false;
            }, 1000);
        }

        function submit(ev, form) {
            var request = Category.create(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Submitting Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function update(ev, form) {
            var request = Category.update(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Updating Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function setForm(form) {
            vm.form = form;
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function() {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.guides', ['ngFileUpload']).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.guides', {
            url: '/guides',
            views: {
                'content@app': {
                    templateUrl: 'app/main/guides/guides.html',
                    controller: 'GuidesController as vm',
                },
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function ($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.guides')
                            .then(function () {
                                defer.resolve();
                            })
                            .catch(function (state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    },
                ],
            },
        });
    }
})();

/* eslint-disable angular/log */
/* eslint-disable no-console */
(function () {
    'use strict';

    angular
        .module('app.guides')
        .controller('ViewGuidesToolbarController', ViewGuidesToolbarController);

    /** @ngInject */
    function ViewGuidesToolbarController($mdDialog, theme, guide) {
        // data
        var vm = this;
        vm.isLoading = true;
        vm.isErrorLoad = false;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.theme = theme;
        vm.guide = guide;

        activate();

        function activate() {
            console.log(guide);
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.clients.assessment_tiki', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.clients.assessment_tiki', {
            url: '/tiki/{session_id}/{pool_id}/{guide_id}',
            views: {
                client_content: {
                    templateUrl:
                        'app/main/clients/assessment-tiki/assessment-tiki.html',
                    controller: 'AssessmentTikiController as vm'
                }
            }
        });

        $stateProvider.state('app.clients.assessment_tiki.guide', {
            url: '/guide/{temp_session_id}/{section_id}',
            views: {
                tiki_content: {
                    templateUrl:
                        'app/main/clients/assessment-tiki/tiki-guide/tiki-guide.html',
                    controller: 'AssessmentTikiGuideController as vm'
                }
            }
        });

        $stateProvider.state('app.clients.assessment_tiki.section', {
            url: '/section/{temp_session_id}/{section_id}',
            views: {
                tiki_content: {
                    templateUrl:
                        'app/main/clients/assessment-tiki/tiki-section/tiki-section.html',
                    controller: 'AssessmentTikiSectionController as vm'
                }
            }
        });
    }
})();

/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable angular/log */
/* eslint-disable angular/json-functions */
(function() {
    'use strict';

    angular
        .module('app.clients.assessment_tiki')
        .controller(
            'AssessmentTikiSectionController',
            AssessmentTikiSectionController
        );

    /** @ngInject */
    function AssessmentTikiSectionController(
        $state,
        apiService,
        blockUI,
        $scope,
        $stateParams,
        $mdDialog,
        fuseTheming,
        toastr,
        $interval
    ) {
        var vm = this;
        var Assessment = apiService.Assessment();
        var alert;
        var countdownInterval;
        vm.themes = fuseTheming.themes;
        vm.isLoading = false;
        vm.sectionId = $stateParams.section_id;
        vm.tempSessionId = $stateParams.temp_session_id;
        vm.sessionId = $stateParams.session_id;
        vm.questions = [];
        vm.remainingTimes = 0;
        vm.tikiSessionId = 0;
        vm.isFailedGetSection = false;
        vm.activeQuestion = {};
        vm.nextQuestion = nextQuestion;
        vm.prevQuestion = prevQuestion;
        vm.lastIndex = 0;
        vm.displayTimer = '00:00';
        vm.remainingTimes = 0;
        vm.timeIsOver = false;
        vm.progressWidth = '100%';
        vm.progress = false;
        vm.interruptSync = false;
        vm.finish = finish;
        vm.isFinishAction = false;

        activate();

        function activate() {
            getSection();
        }

        function getSection() {
            var request = Assessment.getTikiSection({
                section_id: vm.sectionId,
                temp_session_id: vm.tempSessionId
            });
            request.$promise.then(successGetSection);
            request.$promise.catch(failedGetSection);
        }

        function successGetSection(params) {
            if (params.data.is_finished == 1) {
                if (params.data.section_id == 4) {
                    $state.go('app.clients.menus');
                } else {
                    checkNextSection();
                }
                return;
            }
            vm.questions = JSON.parse(params.data.scheme);
            for (var i = 0; i < vm.questions.length; i++) {
                if (vm.questions[i].is_last_index) {
                    vm.activeQuestion = vm.questions[i];
                }
            }
            vm.lastIndex = vm.questions.length - 1;
            vm.remainingTimes = params.data.remaining_time;
            vm.tikiSessionId = params.data.id;
            vm.isFailedGetSection = false;
            vm.displayTimer = fmtMSS(vm.remainingTimes);
            setCountdownInterval();
        }

        function failedGetSection() {
            vm.remainingTimes = 0;
            vm.questions = [];
            vm.tikiSessionId = 0;
            vm.isFailedGetSection = true;
        }

        function nextQuestion() {
            if (!isSelectedAnswerValid()) {
                showMessage(
                    'error',
                    'Pertanyaan ini membutuhkan ' +
                        vm.activeQuestion.valid_answer_count +
                        ' Jawaban !'
                );
                return;
            }
            var idx = angular.copy(vm.activeQuestion.index);
            var nextIdx = idx + 1;
            if (vm.questions[nextIdx]) {
                vm.progress = !vm.progress;
                vm.activeQuestion = vm.questions[nextIdx];
                setLastIndex(nextIdx);
            }
        }

        function prevQuestion() {
            var idx = angular.copy(vm.activeQuestion.index);
            var prevIndex = idx - 1;
            if (vm.questions[prevIndex]) {
                vm.progress = !vm.progress;
                vm.activeQuestion = vm.questions[prevIndex];
                setLastIndex(prevIndex);
            }
        }

        function setLastIndex(idx) {
            for (var i = 0; i < vm.questions.length; i++) {
                if (idx === i) {
                    vm.questions[i].is_last_index = true;
                } else {
                    vm.questions[i].is_last_index = false;
                }
            }
        }

        function isSelectedAnswerValid() {
            var required = vm.activeQuestion.valid_answer_count;
            var counter = 0;
            for (var i = 0; i < vm.activeQuestion.answer.length; i++) {
                if (vm.activeQuestion.answer[i].selected) {
                    counter += 1;
                }
            }
            return counter === required;
        }

        function finish(ev) {
            var message =
                'Saat ini waktu anda masih tersisa, apabila anda melakukan finish anda tidak dapat kembali lagi';

            if (vm.sectionId == 4) {
                message =
                    'Ini adalah section terakhir, apakah anda yakin akan mengakhiri test ini ?';
            }

            var confirm = $mdDialog
                .confirm()
                .title('Apakah anda yakin ?')
                .textContent(message)
                .ariaLabel('Start')
                .targetEvent(ev)
                .ok('OK')
                .cancel('NO');

            $mdDialog.show(confirm).then(function() {
                vm.isFinishAction = true;
                checkNextSection();
                vm.isFinishAction = false;
            });
        }

        function showMessage(status, message) {
            switch (status) {
                case 'success':
                    toastr.success(message);
                    break;
                case 'warning':
                    toastr.warning(message);
                    break;
                case 'error':
                    toastr.error(message);
                    break;
                case 'info':
                    toastr.info(message);
                    break;
            }
        }

        function fmtMSS(s) {
            if (!s || s <= 0) {
                return '00:00';
            }
            return (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + s;
        }

        function setCountdownInterval() {
            countdownInterval = $interval(function() {
                vm.remainingTimes -= 1;
                vm.displayTimer = fmtMSS(vm.remainingTimes);
                if (vm.remainingTimes <= 0) {
                    $interval.cancel(countdownInterval);
                    if (!vm.isFinishAction) {
                        checkNextSection();
                    }
                    return;
                }
                if (vm.remainingTimes % 20 == 0) {
                    syncTikiSection();
                }
            }, 1000);
        }

        // TODO : check next section
        function checkNextSection() {
            $mdDialog.cancel();
            showMessage(
                'warning',
                'Your session for ' + vm.sectionId + ' has been ended'
            );
            var counter = parseInt(vm.sectionId);
            if (counter <= 4) {
                setTikiSectionFinished();
            } else {
                showFinishDialog();
            }
        }

        function setTikiSectionFinished() {
            blockUI.start({ message: 'please wait' });
            var request = Assessment.setTikiSectionFinished({
                session_id: vm.sessionId,
                section_id: vm.sectionId,
                temp_session_id: vm.tempSessionId,
                schemes: vm.questions
            });

            request.$promise.then(successSetTikiSectionFinished);
            request.$promise.catch(failedSetTikiSectionFinished);
        }

        function successSetTikiSectionFinished() {
            if (vm.sectionId == 4) {
                showFinishDialog();
            } else {
                setTikiSession();
            }
        }

        function setTikiSession() {
            var nextSection = parseInt(vm.sectionId) + 1;
            var request = Assessment.setTikiSession({
                section_id: nextSection,
                temp_session_id: vm.tempSessionId
            });
            request.$promise.then(function() {
                blockUI.stop();
                $scope.$emit('::onFinishedSection');
            });
            request.$promise.catch(function() {
                blockUI.stop();
            });
        }

        function failedSetTikiSectionFinished(params) {
            console.log(params);
        }

        function showFinishDialog() {
            blockUI.stop();
            alert = $mdDialog
                .alert()
                .title('Congratulations')
                .textContent(
                    'Your test has been finished, you will be redirected to menu page'
                )
                .ok('Close');

            $mdDialog.show(alert).finally(function() {
                alert = undefined;
                $state.go('app.clients.menus');
            });
        }

        function syncTikiSection() {
            vm.interruptSync = true;
            var request = Assessment.syncTikiSection({
                temp_session_id: vm.tempSessionId,
                section_id: vm.sectionId,
                remaining_time: vm.remainingTimes,
                schemes: vm.questions
            });

            request.$promise.then(successSyncTikiSection);
            request.$promise.catch(failedSyncTikiSection);
        }

        function successSyncTikiSection() {
            vm.interruptSync = false;
        }

        function failedSyncTikiSection(params) {
            vm.interruptSync = false;
            showMessage('danger', 'failed sync data');
        }

        $scope.$watch('vm.progress', function(newVal, oldVal) {
            vm.activeQuestion.index;
            if (vm.activeQuestion.index == 0) {
                vm.progressWidth = 0 + '%';
            } else {
                var calculation =
                    (vm.activeQuestion.index / vm.questions.length) * 100;
                vm.progressWidth = Math.round(calculation) + '%';
            }
        });

        $scope.$on('$destroy', function() {
            $interval.cancel(countdownInterval);
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.clients.assessment_tiki')
        .controller('AssessmentTikiGuideController', AssessmentTikiGuideController);

    /** @ngInject */
    function AssessmentTikiGuideController(
        $state,
        apiService,
        blockUI,
        $stateParams,
        $mdDialog,
        fuseTheming
    ) {
        var vm = this;
        var Assessment = apiService.Assessment();
        vm.themes = fuseTheming.themes;
        vm.isLoading = false;
        vm.sectionId = $stateParams.section_id;
        vm.tempSessionId = $stateParams.temp_session_id;
        vm.start = start;

        checkGuideIsRead();

        function checkGuideIsRead() {
            var request = Assessment.checkTikiGuideIsRead({
                temp_session_id: vm.tempSessionId,
                section_id: vm.sectionId
            });
            request.$promise.then(function(res) {
                if (res.status) {
                    toSection();
                }
            });
        }

        function start(ev) {
            var confirm = $mdDialog
                .confirm()
                .title('Apakah anda yakin ?')
                .textContent(
                    'Saat test dimulai waktu pengerjaan akan dimulai dan anda tidak dapat kembali lagi'
                )
                .ariaLabel('Start')
                .targetEvent(ev)
                .ok('OK')
                .cancel('NO');

            $mdDialog.show(confirm).then(setGuideIsRead);
        }

        function toSection() {
            $state.go('app.clients.assessment_tiki.section', {
                temp_session_id: vm.tempSessionId,
                section_id: vm.sectionId
            });
        }

        function setGuideIsRead() {
            vm.isLoading = true;
            var request = Assessment.setTikiGuideIsRead({
                section_id: vm.sectionId,
                temp_session_id: vm.tempSessionId
            });
            request.$promise.then(function() {
                vm.isLoading = false;
                toSection();
            });
            request.$promise.catch(function() {
                vm.isLoading = false;
                $mdDialog.alert({
                    title: 'Failed',
                    textContent: 'Failed Set Section, please try again',
                    ok: 'Close'
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.case_study.scheme', ['ngFileUpload', 'textAngular'])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.case_study_scheme', {
            url: '/case_study/scheme',
            views: {
                'content@app': {
                    templateUrl: 'app/main/case-study/scheme/scheme.html',
                    controller: 'CaseStudySchemeController as vm',
                },
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function ($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.case_study_scheme')
                            .then(function () {
                                defer.resolve();
                            })
                            .catch(function (state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    },
                ],
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.case_study.scheme')
        .controller('FormCaseStudySchemeController', FormCaseStudySchemeController);

    /** @ngInject */
    function FormCaseStudySchemeController(
        apiService,
        $mdDialog,
        theme,
        refData,
        dialogType,
        $scope,
        $timeout,
        $q
    ) {
        // data
        var vm = this;
        var CaseStudyScheme = apiService.CaseStudyScheme();
        var CaseStudyQuestion = apiService.CaseStudyQuestion();
        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.theme = theme;
        vm.form = {};
        vm.dialogType = dialogType;
        vm.data = {
            case_study_scheme_question: [],
        };
        vm.listRef = [];
        vm.selectedRef = null;
        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;
        vm.update = update;
        vm.doAdd = doAdd;
        vm.doRemove = doRemove;

        init();

        function init() {
            if (vm.dialogType === 'UPDATE') {
                vm.data.id = refData.id;
                vm.data.name = refData.name;
                vm.data.description = refData.description;
                refData.case_study_scheme_question.map(function (val) {
                    vm.data.case_study_scheme_question.push({
                        id: val.case_study_question.id,
                        name: val.case_study_question.name,
                        description: val.case_study_question.description,
                    });
                });
                loadRef().then(function () {
                    vm.isLoading = false;
                });
            } else {
                vm.data.case_study_scheme_question = [];
                loadRef().then(function () {
                    vm.isLoading = false;
                });
            }
        }

        function setForm(form) {
            vm.form = form;
        }

        function submit(ev, form) {
            var request = CaseStudyScheme.create(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Submitting Request';
            request.$promise.then(function (res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function (err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function update(ev, form) {
            var request = CaseStudyScheme.update(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Updating Request';
            request.$promise.then(function (res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function (err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function () {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function loadRef() {
            var defer = $q.defer();
            var request = CaseStudyQuestion.lists();
            request.$promise.then(function (res) {
                vm.listRef = res;
                defer.resolve(res);
            });
            request.$promise.catch(function (err) {
                vm.listRef = [];
                defer.resolve([]);
            });
            return defer.promise;
        }

        function doAdd(item) {
            var exists = false;
            for (var i = 0; i < vm.data.case_study_scheme_question.length; i++) {
                var el = vm.data.case_study_scheme_question[i];
                if (el.id == item.id) {
                    exists = true;
                    break;
                }
            }
            if (!exists) {
                vm.data.case_study_scheme_question.push(item);
            }
        }

        function doRemove(idx) {
            vm.data.case_study_scheme_question.splice(idx, 1);
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.case_study.question', ['ngFileUpload', 'textAngular'])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.case_study_question', {
            url: '/case_study/question',
            views: {
                'content@app': {
                    templateUrl: 'app/main/case-study/question/question.html',
                    controller: 'CaseStudyQuestionController as vm',
                },
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function ($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.case_study_question')
                            .then(function () {
                                defer.resolve();
                            })
                            .catch(function (state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    },
                ],
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.case_study.question')
        .controller(
            'FormQuestionCaseStudyController',
            FormQuestionCaseStudyController
        );

    /** @ngInject */
    function FormQuestionCaseStudyController(
        apiService,
        $mdDialog,
        theme,
        refData,
        dialogType,
        $timeout,
        $sce,
        $q,
        Upload
    ) {
        // data
        var vm = this;
        var QuestionCaseStudy = apiService.CaseStudyQuestion();
        var Ref = apiService.Reference();

        vm.data = angular.copy(refData);
        vm.dialogType = dialogType;
        vm.isLoading = true;
        vm.isErrorLoad = false;
        vm.message = '';
        vm.media = null;
        vm.form;

        vm.cancel = cancel;
        vm.hide = hide;
        vm.update = updateData;
        vm.create = createData;
        vm.theme = theme;
        vm.setForm = setForm;

        init();

        function init() {
            vm.isLoading = true;
            if (vm.dialogType == 'UPDATE') {
                loadMedia().then(function () {
                    vm.isLoading = false;
                });
            } else {
                vm.isLoading = false;
            }
        }

        function loadMedia() {
            var defer = $q.defer();
            var request = QuestionCaseStudy.loadMedia({
                filename: vm.data.filename,
            });
            request.$promise.then(function (blob) {
                vm.media = blob.data;
                console.log(vm.form);
                defer.resolve(true);
            });
            request.$promise.catch(function (err) {
                vm.isErrorLoad = true;
                defer.resolve(false);
            });
            return defer.promise;
        }

        function createData(ev, form) {
            var checkImages = havingMedia();
            vm.isLoading = true;
            checkImages.then(function (res) {
                var attachment = null;
                if (res.status) {
                    attachment = res.image;
                }
                var payload = {
                    file: attachment,
                    name: vm.data.name,
                    description: vm.data.description,
                };
                console.log(payload);
                var req = QuestionCaseStudy.create(payload);
                req.$promise.then(function (success) {
                    vm.message = 'Success';
                    vm.isLoading = false;
                    hide();
                });
                req.$promise.catch(function (error) {
                    vm.message = 'Failed';
                    vm.isLoading = false;
                });
            });
        }

        function updateData(ev, form) {
            var checkImages = havingMedia();
            vm.isLoading = true;
            checkImages.then(function (res) {
                var attachment = null;
                if (res.status) {
                    attachment = res.image;
                }
                var req = QuestionCaseStudy.update({
                    id: vm.data.id,
                    file: attachment,
                    name: vm.data.name,
                    description: vm.data.description,
                });
                req.$promise.then(function (success) {
                    vm.message = 'Success';
                    vm.isLoading = false;
                    hide();
                });
                req.$promise.catch(function (error) {
                    vm.message = 'Failed';
                    vm.isLoading = false;
                });
            });
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function havingMedia() {
            var defer = $q.defer();
            if (vm.media) {
                Upload.dataUrl(vm.media, true).then(function (url) {
                    defer.resolve({ status: true, image: url });
                });
            } else {
                defer.resolve({ status: false, image: null });
            }
            return defer.promise;
        }

        function setForm(form) {
            vm.form = form;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function() {
    'use strict';

    angular.module('app.utility.menu', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.utility_menu', {
            url: '/utility/menu',
            views: {
                'content@app': {
                    templateUrl: 'app/main/utility/menu/menu.html',
                    controller: 'UtilityMenuController as vm'
                }
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.utility_menu')
                            .then(function() {
                                defer.resolve();
                            })
                            .catch(function(state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    }
                ]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.utility.menu')
        .controller('UtilityMenuController', UtilityMenuController);

    /** @ngInject */
    UtilityMenuController.$inject = [
        'apiService',
        'fuseTheming',
        '$mdDialog',
        '$timeout',
        'blockUI',
        '$mdToast',
        '$state',
        '$q',
        'toastr'
    ];

    function UtilityMenuController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $state,
        $q,
        toastr
    ) {
        var vm = this;
        var Menu = apiService.Menu();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.group = null;
        vm.listGroup = [
            { id: 1, name: 'super admin' },
            { id: 2, name: 'admin' }
        ];
        vm.isLoading = false;
        vm.listMenu = [];
        vm.loadData = loadData;
        vm.switchMenu = switchMenu;
        vm.switchAction = switchAction;

        function loadData() {
            blockView.start({ message: 'Please wait' });
            vm.isLoading = true;
            var request = Menu.view({ group_id: vm.group });
            request.$promise.then(function(res) {
                vm.listMenu = res;
                $timeout(function() {
                    blockView.stop();
                    vm.isLoading = false;
                }, 1000);
            });
            request.$promise.catch(function(res) {
                vm.isLoading = false;
                $timeout(function() {
                    blockView.stop();
                }, 1000);
                vm.listMenu = [];
            });
        }

        function switchMenu(item) {
            blockView.start({ message: 'Please wait' });
            var payload = {
                group_id: vm.group,
                menu_id: item.id,
                is_enable: item.checked
            };
            var request = Menu.switchMenu(payload);
            request.$promise.then(function(res) {
                blockView.stop();
                toastr.success(res.message);
            });
            request.$promise.catch(function(res) {
                blockView.stop();
                toastr.error(res.data.message);
            });
            console.log(payload);
        }

        function switchAction(item) {
            blockView.start({ message: 'Please wait' });
            var payload = {
                group_id: vm.group,
                menu_id: item.menu_id,
                action_id: item.id,
                is_enable: item.checked
            };
            var request = Menu.switchAction(payload);
            request.$promise.then(function(res) {
                blockView.stop();
                toastr.success(res.message);
            });
            request.$promise.catch(function(res) {
                blockView.stop();
                toastr.error(res.data.message);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.survey.scheme')
        .controller('SurveySchemeController', SurveySchemeController);

    /** @ngInject */
    function SurveySchemeController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $state,
        $q
    ) {
        var vm = this;
        var SurveyScheme = apiService.SurveyScheme();
        var Menu = apiService.Menu();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false,
        };
        vm.state = $state.current.name;
        vm.permissionList = [];
        vm.actionPermit = {
            view: false,
            delete: false,
            update: false,
            create: false,
        };

        // method
        vm.onPageChange = onPageChange;
        vm.showDialog = showDialog;
        vm.loadData = loadData;

        activate();

        function activate() {
            loadPermission().then(function () {
                if (vm.actionPermit.view) {
                    loadData(1);
                } else {
                    vm.pagination.is_loading = false;
                }
            });
        }

        function loadPermission() {
            var defer = $q.defer();
            var request = Menu.getPermissionByState({ state: vm.state });
            request.$promise.then(function (res) {
                vm.permissionList = res;
                setPermission(res);
                defer.resolve();
            });
            request.$promise.catch(function (res) {
                vm.permissionList = [];
                defer.reject();
            });
            return defer.promise;
        }

        function setPermission(permission) {
            permission.map(function (val) {
                for (var key in vm.actionPermit) {
                    if (val.actions == key) {
                        vm.actionPermit[key] = val.checked;
                    }
                }
            });
        }

        function loadData(page) {
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var request = SurveyScheme.view({
                page: page,
                page_size: vm.pagination.page_size,
                search: vm.pagination.search,
            });
            request.$promise.then(function (res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function () {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function (res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function deleteAction(ev, item, isSingle) {
            var ref = [];
            if (isSingle) {
                var message = item.name + ' will be deleted, are you sure ?';
                ref.push(item.id);
            } else {
                ref = [];
            }
            deleteDialog(ev, ref, message);
        }

        function deleteRequest(ref) {
            blockView.start({ message: 'Please wait' });
            var request = SurveyScheme.delete({
                ids: ref,
            });
            request.$promise.then(function (res) {
                blockView.stop();
                showToast(res.message);
                loadData(1);
            });
            request.$promise.catch(function (err) {
                blockView.stop();
                showToast(err.data.message);
                loadData(1);
            });
        }

        function showToast(message) {
            $mdToast.show(
                $mdToast.simple().textContent(message).position('top right')
            );
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function showDialog(ev, type, ref, isSingle) {
            switch (type) {
                case 'UPDATE':
                case 'CREATE':
                    formDialog(ev, type, ref);
                    break;
                case 'DELETE':
                    deleteAction(ev, ref, isSingle);
                    break;
            }
        }

        function formDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'FormSurveySchemeController as vm',
                    templateUrl: 'app/main/survey/scheme/form/form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type,
                    },
                })
                .then(
                    function (res) {
                        loadData(1);
                    },
                    function () {
                        // loadData(1);
                    }
                );
        }

        function deleteDialog(ev, ref, message) {
            var confirm = $mdDialog
                .confirm()
                .title('Delete Confirmation')
                .textContent(message)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function () {
                deleteRequest(ref);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.survey.category')
        .controller('SurveyCategoryController', SurveyCategoryController);

    /** @ngInject */
    function SurveyCategoryController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $state,
        $q
    ) {
        var vm = this;
        var SurveyCategory = apiService.SurveyCategory();
        var Menu = apiService.Menu();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.group = 'all';
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false,
        };
        vm.state = $state.current.name;
        vm.permissionList = [];
        vm.actionPermit = {
            view: false,
            delete: false,
            update: false,
            create: false,
        };
        vm.type = 'all';
        vm.listType = ['all', 'normal', 'essay'];

        // method
        vm.onPageChange = onPageChange;
        vm.showDialog = showDialog;
        vm.loadData = loadData;

        activate();

        function activate() {
            loadPermission().then(function () {
                if (vm.actionPermit.view) {
                    loadData(1);
                } else {
                    vm.pagination.is_loading = false;
                }
            });
        }

        function loadPermission() {
            var defer = $q.defer();
            var request = Menu.getPermissionByState({ state: vm.state });
            request.$promise.then(function (res) {
                vm.permissionList = res;
                setPermission(res);
                defer.resolve();
            });
            request.$promise.catch(function (res) {
                vm.permissionList = [];
                defer.reject();
            });
            return defer.promise;
        }

        function setPermission(permission) {
            permission.map(function (val) {
                for (var key in vm.actionPermit) {
                    if (val.actions == key) {
                        vm.actionPermit[key] = val.checked;
                    }
                }
            });
        }

        function loadData(page) {
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var request = SurveyCategory.view({
                page: page,
                type: vm.type,
                page_size: vm.pagination.page_size,
                search: vm.pagination.search,
            });
            request.$promise.then(function (res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function () {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function (res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function deleteAction(ev, item, isSingle) {
            var ref = [];
            if (isSingle) {
                var message = item.name + ' will be deleted, are you sure ?';
                ref.push(item.id);
            } else {
                ref = [];
            }
            deleteDialog(ev, ref, message);
        }

        function deleteRequest(ref) {
            blockView.start({ message: 'Please wait' });
            var request = SurveyCategory.delete({
                ids: ref,
            });
            request.$promise.then(function (res) {
                blockView.stop();
                showToast(res.message);
                loadData(1);
            });
            request.$promise.catch(function (err) {
                blockView.stop();
                showToast(err.data.message);
                loadData(1);
            });
        }

        function showToast(message) {
            $mdToast.show(
                $mdToast.simple().textContent(message).position('top right')
            );
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function showDialog(ev, type, ref, isSingle) {
            switch (type) {
                case 'UPDATE':
                case 'CREATE':
                    formDialog(ev, type, ref);
                    break;
                case 'DELETE':
                    deleteAction(ev, ref, isSingle);
                    break;
            }
        }

        function formDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'FormSurveyCategoryController as vm',
                    templateUrl: 'app/main/survey/category/form/form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type,
                    },
                })
                .then(
                    function (res) {
                        loadData(1);
                    },
                    function () {
                        // loadData(1);
                    }
                );
        }

        function deleteDialog(ev, ref, message) {
            var confirm = $mdDialog
                .confirm()
                .title('Delete Confirmation')
                .textContent(message)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function () {
                deleteRequest(ref);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.survey.question')
        .controller('SurveyQuestionController', SurveyQuestionController);

    /** @ngInject */
    function SurveyQuestionController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $state,
        $q
    ) {
        var vm = this;
        var SurveyQuestion = apiService.SurveyQuestion();
        var Ref = apiService.Reference();
        var Menu = apiService.Menu();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.group = 'all';
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false,
        };
        vm.state = $state.current.name;
        vm.permissionList = [];
        vm.actionPermit = {
            view: false,
            delete: false,
            update: false,
            create: false,
        };
        vm.category = 'all';
        vm.listCategory = [];
        vm.type = 'all';
        vm.listType = ['all', 'normal', 'essay'];

        // method
        vm.onPageChange = onPageChange;
        vm.showDialog = showDialog;
        vm.loadData = loadData;

        activate();

        function activate() {
            loadPermission().then(function () {
                if (vm.actionPermit.view) {
                    loadSurveyCategory().then(loadData.bind(this, 1));
                } else {
                    vm.pagination.is_loading = false;
                }
            });
        }

        function loadPermission() {
            var defer = $q.defer();
            var request = Menu.getPermissionByState({ state: vm.state });
            request.$promise.then(function (res) {
                vm.permissionList = res;
                setPermission(res);
                defer.resolve();
            });
            request.$promise.catch(function (res) {
                vm.permissionList = [];
                defer.reject();
            });
            return defer.promise;
        }

        function setPermission(permission) {
            permission.map(function (val) {
                for (var key in vm.actionPermit) {
                    if (val.actions == key) {
                        vm.actionPermit[key] = val.checked;
                    }
                }
            });
        }

        function loadData(page) {
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var request = SurveyQuestion.view({
                page: page,
                page_size: vm.pagination.page_size,
                category_id: vm.category,
                type: vm.type,
                search: vm.pagination.search,
            });
            request.$promise.then(function (res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function () {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function (res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function deleteAction(ev, item, isSingle) {
            var ref = [];
            if (isSingle) {
                var message = item.name + ' will be deleted, are you sure ?';
                ref.push(item.id);
            } else {
                ref = [];
            }
            deleteDialog(ev, ref, message);
        }

        function deleteRequest(ref) {
            blockView.start({ message: 'Please wait' });
            var request = SurveyQuestion.delete({
                ids: ref,
            });
            request.$promise.then(function (res) {
                blockView.stop();
                showToast(res.message);
                loadData(1);
            });
            request.$promise.catch(function (err) {
                blockView.stop();
                showToast(err.data.message);
                loadData(1);
            });
        }

        function showToast(message) {
            $mdToast.show(
                $mdToast.simple().textContent(message).position('top right')
            );
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function showDialog(ev, type, ref, isSingle) {
            switch (type) {
                case 'UPDATE':
                case 'CREATE':
                    formDialog(ev, type, ref);
                    break;
                case 'DELETE':
                    deleteAction(ev, ref, isSingle);
                    break;
            }
        }

        function formDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'FormSurveyQuestionController as vm',
                    templateUrl: 'app/main/survey/question/form/form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type,
                    },
                })
                .then(
                    function (res) {
                        loadData(1);
                    },
                    function () {
                        // loadData(1);
                    }
                );
        }

        function deleteDialog(ev, ref, message) {
            var confirm = $mdDialog
                .confirm()
                .title('Delete Confirmation')
                .textContent(message)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function () {
                deleteRequest(ref);
            });
        }

        function loadSurveyCategory() {
            var defer = $q.defer();
            var request = Ref.surveyCategory({ has_all: true });
            request.$promise.then(function (res) {
                vm.listCategory = res;
                defer.resolve(res);
            });
            request.$promise.catch(function (err) {
                vm.listCategory = [];
                defer.resolve([]);
            });
            return defer.promise;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.session', ['ngFileUpload']).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.session', {
            url: '/session',
            views: {
                'content@app': {
                    templateUrl: 'app/main/session/session.html',
                    controller: 'SessionController as vm'
                }
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.session')
                            .then(function() {
                                defer.resolve();
                            })
                            .catch(function(state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    }
                ]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.session')
        .controller('UploadSessionController', UploadSessionController);

    /** @ngInject */
    function UploadSessionController(
        apiService,
        $mdDialog,
        theme,
        $scope,
        $timeout,
        $q,
        $location,
        authService,
        appConfig,
        $window
    ) {
        // data
        var vm = this;
        var Session = apiService.Session();

        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.theme = theme;
        vm.isErrorUpload = false;
        vm.validationLog = [];
        vm.file;
        vm.numPages = numPages;
        vm.filtered = [];
        vm.currentPage = 1;
        vm.numPerPage = 10;
        vm.totalItems = vm.validationLog.length;

        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;
        vm.downloadTemplate = downloadTemplate;

        init();

        function init() {
            $scope.$watch('vm.currentPage + vm.numPerPage', function() {
                var begin = (vm.currentPage - 1) * vm.numPerPage;
                var end = begin + vm.numPerPage;
                vm.filtered = vm.validationLog.slice(begin, end);
            });
            $timeout(function() {
                vm.isLoading = false;
            }, 1000);
        }

        function submit(ev, form) {
            vm.isLoading = true;
            vm.loadingMessage = 'Uploading Request, Please Wait';
            var fd = new FormData();
            fd.append('file', vm.file);
            var request = Session.upload({}, fd);
            request.$promise.then(function(res) {
                vm.isLoading = false;
                vm.isErrorUpload = false;
                vm.validationLog = res.data;
                vm.totalItems = vm.validationLog.length;
                vm.currentPage = 1;
                $scope.$watch('vm.currentPage + vm.numPerPage', function() {
                    var begin = (vm.currentPage - 1) * vm.numPerPage;
                    var end = begin + vm.numPerPage;
                    vm.filtered = vm.validationLog.slice(begin, end);
                });
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                vm.isLoading = false;
                vm.validationLog = err.data.errors;
                vm.isErrorUpload = true;
                showDialog(ev, false, err.data);
            });
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function() {
                    if (status) {
                        // hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function downloadTemplate() {
            var protocol = $location.protocol();
            var host = $location.host();
            var url =
                appConfig.apiUrl +
                'session/downloadTemplate?token=' +
                authService.getToken();

            $window.open(protocol + '://' + host + url, '_blank');
        }

        function numPages() {
            return Math.ceil(vm.validationLog.length / vm.numPerPage);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report.general', ['app.report.general.detail'])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.report_general', {
            url: '/report/general',
            views: {
                'content@app': {
                    templateUrl: 'app/main/report/general/general.html',
                    controller: 'ReportGeneralController as vm',
                },
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function ($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.report_general')
                            .then(function () {
                                defer.resolve();
                            })
                            .catch(function (state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    },
                ],
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report.general')
        .controller('ReportGeneralController', ReportGeneralController);

    /** @ngInject */
    function ReportGeneralController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $q,
        $window,
        appConfig,
        authService,
        $location,
        $state
    ) {
        var vm = this;
        var Report = apiService.Report();
        var Ref = apiService.Reference();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.groupParticipant = 'all';
        vm.tempStart = new Date();
        vm.tempEnd = new Date();
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false,
        };

        // method
        vm.onPageChange = onPageChange;
        vm.loadData = loadData;
        vm.exportData = exportData;
        vm.goToDetail = goToDetail;

        activate();

        function activate() {
            vm.pagination.is_loading = true;
            loadData(1);
        }

        function loadData(page) {
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var startDate = angular.copy(vm.tempStart);
            var endDate = angular.copy(vm.tempEnd);
            var request = Report.view({
                type: 'general',
                page: page,
                page_size: vm.pagination.page_size,
                start_date: moment(startDate).format('YYYY-MM-DD'),
                end_date: moment(endDate).format('YYYY-MM-DD'),
                search: vm.pagination.search,
            });
            request.$promise.then(function (res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function () {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function (res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function goToDetail(item) {
            $state.go('app.report_general_detail', { achievement_id: item.id });
        }

        function exportData() {
            var tmpStart = angular.copy(vm.tempStart);
            var tmpEnd = angular.copy(vm.tempEnd);
            var startDate = moment(tmpStart).format('YYYY-MM-DD');
            var endDate = moment(tmpEnd).format('YYYY-MM-DD');
            var protocol = $location.protocol();
            var host = $location.host();
            var url =
                appConfig.apiUrl +
                'report/export?type=general&start_date=' +
                startDate +
                '&end_date=' +
                endDate +
                '&token=' +
                authService.getToken();

            $window.open(protocol + '://' + host + url, '_blank');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.session')
        .controller('FormSessionController', FormSessionController);

    /** @ngInject */
    function FormSessionController(
        apiService,
        $mdDialog,
        theme,
        refData,
        dialogType,
        $scope,
        $timeout,
        $q,
        $document
    ) {
        // data
        var vm = this;
        var Session = apiService.Session();
        var Ref = apiService.Reference();
        vm.isLoading = true;
        vm.isPreparingSessionType = false;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.theme = theme;
        vm.form = {};
        vm.dialogType = dialogType;
        vm.data = {
            ref_id: 0,
            session_type: '',
            session_order: 1,
            session_duration: 120,
            question_limit: 0,
            send_mail: 0,
            users: [],
        };
        vm.sessionType = ['general', 'tiki', 'papikostik', 'case_study', 'survey'];
        vm.questionPool = [];
        vm.listRef = [];
        vm.guides = [];
        vm.searchText = '';
        vm.ref = {};
        vm.refTitle = '';
        vm.showEntity = {
            survey: false,
            case_study: false,
            duration: false,
            question_limit: false,
        };

        // initialize date and time
        vm.tmpStartDate, vm.tmpEndDate, vm.tmpStartTime, vm.tmpEndTime;

        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;
        vm.update = update;
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.getItemText = getItemText;
        vm.removeUsers = removeUsers;
        vm.loadQuestionPool = loadQuestionPool;
        vm.loadSurveyScheme = loadSurveyScheme;
        vm.onChangeSessionType = onChangeSessionType;

        init();

        function init() {
            if (vm.dialogType === 'UPDATE') {
                var temp = angular.copy(refData);
                loadQuestionPool(temp.session_type)
                    .then(setValueUpdate.bind(this, temp))
                    .then(switchStateSessionType);
            }

            loadGuides()
                .then(function () {
                    vm.errorMessage = '';
                    vm.isLoading = false;
                })
                .catch(function (err) {
                    vm.errorMessage = err;
                });
        }

        function setValueUpdate(data) {
            var defer = $q.defer();
            vm.data.id = data.id;
            vm.data.guides_id = data.guides_id;
            vm.data.question_limit = data.question_limit;
            vm.data.question_pool_id = data.question_pool_id;
            vm.data.session_type = data.session_type;
            vm.data.session_order = data.session_order;
            vm.data.session_duration = data.session_duration;
            vm.data.user = data.user;
            vm.data.ref_id = data.ref_id;
            vm.tmpStartDate = new Date(data.session_start_date);
            vm.tmpEndDate = new Date(data.session_end_date);
            vm.tmpStartTime = new Date(
                data.session_end_date + ' ' + data.session_start_time
            );
            vm.tmpEndTime = new Date(
                data.session_end_date + ' ' + data.session_end_time
            );
            $timeout(function () {
                defer.resolve(true);
            }, 800);
            return defer.promise;
        }

        function submit(ev, form) {
            buildPayload(form);
            console.log(vm.data);
            var request = Session.create(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Submitting Request';
            request.$promise.then(function (res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function (err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function update(ev, form) {
            buildPayload(form);
            var request = Session.update(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Updating Request';
            request.$promise.then(function (res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function (err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function buildPayload(form) {
            vm.data.session_start_date = form.session_start_date.$viewValue;
            vm.data.session_end_date = form.session_end_date.$viewValue;
            vm.data.session_start_time = form.session_start_time.$viewValue + ':00';
            vm.data.session_end_time = form.session_end_time.$viewValue + ':00';
        }

        function setForm(form) {
            vm.form = form;
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element($document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function () {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function selectedItemChange(item) {
            if (item) {
                vm.data.users.push(item);
                vm.user = undefined;
                vm.searchText = '';
            }
        }

        function removeUsers(idx) {
            vm.data.users.splice(idx, 1);
        }

        function querySearch(query) {
            var request = Ref.users({ search: query });
            return request.$promise.then(function (response) {
                return response;
            });
        }

        function getItemText(item) {
            return item.nik + ' - ' + item.name;
        }

        function loadQuestionPool(type) {
            var defer = $q.defer();
            var request = Ref.questionPool({ has_all: false, type: type });
            request.$promise.then(function (res) {
                vm.questionPool = res;
                defer.resolve();
            });
            request.$promise.catch(function () {
                vm.questionPool = [];
                defer.resolve('FAILED LOAD QUESTION POOL');
            });
            return defer.promise;
        }

        function loadGuides() {
            var defer = $q.defer();
            var request = Ref.guides({ has_all: false });
            request.$promise.then(function (res) {
                vm.guides = res;
                defer.resolve();
            });
            request.$promise.catch(function () {
                vm.guides = [];
                defer.resolve('FAILED LOAD GUIDES');
            });
            return defer.promise;
        }

        function loadSurveyScheme() {
            var defer = $q.defer();
            var request = Ref.surveyScheme();
            request.$promise.then(function (res) {
                vm.listRef = res;
                defer.resolve();
            });
            request.$promise.catch(function () {
                vm.listRef = [];
                defer.resolve('FAILED LOAD SURVEY SCHEMES');
            });
            return defer.promise;
        }

        function loadCaseStudyScheme() {
            var defer = $q.defer();
            var request = Ref.caseStudyScheme();
            request.$promise.then(function (res) {
                vm.listRef = res;
                defer.resolve();
            });
            request.$promise.catch(function () {
                vm.listRef = [];
                defer.resolve('FAILED LOAD SURVEY SCHEMES');
            });
            return defer.promise;
        }

        function onChangeSessionType() {
            vm.isLoading = true;
            loadQuestionPool(vm.data.session_type)
                .then(switchStateSessionType)
                .then(function () {
                    vm.isLoading = false;
                });
        }

        function switchStateSessionType() {
            var defer = $q.defer();

            if (vm.questionPool.length > 0) {
                vm.data.question_pool_id = vm.questionPool[0].id;
            }

            // set reference null
            switch (vm.data.session_type) {
                case 'general':
                    vm.showEntity.case_study = false;
                    vm.showEntity.survey = false;
                    vm.showEntity.duration = true;
                    vm.showEntity.question_limit = true;
                    $timeout(function () {
                        defer.resolve(true);
                    }, 800);
                    break;
                case 'tiki':
                    vm.showEntity.case_study = false;
                    vm.showEntity.survey = false;
                    vm.showEntity.duration = false;
                    vm.showEntity.question_limit = false;
                    $timeout(function () {
                        defer.resolve(true);
                    }, 800);
                    break;
                case 'papikostik':
                    vm.showEntity.case_study = false;
                    vm.showEntity.survey = false;
                    vm.showEntity.duration = true;
                    vm.showEntity.question_limit = false;
                    $timeout(function () {
                        defer.resolve(true);
                    }, 800);
                    break;
                case 'case_study':
                    vm.showEntity.case_study = true;
                    vm.showEntity.survey = false;
                    vm.showEntity.duration = true;
                    vm.showEntity.question_limit = false;
                    vm.refTitle = 'Case Study Schemes';
                    loadCaseStudyScheme().then(function () {
                        defer.resolve(true);
                    });
                    break;
                case 'survey':
                    vm.showEntity.case_study = false;
                    vm.showEntity.survey = true;
                    vm.showEntity.duration = true;
                    vm.showEntity.question_limit = false;
                    vm.refTitle = 'Survey Schemes';
                    loadSurveyScheme().then(function () {
                        defer.resolve(true);
                    });
                    break;
                default:
                    vm.showEntity.case_study = false;
                    vm.showEntity.survey = false;
                    vm.showEntity.duration = true;
                    vm.showEntity.question_limit = true;
                    $timeout(function () {
                        defer.resolve(true);
                    }, 800);
                    break;
            }
            return defer.promise;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report.survey')
        .controller('ReportSurveyController', ReportSurveyController);

    /** @ngInject */
    function ReportSurveyController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $q,
        $window,
        appConfig,
        authService,
        $location,
        $state
    ) {
        var vm = this;
        var blockView = blockUI.instances.get('block-content');
        var Report = apiService.Report();
        vm.themes = fuseTheming.themes;
        vm.startDate = new Date();
        vm.endDate = new Date();
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: null,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false,
        };

        // method
        vm.onPageChange = onPageChange;
        vm.loadData = loadData;
        vm.exportData = exportData;
        vm.viewDetail = viewDetail;

        activate();

        function activate() {
            vm.pagination.is_loading = true;
            loadData(1);
        }

        function loadData(page) {
            blockView.start({ message: 'please wait' });
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var startDate = angular.copy(vm.startDate);
            var endDate = angular.copy(vm.endDate);
            var request = Report.view({
                type: 'survey',
                page: page,
                page_size: vm.pagination.page_size,
                start_date: moment(startDate).format('YYYY-MM-DD'),
                end_date: moment(endDate).format('YYYY-MM-DD'),
                search: vm.pagination.search,
            });
            request.$promise.then(function (res) {
                blockView.stop();
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function () {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function (res) {
                blockView.stop();
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function exportData() {
            var startDate = angular.copy(vm.startDate);
            var endDate = angular.copy(vm.startDate);
            var protocol = $location.protocol();
            var host = $location.host();
            var url =
                appConfig.apiUrl +
                'report/export?type=survey&start_date=' +
                moment(startDate).format('YYYY-MM-DD') +
                '&end_date=' +
                moment(endDate).format('YYYY-MM-DD') +
                '&token=' +
                authService.getToken();

            $window.open(protocol + '://' + host + url, '_blank');
        }

        function viewDetail(ev, ref) {
            $mdDialog
                .show({
                    controller: 'ReportDetailSurveyController as vm',
                    templateUrl: 'app/main/report/survey/view/view.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                    },
                })
                .then(
                    function (res) {
                        loadData(1);
                    },
                    function () {
                        // loadData(1);
                    }
                );
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.report.tiki', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.report_tiki', {
            url: '/report-tiki',
            views: {
                'content@app': {
                    templateUrl: 'app/main/report/tiki/tiki.html',
                    controller: 'ReportTikiController as vm',
                },
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function ($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.report_tiki')
                            .then(function () {
                                defer.resolve();
                            })
                            .catch(function (state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    },
                ],
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report.tiki')
        .controller('ReportTikiController', ReportTikiController);

    /** @ngInject */
    function ReportTikiController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $q,
        $window,
        appConfig,
        authService,
        $location,
        $state
    ) {
        var vm = this;
        var Report = apiService.Report();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.groupParticipant = 'all';
        vm.tempDate = new Date();
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false,
        };

        // method
        vm.onPageChange = onPageChange;
        vm.loadData = loadData;
        vm.exportData = exportData;

        activate();

        function activate() {
            vm.pagination.is_loading = true;
            loadData(1);
        }

        function loadData(page) {
            blockView.start({ message: 'please wait' });
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var tempDate = angular.copy(vm.tempDate);
            var request = Report.view({
                type: 'tiki',
                page: page,
                page_size: vm.pagination.page_size,
                start_date: moment(tempDate).format('YYYY-MM-DD'),
                end_date: moment(tempDate).format('YYYY-MM-DD'),
                search: vm.pagination.search,
            });
            request.$promise.then(function (res) {
                blockView.stop();
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function () {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function (res) {
                blockView.stop();
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function exportData() {
            var tempDate = angular.copy(vm.tempDate);
            var date = moment(tempDate).format('YYYY-MM-DD');
            var protocol = $location.protocol();
            var host = $location.host();
            var url =
                appConfig.apiUrl +
                'report/export?type=tiki&start_date=' +
                date +
                '&end_date=' +
                date +
                '&token=' +
                authService.getToken();

            $window.open(protocol + '://' + host + url, '_blank');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report.papikostik')
        .controller('ReportPapikostikController', ReportPapikostikController);

    /** @ngInject */
    function ReportPapikostikController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $q,
        $window,
        appConfig,
        authService,
        $location,
        $state
    ) {
        var vm = this;
        var blockView = blockUI.instances.get('block-content');
        var Report = apiService.Report();
        vm.themes = fuseTheming.themes;
        vm.startDate = new Date();
        vm.endDate = new Date();
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: null,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false,
        };

        // method
        vm.onPageChange = onPageChange;
        vm.loadData = loadData;
        vm.exportData = exportData;
        vm.viewDetail = viewDetail;

        activate();

        function activate() {
            vm.pagination.is_loading = true;
            loadData(1);
        }

        function loadData(page) {
            blockView.start({ message: 'please wait' });
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var startDate = angular.copy(vm.startDate);
            var endDate = angular.copy(vm.endDate);
            var request = Report.view({
                type: 'papikostik',
                page: page,
                page_size: vm.pagination.page_size,
                start_date: moment(startDate).format('YYYY-MM-DD'),
                end_date: moment(endDate).format('YYYY-MM-DD'),
                search: vm.pagination.search,
            });
            request.$promise.then(function (res) {
                blockView.stop();
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function () {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function (res) {
                blockView.stop();
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function exportData() {
            var startDate = angular.copy(vm.startDate);
            var endDate = angular.copy(vm.startDate);
            var protocol = $location.protocol();
            var host = $location.host();
            var url =
                appConfig.apiUrl +
                'report/export?type=papikostik&start_date=' +
                moment(startDate).format('YYYY-MM-DD') +
                '&end_date=' +
                moment(endDate).format('YYYY-MM-DD') +
                '&token=' +
                authService.getToken();

            $window.open(protocol + '://' + host + url, '_blank');
        }

        function viewDetail(ev, ref) {
            $mdDialog
                .show({
                    controller: 'ReportViewDetailPapikostikController as vm',
                    templateUrl:
                        'app/main/report/papikostik/view-detail/view-detail-papikostik.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                    },
                })
                .then(
                    function (res) {
                        loadData(1);
                    },
                    function () {
                        // loadData(1);
                    }
                );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report.case_study')
        .controller('ReportCaseStudyController', ReportCaseStudyController);

    /** @ngInject */
    function ReportCaseStudyController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $q,
        $window,
        appConfig,
        authService,
        $location,
        $state
    ) {
        var vm = this;
        var blockView = blockUI.instances.get('block-content');
        var Report = apiService.Report();
        vm.themes = fuseTheming.themes;
        vm.startDate = new Date();
        vm.endDate = new Date();
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: null,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false,
        };

        // method
        vm.onPageChange = onPageChange;
        vm.loadData = loadData;
        vm.exportData = exportData;
        vm.viewDetail = viewDetail;

        activate();

        function activate() {
            vm.pagination.is_loading = true;
            loadData(1);
        }

        function loadData(page) {
            blockView.start({ message: 'please wait' });
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var startDate = angular.copy(vm.startDate);
            var endDate = angular.copy(vm.endDate);
            var request = Report.view({
                type: 'case_study',
                page: page,
                page_size: vm.pagination.page_size,
                start_date: moment(startDate).format('YYYY-MM-DD'),
                end_date: moment(endDate).format('YYYY-MM-DD'),
                search: vm.pagination.search,
            });
            request.$promise.then(function (res) {
                blockView.stop();
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function () {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function (res) {
                blockView.stop();
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function exportData() {
            var startDate = angular.copy(vm.startDate);
            var endDate = angular.copy(vm.startDate);
            var protocol = $location.protocol();
            var host = $location.host();
            var url =
                appConfig.apiUrl +
                'report/export?type=case_study&start_date=' +
                moment(startDate).format('YYYY-MM-DD') +
                '&end_date=' +
                moment(endDate).format('YYYY-MM-DD') +
                '&token=' +
                authService.getToken();

            $window.open(protocol + '://' + host + url, '_blank');
        }

        function viewDetail(ev, ref) {
            $mdDialog
                .show({
                    controller: 'ReportDetailCaseStudyController as vm',
                    templateUrl: 'app/main/report/case-study/view/view.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                    },
                })
                .then(
                    function (res) {
                        loadData(1);
                    },
                    function () {
                        // loadData(1);
                    }
                );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.questions_tiki', ['ngFileUpload', 'textAngular'])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.qa_questions_tiki', {
            url: '/qa/questions_tiki',
            views: {
                'content@app': {
                    templateUrl: 'app/main/qa/qa-tiki/qa-tiki.html',
                    controller: 'QaTikiController as vm'
                }
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.qa_questions_tiki')
                            .then(function() {
                                defer.resolve();
                            })
                            .catch(function(state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    }
                ]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.questions_tiki')
        .controller('QaTikiController', QaTikiController);

    /** @ngInject */
    function QaTikiController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $q,
        $sce,
        $state
    ) {
        var vm = this;
        var QuestionTiki = apiService.QuestionTiki();
        var Ref = apiService.Reference();
        var Menu = apiService.Menu();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.section = 'all';
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false
        };
        vm.state = $state.current.name;
        vm.permissionList = [];
        vm.actionPermit = {
            view: false,
            delete: false,
            update: false,
            changePassword: false,
            upload: false,
            create: false
        };

        // method
        vm.onPageChange = onPageChange;
        vm.showDialog = showDialog;
        vm.loadData = loadData;
        vm.getQuestionImages = getQuestionImages;
        vm.getQuestion = getQuestion;
        vm.uploadDialog = uploadDialog;
        vm.getAbjact = getAbjact;

        activate();

        function activate() {
            loadPermission().then(function() {
                if (vm.actionPermit.view) {
                   loadTikiSections().then(loadData(1));
                } else {
                    vm.pagination.is_loading = false;
                }
            });
        }

        function loadPermission() {
            var defer = $q.defer();
            var request = Menu.getPermissionByState({ state: vm.state });
            request.$promise.then(function(res) {
                vm.permissionList = res;
                setPermission(res);
                defer.resolve();
            });
            request.$promise.catch(function(res) {
                vm.permissionList = [];
                defer.reject();
            });
            return defer.promise;
        }

        function setPermission(permission) {
            permission.map(function(val) {
                for (var key in vm.actionPermit) {
                    if (val.actions == key) {
                        vm.actionPermit[key] = val.checked;
                    }
                }
            });
        }

        function loadData(page) {
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var request = QuestionTiki.view({
                page: page,
                section_id: null,
                page_size: vm.pagination.page_size,
                search: vm.pagination.search
            });
            request.$promise.then(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function() {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function loadTikiSections() {
            var defer = $q.defer();
            var request = Ref.tikiSections({ has_all: true });
            request.$promise.then(function(data) {
                defer.resolve(data);
                vm.listSections = data;
            });
            request.$promise.catch(function(data) {
                defer.resolve([]);
                vm.listSections = [];
            });
            return defer.promise;
        }

        function deleteAction(ev, item, isSingle) {
            var ref = [];
            if (isSingle) {
                var message = item.code + ' will be deleted, are you sure ?';
                ref.push(item.question_id);
            } else {
                ref = [];
            }
            deleteDialog(ev, ref, message);
        }

        function deleteRequest(ref) {
            blockView.start({ message: 'Please wait' });
            var request = QuestionGeneral.delete({
                ids: ref
            });
            request.$promise.then(function(res) {
                blockView.stop();
                showToast(res.message);
                loadData(1);
            });
            request.$promise.catch(function(err) {
                blockView.stop();
                showToast(err.data.message);
                loadData(1);
            });
        }

        function showToast(message) {
            $mdToast.show(
                $mdToast
                    .simple()
                    .textContent(message)
                    .position('top right')
            );
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function showDialog(ev, type, ref, isSingle) {
            switch (type) {
                case 'UPDATE':
                case 'CREATE':
                    formDialog(ev, type, ref);
                    break;
                case 'DELETE':
                    deleteAction(ev, ref, isSingle);
                    break;
            }
        }

        function formDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'FormQaGeneralController as vm',
                    templateUrl: 'app/main/qa/qa-general/form/form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type
                    }
                })
                .then(
                    function(res) {
                        loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function uploadDialog(ev) {
            $mdDialog
                .show({
                    controller: 'QuestionUploadController as vm',
                    templateUrl: 'app/main/qa/qa-general/upload/upload.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name
                    }
                })
                .then(
                    function(res) {
                        loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function deleteDialog(ev, ref, message) {
            var confirm = $mdDialog
                .confirm()
                .title('Delete Confirmation')
                .textContent(message)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function() {
                deleteRequest(ref);
            });
        }

        function getQuestionImages(path, item) {
            var request = QuestionGeneral.images({ path: path });
            request.$promise.then(function(images) {
                var fileURL = URL.createObjectURL(images.data);
                item.question_image = fileURL;
            });
            request.$promise.catch(function(images) {
                item.question_image = 'assets/images/loader.svg';
            });
        }

        function getQuestion(question) {
            return $sce.trustAsHtml(question);
        }

        function getAbjact(idx) {
            var abjacts = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
            return abjacts[idx];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.questions_papikostik')
        .controller('QaPapikostikController', QaPapikostikController);

    /** @ngInject */
    function QaPapikostikController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $q,
        $sce,
        $state
    ) {
        var vm = this;
        var QuestionPapikostik = apiService.QuestionPapikostik();
        var Ref = apiService.Reference();
        var Menu = apiService.Menu();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.questionPool = 'all';
        vm.questionCategory = 'all';
        vm.competency = 'all';
        vm.listQuestionPool = [];
        vm.listQuestionCategory = [];
        vm.listCompetency = [];
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false
        };
        vm.state = $state.current.name;
        vm.permissionList = [];
        vm.actionPermit = {
            view: false,
            delete: false,
            update: false,
            changePassword: false,
            upload: false,
            create: false
        };

        // method
        vm.onPageChange = onPageChange;
        vm.showDialog = showDialog;
        vm.loadData = loadData;
        vm.uploadDialog = uploadDialog;

        activate();

        function activate() {
            loadPermission().then(function() {
                if (vm.actionPermit.view) {
                    loadData(1);
                } else {
                    vm.pagination.is_loading = false;
                }
            });
        }

        function loadPermission() {
            var defer = $q.defer();
            var request = Menu.getPermissionByState({ state: vm.state });
            request.$promise.then(function(res) {
                vm.permissionList = res;
                setPermission(res);
                defer.resolve();
            });
            request.$promise.catch(function(res) {
                vm.permissionList = [];
                defer.reject();
            });
            return defer.promise;
        }

        function setPermission(permission) {
            permission.map(function(val) {
                for (var key in vm.actionPermit) {
                    if (val.actions == key) {
                        vm.actionPermit[key] = val.checked;
                    }
                }
            });
        }

        function loadData(page) {
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var request = QuestionPapikostik.view({
                page: page,
                page_size: vm.pagination.page_size,
                search: vm.pagination.search
            });
            request.$promise.then(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function() {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function deleteAction(ev, item, isSingle) {
            var ref = [];
            if (isSingle) {
                var message = item.code + ' will be deleted, are you sure ?';
                ref.push(item.question_id);
            } else {
                ref = [];
            }
            deleteDialog(ev, ref, message);
        }

        function deleteRequest(ref) {
            blockView.start({ message: 'Please wait' });
            var request = QuestionGeneral.delete({
                ids: ref
            });
            request.$promise.then(function(res) {
                blockView.stop();
                showToast(res.message);
                loadData(1);
            });
            request.$promise.catch(function(err) {
                blockView.stop();
                showToast(err.data.message);
                loadData(1);
            });
        }

        function showToast(message) {
            $mdToast.show(
                $mdToast
                    .simple()
                    .textContent(message)
                    .position('top right')
            );
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function showDialog(ev, type, ref, isSingle) {
            switch (type) {
                case 'UPDATE':
                case 'CREATE':
                    formDialog(ev, type, ref);
                    break;
                case 'DELETE':
                    deleteAction(ev, ref, isSingle);
                    break;
            }
        }

        function formDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'FormQaPapikostikController as vm',
                    templateUrl: 'app/main/qa/qa-papikostik/form/form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type
                    }
                })
                .then(
                    function(res) {
                        loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function uploadDialog(ev) {
            $mdDialog
                .show({
                    controller: 'QuestionUploadController as vm',
                    templateUrl: 'app/main/qa/qa-general/upload/upload.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name
                    }
                })
                .then(
                    function(res) {
                        loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function deleteDialog(ev, ref, message) {
            var confirm = $mdDialog
                .confirm()
                .title('Delete Confirmation')
                .textContent(message)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function() {
                deleteRequest(ref);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.competency')
        .controller('QaCompetencyController', QaCompetencyController);

    /** @ngInject */
    function QaCompetencyController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $state,
        $q
    ) {
        var vm = this;
        var Competency = apiService.Competency();
        var Menu = apiService.Menu();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.group = 'all';
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false
        };
        vm.state = $state.current.name;
        vm.permissionList = [];
        vm.actionPermit = {
            view: false,
            delete: false,
            update: false,
            create: false
        };

        // method
        vm.onPageChange = onPageChange;
        vm.showDialog = showDialog;
        vm.loadData = loadData;

        activate();

        function activate() {
            loadPermission().then(function() {
                if (vm.actionPermit.view) {
                    loadData(1);
                } else {
                    vm.pagination.is_loading = false;
                }
            });
        }

        function loadPermission() {
            var defer = $q.defer();
            var request = Menu.getPermissionByState({ state: vm.state });
            request.$promise.then(function(res) {
                vm.permissionList = res;
                setPermission(res);
                defer.resolve();
            });
            request.$promise.catch(function(res) {
                vm.permissionList = [];
                defer.reject();
            });
            return defer.promise;
        }

        function setPermission(permission) {
            permission.map(function(val) {
                for (var key in vm.actionPermit) {
                    if (val.actions == key) {
                        vm.actionPermit[key] = val.checked;
                    }
                }
            });
        }

        function loadData(page) {
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var request = Competency.view({
                page: page,
                page_size: vm.pagination.page_size,
                group: vm.group,
                search: vm.pagination.search
            });
            request.$promise.then(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function() {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function deleteAction(ev, item, isSingle) {
            var ref = [];
            if (isSingle) {
                var message = item.name + ' will be deleted, are you sure ?';
                ref.push(item.id);
            } else {
                ref = [];
            }
            deleteDialog(ev, ref, message);
        }

        function deleteRequest(ref) {
            blockView.start({ message: 'Please wait' });
            var request = Competency.delete({
                ids: ref
            });
            request.$promise.then(function(res) {
                blockView.stop();
                showToast(res.message);
                loadData(1);
            });
            request.$promise.catch(function(err) {
                blockView.stop();
                showToast(err.data.message);
                loadData(1);
            });
        }

        function showToast(message) {
            $mdToast.show(
                $mdToast
                    .simple()
                    .textContent(message)
                    .position('top right')
            );
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function showDialog(ev, type, ref, isSingle) {
            switch (type) {
                case 'UPDATE':
                case 'CREATE':
                    formDialog(ev, type, ref);
                    break;
                case 'DELETE':
                    deleteAction(ev, ref, isSingle);
                    break;
            }
        }

        function formDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'FormCompetencyController as vm',
                    templateUrl: 'app/main/qa/competency/form/form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type
                    }
                })
                .then(
                    function(res) {
                        loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function deleteDialog(ev, ref, message) {
            var confirm = $mdDialog
                .confirm()
                .title('Delete Confirmation')
                .textContent(message)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function() {
                deleteRequest(ref);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.questions_general')
        .controller('QaGeneralController', QaGeneralController);

    /** @ngInject */
    function QaGeneralController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $q,
        $sce,
        $state
    ) {
        var vm = this;
        var QuestionGeneral = apiService.QuestionGeneral();
        var Ref = apiService.Reference();
        var Menu = apiService.Menu();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.questionPool = 'all';
        vm.questionCategory = 'all';
        vm.competency = 'all';
        vm.listQuestionPool = [];
        vm.listQuestionCategory = [];
        vm.listCompetencies = [];
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false
        };
        vm.state = $state.current.name;
        vm.permissionList = [];
        vm.actionPermit = {
            view: false,
            delete: false,
            update: false,
            changePassword: false,
            upload: false,
            create: false
        };

        // method
        vm.onPageChange = onPageChange;
        vm.showDialog = showDialog;
        vm.loadData = loadData;
        vm.getQuestionImages = getQuestionImages;
        vm.getQuestion = getQuestion;
        vm.uploadDialog = uploadDialog;

        activate();

        function activate() {
            loadPermission().then(function() {
                if (vm.actionPermit.view) {
                    initFilter().then(loadData(1));
                } else {
                    vm.pagination.is_loading = false;
                }
            });
        }

        function loadPermission() {
            var defer = $q.defer();
            var request = Menu.getPermissionByState({ state: vm.state });
            request.$promise.then(function(res) {
                vm.permissionList = res;
                setPermission(res);
                defer.resolve();
            });
            request.$promise.catch(function(res) {
                vm.permissionList = [];
                defer.reject();
            });
            return defer.promise;
        }

        function setPermission(permission) {
            permission.map(function(val) {
                for (var key in vm.actionPermit) {
                    if (val.actions == key) {
                        vm.actionPermit[key] = val.checked;
                    }
                }
            });
        }

        function loadData(page) {
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var request = QuestionGeneral.view({
                page: page,
                category_id: vm.questionCategory,
                competency_id: vm.competency,
                pool_id: vm.questionPool,
                page_size: vm.pagination.page_size,
                search: vm.pagination.search
            });
            request.$promise.then(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function() {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function initFilter() {
            var defer = $q.defer();
            blockView.start({ message: 'Initializing filter' });
            loadQuestionCategory()
                .then(setQuestionCategory)
                .then(loadQuestionPool)
                .then(setQuestionPool)
                .then(loadCompetencies)
                .then(setCompetencies)
                .finally(function() {
                    blockView.stop();
                    defer.resolve(true);
                });

            return defer.promise;
        }

        function loadQuestionPool() {
            var request = Ref.questionPool({ has_all: true });
            return request.$promise;
        }

        function loadQuestionCategory() {
            var request = Ref.questionCategory({ has_all: true });
            return request.$promise;
        }

        function loadCompetencies() {
            var request = Ref.competencies({ has_all: true });
            return request.$promise;
        }

        function setQuestionPool(data) {
            var defer = $q.defer();
            vm.listQuestionPool = data;
            defer.resolve(true);
            return defer.promise;
        }

        function setQuestionCategory(data) {
            var defer = $q.defer();
            vm.listQuestionCategory = data;
            defer.resolve(true);
            return defer.promise;
        }

        function setCompetencies(data) {
            var defer = $q.defer();
            vm.listCompetencies = data;
            defer.resolve(true);
            return defer.promise;
        }

        function deleteAction(ev, item, isSingle) {
            var ref = [];
            if (isSingle) {
                var message = item.code + ' will be deleted, are you sure ?';
                ref.push(item.question_id);
            } else {
                ref = [];
            }
            deleteDialog(ev, ref, message);
        }

        function deleteRequest(ref) {
            blockView.start({ message: 'Please wait' });
            var request = QuestionGeneral.delete({
                ids: ref
            });
            request.$promise.then(function(res) {
                blockView.stop();
                showToast(res.message);
                loadData(1);
            });
            request.$promise.catch(function(err) {
                blockView.stop();
                showToast(err.data.message);
                loadData(1);
            });
        }

        function showToast(message) {
            $mdToast.show(
                $mdToast
                    .simple()
                    .textContent(message)
                    .position('top right')
            );
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function showDialog(ev, type, ref, isSingle) {
            switch (type) {
                case 'UPDATE':
                case 'CREATE':
                    formDialog(ev, type, ref);
                    break;
                case 'DELETE':
                    deleteAction(ev, ref, isSingle);
                    break;
            }
        }

        function formDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'FormQaGeneralController as vm',
                    templateUrl: 'app/main/qa/qa-general/form/form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type
                    }
                })
                .then(
                    function(res) {
                        loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function uploadDialog(ev) {
            $mdDialog
                .show({
                    controller: 'QuestionUploadController as vm',
                    templateUrl: 'app/main/qa/qa-general/upload/upload.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name
                    }
                })
                .then(
                    function(res) {
                        loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function deleteDialog(ev, ref, message) {
            var confirm = $mdDialog
                .confirm()
                .title('Delete Confirmation')
                .textContent(message)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function() {
                deleteRequest(ref);
            });
        }

        function getQuestionImages(path, item) {
            var request = QuestionGeneral.images({ path: path });
            request.$promise.then(function(images) {
                var fileURL = URL.createObjectURL(images.data);
                item.question_image = fileURL;
            });
            request.$promise.catch(function(images) {
                item.question_image = 'assets/images/loader.svg';
            });
        }

        function getQuestion(question) {
            return $sce.trustAsHtml(question);
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.qa.pool').controller('QaPoolController', QaPoolController);

    /** @ngInject */
    function QaPoolController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $state,
        $q
    ) {
        var vm = this;
        var Pool = apiService.Pool();
        var Menu = apiService.Menu();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.group = 'all';
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false,
        };
        vm.state = $state.current.name;
        vm.permissionList = [];
        vm.actionPermit = {
            view: false,
            delete: false,
            update: false,
            create: false,
        };

        // method
        vm.onPageChange = onPageChange;
        vm.showDialog = showDialog;
        vm.loadData = loadData;
        vm.getType = getType;

        activate();

        function activate() {
            loadPermission().then(function () {
                if (vm.actionPermit.view) {
                    loadData(1);
                } else {
                    vm.pagination.is_loading = false;
                }
            });
        }

        function loadPermission() {
            var defer = $q.defer();
            var request = Menu.getPermissionByState({ state: vm.state });
            request.$promise.then(function (res) {
                vm.permissionList = res;
                setPermission(res);
                defer.resolve();
            });
            request.$promise.catch(function (res) {
                vm.permissionList = [];
                defer.reject();
            });
            return defer.promise;
        }

        function setPermission(permission) {
            permission.map(function (val) {
                for (var key in vm.actionPermit) {
                    if (val.actions == key) {
                        vm.actionPermit[key] = val.checked;
                    }
                }
            });
        }

        function loadData(page) {
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var request = Pool.view({
                page: page,
                page_size: vm.pagination.page_size,
                group: vm.group,
                search: vm.pagination.search,
            });
            request.$promise.then(function (res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function () {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function (res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function deleteAction(ev, item, isSingle) {
            var ref = [];
            if (isSingle) {
                var message = item.name + ' will be deleted, are you sure ?';
                ref.push(item.id);
            } else {
                ref = [];
            }
            deleteDialog(ev, ref, message);
        }

        function deleteRequest(ref) {
            blockView.start({ message: 'Please wait' });
            var request = Pool.delete({
                ids: ref,
            });
            request.$promise.then(function (res) {
                blockView.stop();
                showToast(res.message);
                loadData(1);
            });
            request.$promise.catch(function (err) {
                blockView.stop();
                showToast(err.data.message);
                loadData(1);
            });
        }

        function showToast(message) {
            $mdToast.show(
                $mdToast.simple().textContent(message).position('top right')
            );
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function showDialog(ev, type, ref, isSingle) {
            switch (type) {
                case 'UPDATE':
                case 'CREATE':
                    formDialog(ev, type, ref);
                    break;
                case 'DELETE':
                    deleteAction(ev, ref, isSingle);
                    break;
            }
        }

        function formDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'FormQaPoolController as vm',
                    templateUrl: 'app/main/qa/pool/form/form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type,
                    },
                })
                .then(
                    function (res) {
                        loadData(1);
                    },
                    function () {
                        // loadData(1);
                    }
                );
        }

        function deleteDialog(ev, ref, message) {
            var confirm = $mdDialog
                .confirm()
                .title('Delete Confirmation')
                .textContent(message)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function () {
                deleteRequest(ref);
            });
        }

        function getType(type) {
            return type.split('_').join('').toUpperCase();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.qa.category')
        .controller('QaCategoryController', QaCategoryController);

    /** @ngInject */
    function QaCategoryController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $state,
        $q
    ) {
        var vm = this;
        var Category = apiService.Category();
        var Menu = apiService.Menu();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.group = 'all';
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false
        };
        vm.state = $state.current.name;
        vm.permissionList = [];
        vm.actionPermit = {
            view: false,
            delete: false,
            update: false,
            create: false
        };

        // method
        vm.onPageChange = onPageChange;
        vm.showDialog = showDialog;
        vm.loadData = loadData;

        activate();

        function activate() {
            loadPermission().then(function() {
                if (vm.actionPermit.view) {
                    loadData(1);
                } else {
                    vm.pagination.is_loading = false;
                }
            });
        }

        function loadPermission() {
            var defer = $q.defer();
            var request = Menu.getPermissionByState({ state: vm.state });
            request.$promise.then(function(res) {
                vm.permissionList = res;
                setPermission(res);
                defer.resolve();
            });
            request.$promise.catch(function(res) {
                vm.permissionList = [];
                defer.reject();
            });
            return defer.promise;
        }

        function setPermission(permission) {
            permission.map(function(val) {
                for (var key in vm.actionPermit) {
                    if (val.actions == key) {
                        vm.actionPermit[key] = val.checked;
                    }
                }
            });
        }

        function loadData(page) {
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var request = Category.view({
                page: page,
                page_size: vm.pagination.page_size,
                group: vm.group,
                search: vm.pagination.search
            });
            request.$promise.then(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function() {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function deleteAction(ev, item, isSingle) {
            var ref = [];
            if (isSingle) {
                var message = item.name + ' will be deleted, are you sure ?';
                ref.push(item.id);
            } else {
                ref = [];
            }
            deleteDialog(ev, ref, message);
        }

        function deleteRequest(ref) {
            blockView.start({ message: 'Please wait' });
            var request = Category.delete({
                ids: ref
            });
            request.$promise.then(function(res) {
                blockView.stop();
                showToast(res.message);
                loadData(1);
            });
            request.$promise.catch(function(err) {
                blockView.stop();
                showToast(err.data.message);
                loadData(1);
            });
        }

        function showToast(message) {
            $mdToast.show(
                $mdToast
                    .simple()
                    .textContent(message)
                    .position('top right')
            );
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function showDialog(ev, type, ref, isSingle) {
            switch (type) {
                case 'UPDATE':
                case 'CREATE':
                    formDialog(ev, type, ref);
                    break;
                case 'DELETE':
                    deleteAction(ev, ref, isSingle);
                    break;
            }
        }

        function formDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'FormCategoryController as vm',
                    templateUrl: 'app/main/qa/category/form/form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type
                    }
                })
                .then(
                    function(res) {
                        loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function deleteDialog(ev, ref, message) {
            var confirm = $mdDialog
                .confirm()
                .title('Delete Confirmation')
                .textContent(message)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function() {
                deleteRequest(ref);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.guides')
        .controller('ViewGuidesController', ViewGuidesController);

    /** @ngInject */
    function ViewGuidesController(
        apiService,
        $mdDialog,
        theme,
        refData,
        $timeout,
        $sce
    ) {
        // data
        var vm = this;
        var Guides = apiService.Guides();
        vm.isLoading = true;
        vm.isErrorLoad = false;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.data = angular.copy(refData);
        vm.guide = null;

        init();

        function init() {
            loadGuide();
        }

        function loadGuide() {
            var request = Guides.loadGuide({ filename: vm.data.filename });
            request.$promise.then(function (blob) {
                blobToDataURL(blob.data, function (url) {
                    vm.guide = $sce.trustAsResourceUrl(url);
                });
            });
            request.$promise.catch(function (err) {
                vm.isErrorLoad = true;
            });
        }

        function blobToDataURL(blob, callback) {
            var a = new FileReader();
            a.onload = function (e) {
                callback(e.target.result);
            };
            a.readAsDataURL(blob);
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.guides')
        .controller('FormGuidesController', FormGuidesController);

    /** @ngInject */
    function FormGuidesController(
        apiService,
        $mdDialog,
        theme,
        refData,
        dialogType,
        $scope,
        $timeout,
        Upload,
        $q
    ) {
        // data
        var vm = this;
        var Guides = apiService.Guides();
        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.theme = theme;
        vm.form = {};
        vm.dialogType = dialogType;
        vm.data = {
            title: '',
            description: '',
        };
        // vm.tempFile = null;

        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;
        vm.update = update;

        init();

        function init() {
            if (vm.dialogType === 'UPDATE') {
                vm.data.id = refData.id;
                vm.data.title = refData.title;
                vm.data.description = refData.description;
            }

            $timeout(function () {
                vm.isLoading = false;
            }, 2000);
        }

        function submit(ev, form) {
            var request = Guides.create(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Submitting Request';
            request.$promise.then(function (res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function (err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function update(ev, form) {
            var request = Guides.update(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Updating Request';
            request.$promise.then(function (res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function (err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function setForm(form) {
            vm.form = form;
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element(document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function () {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.dashboard', ['chart.js']).config(config);

    /** @ngInject */
    function config($stateProvider, ChartJsProvider) {
        ChartJsProvider.setOptions({
            colors: [
                '#3F51B5',
                '#3F51B5',
                '#3F51B5',
                '#3F51B5',
                '#3F51B5',
                '#3F51B5',
                '#3F51B5'
            ]
        });
        // State
        $stateProvider.state('app.dashboard', {
            url: '/dashboard',
            views: {
                'content@app': {
                    templateUrl: 'app/main/dashboard/dashboard.html',
                    controller: 'DashboardController as vm'
                }
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.dashboard')
                            .then(function() {
                                defer.resolve();
                            })
                            .catch(function(state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    }
                ]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.dashboard')
        .controller('ViewUserDashboardController', ViewUserDashboardController);

    ViewUserDashboardController.$inject = [
        '$mdDialog',
        'theme',
        'refData',
        'dialogType',
        '$scope'
    ];

    /** @ngInject */
    function ViewUserDashboardController(
        $mdDialog,
        theme,
        refData,
        dialogType,
        $scope
    ) {
        // data
        var vm = this;
        vm.theme = theme;
        vm.form = {};
        vm.dialogType = dialogType;
        vm.data = refData;
        vm.numPages = numPages;
        vm.filtered = [];
        vm.currentPage = 1;
        vm.numPerPage = 20;
        vm.totalItems = vm.data.length;
        vm.end = 1;

        // methods
        vm.cancel = cancel;
        vm.hide = hide;

        init();

        function init() {
            $scope.$watch('vm.currentPage + vm.numPerPage', function() {
                var begin = (vm.currentPage - 1) * vm.numPerPage;
                var end = begin + vm.numPerPage;
                vm.end = begin;
                vm.filtered = vm.data.slice(begin, end);
            });
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function numPages() {
            return Math.ceil(vm.data.length / vm.numPerPage);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.clients', [
            'app.clients.menus',
            'app.clients.assessment_general',
            'app.clients.assessment_tiki',
            'app.clients.assessment_papikostik',
            'app.clients.assessment_case_study',
            'app.clients.assessment_survey',
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.clients', {
            abstract: true,
            url: '/clients',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm',
                },
                'content@app.clients': {
                    templateUrl: 'app/main/clients/clients.html',
                    controller: 'ClientsController as vm',
                },
            },
        });
    }
})();

(function() {
    'use strict';
    angular.module('app.clients').directive('toolbarAssessment', toolbarAssessment);

    function toolbarAssessment() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/clients/toolbar/toolbar.directive.html',
            scope: {
                remainingTimes: '=',
                questions: '=',
                activeQuestion: '=',
                theme: '=',
                questionIndex: '=',
                scheme: '='
            },
            controller: ToolbarController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    ToolbarController.$inject = [
        '$scope',
        '$rootScope',
        '$interval',
        '$mdDialog',
        'apiService',
        'toastr',
        '$state',
        '$document'
    ];

    /** @ngInject */
    function ToolbarController(
        $scope,
        $rootScope,
        $interval,
        $mdDialog,
        apiService,
        toastr,
        $state,
        $document
    ) {
        // Injecting $scope just for comparison
        var vm = this;
        var Assessment = apiService.Assessment();
        vm.$onInit = onInit;
        vm.fmtMSS = fmtMSS;
        vm.guide = null;
        vm.viewDialog = viewDialog;
        vm.timerSyncDelay = 30000;
        vm.isSyncRunning = false;
        vm.isInit = true;
        vm.submit = submit;
        vm.hide = hide;

        var listenOnloadGuide = $rootScope.$on('GUIDE::LOADED', function(ev, val) {
            vm.guide = val;
        });

        function onInit() {
            $scope.$watch('vm.remainingTimes', function(nVal) {
                if (nVal) {
                    if (angular.isUndefined($rootScope.$timer)) {
                        startTimer();
                        initSync();
                    } else {
                        if (vm.remainingTimes <= 0) {
                            if (angular.isDefined($rootScope.$timer)) {
                                $interval.cancel($rootScope.$timer);
                            }
                            $rootScope.$broadcast('TIMER::TIME_IS_OVER', true);
                        }
                    }
                }
            });
        }

        function fmtMSS(s) {
            if (!s || s <= 0) {
                return '00:00';
            }
            return (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + s;
        }

        function startTimer() {
            if (vm.remainingTimes >= 0) {
                $rootScope.$timer = $interval(function() {
                    vm.remainingTimes -= 1;
                }, 1000);
            } else {
                if (angular.isDefined($rootScope.$timer)) {
                    $interval.cancel($rootScope.$timer);
                }
                $rootScope.$broadcast('TIMER::TIME_IS_OVER', true);
            }
        }

        $scope.$on('$destroy', function() {
            if (angular.isDefined($rootScope.$timer)) {
                $interval.cancel($rootScope.$timer);
                $rootScope.$timer = undefined;
            }
            if (angular.isDefined($rootScope.$timerSync)) {
                $interval.cancel($rootScope.$timerSync);
                $rootScope.$timerSync = undefined;
            }
            listenOnloadGuide();
        });

        function viewDialog(ev) {
            ev.preventDefault();
            $mdDialog.show({
                controller: 'ViewGuidesToolbarController as vm',
                templateUrl: 'app/main/clients/toolbar/view-guide/view-guide.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: false,
                locals: {
                    theme: vm.theme.active.name,
                    guide: vm.guide
                }
            });
        }

        function initSync() {
            if (angular.isUndefined($rootScope.$timerSync)) {
                $rootScope.$timerSync = $interval(function() {
                    if (!vm.isSyncRunning && !vm.isInit) {
                        runSync(vm.scheme);
                    }
                    vm.isInit = false;
                }, vm.timerSyncDelay);
            }
        }

        function runSync(scheme) {
            vm.isSyncRunning = true;
            var request = Assessment.sync(scheme);
            request.$promise.then(function() {
                vm.isSyncRunning = false;
                showMessage('success', 'Progress berhasil tersimpan');
            });
            request.$promise.catch(function() {
                vm.isSyncRunning = false;
                showMessage('error', 'Progress gagal tersimpan');
            });
        }

        function showMessage(status, message) {
            switch (status) {
                case 'success':
                    toastr.success(message);
                    break;
                case 'warning':
                    toastr.warning(message);
                    break;
                case 'error':
                    toastr.error(message);
                    break;
                case 'info':
                    toastr.info(message);
                    break;
            }
        }

        function submit(ev) {
            if (vm.remainingTimes <= 20) {
                finalSubmit(ev);
                return;
            }
            var confirmation = confirmDialog(ev);
            confirmation.then(
                function() {
                    finalSubmit();
                },
                function() {
                    showMessage('info', 'Silahkan kembali mengerjakan test anda');
                }
            );
        }

        function finalSubmit(ev) {
            var request = Assessment.submit(vm.scheme);
            request.$promise.then(function(res) {
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(res) {
                showDialog(ev, false, res);
            });
        }

        function confirmDialog(ev) {
            var message =
                'Jika anda melakukan ini, anda tidak dapat melanjutkan kembali test';
            if (vm.remainingTimes > 60) {
                message =
                    'Anda masih memiliki waktu untuk mengerjakan test, jika anda melakukan ini, anda tidak dapat melanjutkan kembali test';
            }
            var confirm = $mdDialog
                .confirm()
                .title('Apakah anda yakin ?')
                .textContent(message)
                .ariaLabel('Submit')
                .targetEvent(ev)
                .ok('OK')
                .cancel('NO');

            return $mdDialog.show(confirm);
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element($document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .then(function() {
                    $state.go('app.clients.menus');
                });
        }

        function hide() {
            $mdDialog.hide();
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.clients.menus', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.clients.menus', {
            url: '/menu',
            views: {
                client_content: {
                    templateUrl: 'app/main/clients/menus/menus.html',
                    controller: 'ClientsMenusController as vm'
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.clients.menus')
        .controller('ClientsMenusController', ClientsMenusController);

    /** @ngInject */
    function ClientsMenusController(
        $mdToast,
        $state,
        apiService,
        blockUI,
        $localStorage,
        $rootScope,
        $timeout
    ) {
        var vm = this;
        var blockContent = blockUI.instances.get('block-content');
        var Assessment = apiService.Assessment();
        vm.listSession = [];
        vm.launchTest = launchTest;
        vm.loadSession = loadSession;
        vm.isLoading = false;

        activate();

        function activate() {
            loadSession();
        }

        function loadSession() {
            vm.isLoading = true;
            blockContent.start({ message: 'Loading Session' });
            var request = Assessment.session();
            request.$promise.then(function (res) {
                $timeout(function () {
                    vm.isLoading = false;
                    blockContent.stop();
                }, 1000);
                vm.listSession = res.data;
                vm.message = res.message;
            });
            request.$promise.catch(function (res) {
                $timeout(function () {
                    vm.isLoading = false;
                    blockContent.stop();
                }, 1000);
                vm.listSession = [];
                vm.message = res.data.message;
            });
        }

        function launchTest(item) {
            var params = {
                session_id: item.session_id,
                pool_id: item.pool_id,
                guide_id: item.guides_id,
            };
            switch (item.session_type) {
                case 'general':
                    $state.go('app.clients.assessment_general', params);
                    break;
                case 'tiki':
                    $state.go('app.clients.assessment_tiki', params);
                    break;
                case 'papikostik':
                    $state.go('app.clients.assessment_papikostik', params);
                    break;
                case 'case_study':
                    $state.go('app.clients.assessment_case_study', params);
                    break;
                case 'survey':
                    $state.go('app.clients.assessment_survey', params);
                    break;
            }
        }
    }
})();

(function() {
    'use strict';
    angular.module('app.clients').directive('guideAssessment', guideAssessment);

    function guideAssessment() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/clients/guides/guides.directive.html',
            scope: {
                sessionId: '=',
                isFinished: '=',
                onClickStart: '&',
                guideId: '='
            },
            controller: GuideController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    GuideController.$inject = ['$sce', 'apiService', '$q'];

    /** @ngInject */
    function GuideController($sce, apiService) {
        // Injecting $rootScope just for comparison
        var vm = this;
        var Guide = apiService.Guides();
        vm.$onInit = onInit;
        vm.media = null;
        vm.title = 'This is guides';
        vm.description = 'This is description guides';
        vm.isErrorLoad = false;
        vm.isLoading = false;
        vm.getGuide = getGuide;

        function onInit() {
            if (!vm.isFinished) {
                getGuide();
            }
        }

        function getGuide() {
            vm.isLoading = true;
            var request = Guide.loadGuideById({ id: vm.guideId });
            request.$promise.then(function(res) {
                vm.isLoading = false;
                vm.isErrorLoad = false;
                vm.description = $sce.trustAsHtml(res.description);
                vm.title = res.title;
            });
            request.$promise.catch(function() {
                vm.description = 'Failed Load Guide';
                vm.title = 'Guide Not Found';
                vm.isLoading = false;
                vm.isErrorLoad = true;
            });
        }
    }
})();

/* eslint-disable angular/log */
/* eslint-disable no-console */
(function() {
    'use strict';

    angular
        .module('app.clients.assessment_tiki')
        .controller('AssessmentTikiController', AssessmentTikiController);

    /** @ngInject */
    function AssessmentTikiController(
        $state,
        apiService,
        $scope,
        $stateParams,
        $q,
        $mdDialog,
        fuseTheming,
        $timeout
    ) {
        var vm = this;
        var Assessment = apiService.Assessment();
        vm.themes = fuseTheming.themes;
        vm.params = {
            session_type: 'tiki',
            pool_id: $stateParams.pool_id,
            session_id: $stateParams.session_id,
            guide_id: $stateParams.guide_id
        };
        vm.start = start;
        vm.isPreparing = true;
        vm.isGuideFinish = true;
        vm.stopSpinner = false;
        vm.activeSession = 1;
        vm.message = 'Preparing';
        vm.tempSessionId = 0;
        vm.activeSectionId = 0;

        activate();

        function activate() {
            vm.isPreparing = true;
            vm.isGuideFinish = true;
            vm.stopSpinner = false;
            checkTikiSession()
                .then(function(session) {
                    if (session.status) {
                        sessionAvailable(session.data);
                    } else {
                        $timeout(function() {
                            initTikiSession();
                        }, 1000);
                    }
                })
                .catch(function(err) {
                    vm.isGuideFinish = false;
                    vm.isPreparing = false;
                    vm.stopSpinner = true;
                    vm.message =
                        'Failed check session, please contact administrator to get help';
                    console.log(err);
                });
        }

        function sessionAvailable(session) {
            vm.isPreparing = false;
            vm.stopSpinner = true;
            vm.tempSessionId = session.id;
            vm.activeSectionId = session.running_session.section_id;
            if (session.is_guide_read == 1) {
                if (session.running_session.is_guide_finished == 0) {
                    toGuide(session.running_session.section_id, session.id);
                } else {
                    toSection(session.running_session.section_id, session.id);
                }
            } else {
                vm.isGuideFinish = false;
            }
        }

        function start(ev) {
            var confirm = $mdDialog
                .confirm()
                .title('Apakah anda yakin ?')
                .textContent(
                    'Saat test dimulai waktu pengerjaan akan dimulai dan anda tidak dapat kembali lagi'
                )
                .ariaLabel('Start')
                .targetEvent(ev)
                .ok('OK')
                .cancel('NO');

            $mdDialog.show(confirm).then(init);
        }

        function init() {
            var setIsRead = Assessment.setGuideIsReaded({
                session_id: vm.params.session_id
            });
            setIsRead.$promise
                .then(function() {
                    vm.isGuideFinish = true;
                    toGuide(vm.activeSectionId, vm.tempSessionId);
                })
                .catch(function(err) {
                    console.log(err);
                });
        }

        function toSection(sectionId, tempSessionId) {
            $state.go('app.clients.assessment_tiki.section', {
                temp_session_id: tempSessionId,
                section_id: sectionId
            });
        }

        function toGuide(sectionId, tempSessionId) {
            $state.go('app.clients.assessment_tiki.guide', {
                temp_session_id: tempSessionId,
                section_id: sectionId
            });
        }

        function checkTikiSession() {
            var defer = $q.defer();
            var request = Assessment.checkTikiSession({
                session_id: vm.params.session_id
            });
            request.$promise.then(function(res) {
                defer.resolve(res);
            });
            request.$promise.catch(function(err) {
                defer.reject(err.data);
            });
            return defer.promise;
        }

        function initTikiSession() {
            var request = Assessment.initTikiSession({
                session_id: vm.params.session_id
            });
            request.$promise.then(successInitSession);
            request.$promise.catch(failedInitSession);
        }

        function successInitSession(res) {
            vm.message = 'Success Initializing Session';
            vm.isPreparing = false;
            vm.stopSpinner = true;
            vm.tempSessionId = res.data.temp_session_id;
            vm.activeSectionId = res.data.section_id;
            if (res.data.is_guide_finished == 1) {
                toGuide(vm.activeSectionId, vm.tempSessionId);
            } else {
                vm.isGuideFinish = false;
            }
        }

        function failedInitSession() {
            vm.stopSpinner = true;
            vm.isPreparing = false;
            vm.message =
                'Failed Initializing Session, please contact administrator to get help';
        }

        var onFinishedSectionListener = $scope.$on(
            '::onFinishedSection',
            function() {
                console.log('::onFinishedSection');
                activate();
            }
        );

        $scope.$on('$destroy', function() {
            onFinishedSectionListener();
        });
    }
})();

(function() {
    'use strict';

    angular.module('app.clients.assessment_survey', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.clients.assessment_survey', {
            url: '/survey/{session_id}/{pool_id}/{guide_id}',
            views: {
                client_content: {
                    templateUrl:
                        'app/main/clients/assessment-survey/assessment-survey.html',
                    controller: 'AssessmentSurveyController as vm'
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.clients.assessment_survey')
        .controller('AssessmentSurveyController', AssessmentSurveyController);

    /** @ngInject */
    function AssessmentSurveyController(
        $mdToast,
        $state,
        apiService,
        blockUI,
        $localStorage,
        $scope,
        $stateParams,
        $q,
        $mdDialog,
        fuseTheming,
        $rootScope,
        toastr,
        $interval,
        $anchorScroll,
        $location,
        $timeout,
        appConfig,
        $sce
    ) {
        var vm = this;
        var Assessment = apiService.Assessment();
        var alert;
        vm.themes = fuseTheming.themes;
        vm.scheme = {};
        vm.params = {
            session_type: 'survey',
            pool_id: $stateParams.pool_id,
            session_id: $stateParams.session_id,
            guide_id: $stateParams.guide_id,
        };

        vm.isGuideFinish = false;
        vm.isLoading = false;
        vm.syncDelay = 10000; // in ms
        vm.isSyncRunning = false;
        vm.countdownExp = 30;
        vm.countdownInterval = undefined;
        vm.countdownExpired = undefined;
        vm.displayTimer = '00:00';
        vm.timeIsOver = false;
        vm.goToMenu = goToMenu;
        vm.start = start;
        vm.goToQuestion = goToQuestion;
        vm.submit = submit;
        vm.timeIsOver = false;
        vm.getResource = getResource;
        vm.locationHash = null;
        vm.isPreparing = true;

        activate();

        function activate() {
            vm.isPreparing = true;
            checkGuideIsRead().then(function (status) {
                if (status) {
                    init();
                }
            });
        }

        function init() {
            vm.isGuideFinish = true;
            loadQuestion()
                .then(initQuestion)
                .catch(function (err) {
                    vm.isPreparing = false;
                    vm.scheme = {};
                });

            $scope.$on('TIMER::TIME_IS_OVER', function (ev, val) {
                vm.timeIsOver = val;
            });
        }

        function start(ev) {
            var confirm = $mdDialog
                .confirm()
                .title('Apakah anda yakin ?')
                .textContent(
                    'Saat test dimulai waktu pengerjaan akan dimulai dan anda tidak dapat kembali lagi'
                )
                .ariaLabel('Start')
                .targetEvent(ev)
                .ok('OK')
                .cancel('NO');

            $mdDialog.show(confirm).then(init);
        }

        function checkGuideIsRead() {
            var defer = $q.defer();
            var request = Assessment.isGuideRead({
                session_id: vm.params.session_id,
            });
            request.$promise.then(function (res) {
                defer.resolve(res.status);
            });
            request.$promise.catch(function () {
                defer.reject(false);
            });
            return defer.promise;
        }

        function loadQuestion() {
            var request = Assessment.question(vm.params);
            return request.$promise;
        }

        function initQuestion(scheme) {
            vm.isPreparing = false;
            vm.scheme = scheme.data;
            vm.remainingTimes = vm.scheme.remaining_times;
            if (!vm.scheme.is_valid) {
                setCountdownExpired();
            } else {
                setCountdownInterval();
            }
        }

        function submit(ev) {
            for (var i = 0; i < vm.scheme.questions.length; i++) {
                for (var j = 0; j < vm.scheme.questions[i].questions.length; j++) {
                    if (!vm.scheme.questions[i].questions[j].selected) {
                        var id =
                            'question_' + vm.scheme.questions[i].questions[j].id;
                        vm.locationHash = id;
                        goToQuestion(id);
                        showMessage('error', 'Pertanyaan ini Belum diisi');
                        return;
                    }
                }
            }
            confirmDialog(ev).then(function () {
                saveData();
            });
        }

        function confirmDialog(ev) {
            var message =
                'Jika anda melakukan ini, anda tidak dapat melanjutkan kembali test';
            if (vm.remainingTimes > 60) {
                message =
                    'Anda masih memiliki waktu untuk mengerjakan test, jika anda melakukan ini, anda tidak dapat melanjutkan kembali test';
            }
            var confirm = $mdDialog
                .confirm()
                .title('Apakah anda yakin ?')
                .textContent(message)
                .ariaLabel('Submit')
                .targetEvent(ev)
                .ok('OK')
                .cancel('NO');

            return $mdDialog.show(confirm);
        }

        function saveData() {
            blockUI.start({ message: 'Submitting' });
            $timeout(function () {
                var request = Assessment.submit(vm.scheme);
                request.$promise.then(function (res) {
                    blockUI.stop();
                    showFinishDialog();
                });
                request.$promise.catch(function (res) {
                    showErrorDialog();
                    blockUI.stop();
                });
            }, 2000);
        }

        function showErrorDialog() {
            blockUI.stop();
            alert = $mdDialog
                .alert()
                .title('Terjadi kesalahan')
                .textContent(
                    'Survey anda tidak berhasil tersubmit, silahkan check kembali koneksi internet anda'
                )
                .ok('Tutup');

            $mdDialog.show(alert).finally(function () {
                alert = undefined;
                goToMenu();
            });
        }

        function showFinishDialog() {
            blockUI.stop();
            alert = $mdDialog
                .alert()
                .title('Terima kasih')
                .textContent(
                    'Survey anda telah berhasil tersubmit, anda akan segera di alihkan kehalaman menu'
                )
                .ok('Tutup');

            $mdDialog.show(alert).finally(function () {
                alert = undefined;
                goToMenu();
            });
        }

        function showMessage(status, message) {
            switch (status) {
                case 'success':
                    toastr.success(message);
                    break;
                case 'warning':
                    toastr.warning(message);
                    break;
                case 'error':
                    toastr.error(message);
                    break;
                case 'info':
                    toastr.info(message);
                    break;
            }
        }

        function goToMenu() {
            $state.go('app.clients.menus');
        }

        function setCountdownExpired() {
            vm.countdownExpired = $interval(function () {
                vm.countdownExp -= 1;
                if (vm.countdownExp <= 0) {
                    $interval.cancel(vm.countdownExpired);
                    goToMenu();
                }
            }, 1000);
        }

        function setCountdownInterval() {
            vm.countdownInterval = $interval(function () {
                vm.remainingTimes -= 1;
                vm.displayTimer = fmtMSS(vm.remainingTimes);
                if (vm.remainingTimes <= 0) {
                    $interval.cancel(vm.countdownInterval);
                    saveData();
                    return;
                }
                if (vm.remainingTimes % 20 == 0) {
                    if (!vm.isSyncRunning) {
                        runSync(vm.scheme);
                    }
                }
            }, 1000);
        }

        function runSync(scheme) {
            vm.isSyncRunning = true;
            var request = Assessment.sync(scheme);
            request.$promise.then(function (res) {
                vm.isSyncRunning = false;
                // showMessage('success', 'Progress berhasil tersimpan');
            });
            request.$promise.catch(function (err) {
                vm.isSyncRunning = false;
                showMessage(
                    'error',
                    'Progress gagal tersimpan, mohon pastikan internet anda terhubung'
                );
            });
        }

        $scope.$on('$destroy', function () {
            if (angular.isDefined(vm.countdownInterval)) {
                $interval.cancel(vm.countdownInterval);
            }
            if (angular.isDefined(vm.countdownExpired)) {
                $interval.cancel(vm.countdownExpired);
            }
        });

        function goToQuestion(id) {
            if ($location.hash() !== id) {
                $location.hash(id);
            } else {
                $anchorScroll();
            }
        }

        function fmtMSS(s) {
            if (!s || s <= 0) {
                return '00:00';
            }
            return (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + s;
        }

        function getResource(filename) {
            var token = $localStorage.token;
            var url =
                appConfig.apiUrl +
                'assessment/getResource?filename=' +
                filename +
                '&session_type=case_study&token=' +
                token +
                '&page=hsn#toolbar=0';
            return $sce.trustAsResourceUrl(url);
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.clients.assessment_papikostik', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.clients.assessment_papikostik', {
            url: '/papikostik/{session_id}/{pool_id}/{guide_id}',
            views: {
                client_content: {
                    templateUrl:
                        'app/main/clients/assessment-papikostik/assessment-papikostik.html',
                    controller: 'AssessmentPapikostikController as vm',
                },
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.clients.assessment_papikostik')
        .controller(
            'AssessmentPapikostikController',
            AssessmentPapikostikController
        );

    /** @ngInject */
    function AssessmentPapikostikController(
        $mdToast,
        $state,
        apiService,
        blockUI,
        $document,
        $scope,
        $stateParams,
        $q,
        $mdDialog,
        fuseTheming,
        $rootScope,
        toastr,
        $interval,
        $location,
        $anchorScroll,
        $timeout
    ) {
        var vm = this;
        var blockContent = blockUI.instances.get('block-content');
        var Assessment = apiService.Assessment();
        var alert;
        vm.themes = fuseTheming.themes;
        vm.scheme = {};
        vm.params = {
            session_type: 'papikostik',
            pool_id: $stateParams.pool_id,
            session_id: $stateParams.session_id,
            guide_id: $stateParams.guide_id,
        };

        vm.isGuideFinish = false;
        vm.countdownInterval = undefined;
        vm.countdownTime = 10;
        vm.isValidSession = false;
        vm.syncDelay = 10000; // in ms
        vm.isSyncRunning = false;
        vm.remainingTimes = 0;
        vm.displayTimer = '00:00:00';
        vm.isInit = true;

        vm.start = start;
        vm.goToQuestion = goToQuestion;
        vm.lockQuestion = false;
        vm.submit = submit;

        activate();

        function activate() {
            checkGuideIsRead().then(function (status) {
                if (status) {
                    init();
                }
            });
        }

        function start(ev) {
            var confirm = $mdDialog
                .confirm()
                .title('Apakah anda yakin ?')
                .textContent(
                    'Saat test dimulai waktu pengerjaan akan dimulai dan anda tidak dapat kembali lagi'
                )
                .ariaLabel('Start')
                .targetEvent(ev)
                .ok('OK')
                .cancel('NO');

            $mdDialog.show(confirm).then(init);
        }

        function init() {
            vm.isGuideFinish = true;
            blockContent.start({ message: 'Please Wait' });
            loadQuestion()
                .then(initQuestion)
                .catch(function (err) {
                    vm.scheme = {};
                })
                .finally(function () {
                    $timeout(function () {
                        blockContent.stop();
                    }, 2000);
                });
        }

        function checkGuideIsRead() {
            var defer = $q.defer();
            var request = Assessment.isGuideRead({
                session_id: vm.params.session_id,
            });
            request.$promise.then(function (res) {
                defer.resolve(res.status);
            });
            request.$promise.catch(function () {
                defer.reject(false);
            });
            return defer.promise;
        }

        function loadQuestion() {
            var request = Assessment.question(vm.params);
            return request.$promise;
        }

        function initQuestion(scheme) {
            vm.scheme = scheme.data;
            vm.remainingTimes = scheme.data.remaining_times;
            vm.isInit = scheme.data.is_init;
            vm.isValidSession = scheme.data.is_valid;
            if (vm.isValidSession) {
                startTimer();
                initSync();
            } else {
                vm.lockQuestion = true;
                startCountDownInterval();
            }
        }

        function goToQuestion(id) {
            var newHash = 'question_' + id;
            if ($location.hash() !== newHash) {
                $location.hash('question_' + id);
            } else {
                $anchorScroll();
            }
        }

        // timer part

        function initSync() {
            if (angular.isUndefined($rootScope.$timerSync)) {
                $rootScope.$timerSync = $interval(function () {
                    if (!vm.isSyncRunning && !vm.isInit) {
                        runSync(vm.scheme);
                    }
                    vm.isInit = false;
                }, vm.syncDelay);
            }
        }

        function runSync(scheme) {
            vm.isSyncRunning = true;
            var request = Assessment.sync(scheme);
            request.$promise.then(function () {
                vm.isSyncRunning = false;
            });
            request.$promise.catch(function () {
                vm.isSyncRunning = false;
            });
        }

        function fmtMSS(s) {
            if (!s || s <= 0) {
                vm.displayTimer = '00:00:00';
            } else {
                vm.displayTimer = (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + s;
            }
        }

        function startTimer() {
            if (vm.remainingTimes >= 0) {
                $rootScope.$timer = $interval(function () {
                    fmtMSS(vm.remainingTimes);
                    vm.remainingTimes -= 1;
                    if (vm.remainingTimes <= 0) {
                        vm.lockQuestion = true;
                        startCountDownInterval();
                    }
                }, 1000);
            } else {
                if (angular.isDefined($rootScope.$timer)) {
                    $interval.cancel($rootScope.$timer);
                }
                vm.lockQuestion = true;
                $rootScope.$broadcast('TIMER::TIME_IS_OVER', true);
            }
        }

        function startCountDownInterval() {
            vm.countdownInterval = $interval(function () {
                if (vm.countdownTime <= 0) {
                    vm.countdownTime = 0;
                    $interval.cancel(vm.countdownInterval);
                    finalSubmit();
                    return;
                }
                vm.countdownTime -= 1;
            }, 1000);
        }

        function submit(ev) {
            if (vm.remainingTimes <= 20) {
                finalSubmit();
                return;
            }
            var confirmation = confirmDialog(ev);
            confirmation.then(
                function () {
                    finalSubmit();
                },
                function () {
                    showMessage('info', 'Silahkan kembali mengerjakan test anda');
                }
            );
        }

        function finalSubmit() {
            blockContent.start({ message: 'Submitting Result' });
            var request = Assessment.submit(vm.scheme);
            request.$promise.then(function (res) {
                blockContent.stop();
                showAlert(true, res);
            });
            request.$promise.catch(function (res) {
                blockContent.stop();
                showAlert(false, res);
            });
        }

        function showAlert(status, response) {
            alert = $mdDialog
                .alert({
                    title: status ? 'Success' : 'Failed',
                    textContent: response.message,
                    ok: 'OK',
                })
                .parent(angular.element($document.body));

            $mdDialog.show(alert).finally(function () {
                alert = undefined;
                if (status) {
                    $state.go('app.clients.menus');
                }
            });
        }

        function confirmDialog(ev) {
            var message =
                'Jika anda melakukan ini, anda tidak dapat melanjutkan kembali test';
            if (vm.remainingTimes > 60) {
                message =
                    'Anda masih memiliki waktu untuk mengerjakan test, jika anda melakukan ini, anda tidak dapat melanjutkan kembali test';
            }
            var confirm = $mdDialog
                .confirm()
                .title('Apakah anda yakin ?')
                .textContent(message)
                .ariaLabel('Submit')
                .targetEvent(ev)
                .ok('OK')
                .cancel('NO');

            return $mdDialog.show(confirm);
        }

        function showMessage(status, message) {
            switch (status) {
                case 'success':
                    toastr.success(message);
                    break;
                case 'warning':
                    toastr.warning(message);
                    break;
                case 'error':
                    toastr.error(message);
                    break;
                case 'info':
                    toastr.info(message);
                    break;
            }
        }

        $scope.$on('$destroy', function () {
            if (angular.isDefined($rootScope.$timer)) {
                $interval.cancel($rootScope.$timer);
                $rootScope.$timer = undefined;
            }
            if (angular.isDefined($rootScope.$timerSync)) {
                $interval.cancel($rootScope.$timerSync);
                $rootScope.$timerSync = undefined;
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('app.clients.assessment_general', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.clients.assessment_general', {
            url: '/general/{session_id}/{pool_id}/{guide_id}',
            views: {
                client_content: {
                    templateUrl:
                        'app/main/clients/assessment-general/assessment-general.html',
                    controller: 'AssessmentGeneralController as vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.clients.assessment_general')
        .controller('AssessmentGeneralController', AssessmentGeneralController);

    /** @ngInject */
    function AssessmentGeneralController(
        $mdToast,
        $state,
        apiService,
        blockUI,
        $localStorage,
        $scope,
        $stateParams,
        $q,
        $mdDialog,
        fuseTheming,
        $rootScope,
        toastr,
        $interval
    ) {
        var vm = this;
        var blockContent = blockUI.instances.get('block-content');
        var Assessment = apiService.Assessment();
        var QuestionGeneral = apiService.QuestionGeneral();
        vm.themes = fuseTheming.themes;
        vm.scheme = {};
        vm.params = {
            session_type: 'general',
            pool_id: $stateParams.pool_id,
            session_id: $stateParams.session_id,
            guide_id: $stateParams.guide_id
        };
        vm.activeQuestion = {};
        vm.start = start;
        vm.isGuideFinish = false;
        vm.isLoading = false;
        vm.questionIndex = 0;
        vm.syncDelay = 10000; // in ms
        vm.isSyncRunning = false;
        vm.countdownExp = 30;
        vm.countdownInterval = undefined;
        vm.timeIsOver = false;
        vm.isLastQuestion = false;
        vm.isFirstQuestion = false;

        vm.setQuestion = setQuestion;
        vm.getQuestionImages = getQuestionImages;
        vm.prevQuestion = prevQuestion;
        vm.nextQuestion = nextQuestion;
        vm.onAnswerChange = onAnswerChange;
        vm.goToMenu = goToMenu;

        activate();

        function activate() {
            checkGuideIsRead().then(function(status) {
                if (status) {
                    init();
                }
            });
        }

        function init() {
            vm.isGuideFinish = true;
            loadQuestion()
                .then(initQuestion)
                .catch(function(err) {
                    vm.scheme = {};
                });

            $scope.$on('GENERAL::QUESTION_RELOAD', function() {
                loadQuestion();
            });
            $scope.$on('TIMER::TIME_IS_OVER', function(ev, val) {
                vm.timeIsOver = val;
            });
        }

        function initQuestion(scheme) {
            vm.scheme = scheme.data;
            vm.questionIndex = getLastIndex(vm.scheme.questions);
            vm.activeQuestion = vm.scheme.questions[vm.questionIndex];
            if (vm.questionIndex === 0) {
                vm.isFirstQuestion = true;
            }
            if (!vm.scheme.is_valid) {
                setCountdownExpired();
            }
        }

        function loadQuestion() {
            var request = Assessment.question(vm.params);
            return request.$promise;
        }

        function start(ev) {
            var confirm = $mdDialog
                .confirm()
                .title('Apakah anda yakin ?')
                .textContent(
                    'Saat test dimulai waktu pengerjaan akan dimulai dan anda tidak dapat kembali lagi'
                )
                .ariaLabel('Start')
                .targetEvent(ev)
                .ok('OK')
                .cancel('NO');

            $mdDialog.show(confirm).then(init);
        }

        function checkGuideIsRead() {
            var defer = $q.defer();
            var request = Assessment.isGuideRead({
                session_id: vm.params.session_id
            });
            request.$promise.then(function(res) {
                defer.resolve(res.status);
            });
            request.$promise.catch(function() {
                defer.reject(false);
            });
            return defer.promise;
        }

        function setQuestion(idx) {
            vm.isLastQuestion = false;
            vm.isFirstQuestion = false;

            var answered = vm.activeQuestion.answers.filter(function(val) {
                return val.checked;
            });

            if (idx === 0) {
                vm.isFirstQuestion = true;
            }

            if (answered.length !== 0) {
                if (vm.activeQuestion.total_answer !== answered.length) {
                    showMessage(
                        'warning',
                        'Pertanyaan ini membutuhkan ' +
                            vm.activeQuestion.total_answer +
                            ' jawaban'
                    );
                    return;
                }
            }

            vm.activeQuestion = vm.scheme.questions[idx];
            vm.questionIndex = idx;

            if (vm.scheme.questions.length - 1 == idx) {
                vm.isLastQuestion = true;
            }
            setLastIndex(idx);
        }

        function getQuestionImages(path) {
            var defer = $q.defer();
            var request = QuestionGeneral.images({ path: path });
            request.$promise.then(function(images) {
                var fileURL = URL.createObjectURL(images.data);
                defer.resolve(fileURL);
            });
            request.$promise.catch(function(images) {
                defer.resolve('assets/images/loader.svg');
            });
            return defer.promise;
        }

        function nextQuestion() {
            var questionIdx = angular.copy(vm.questionIndex);
            var nextIdx = questionIdx + 1;
            var questionTotalIdx = vm.scheme.questions.length - 1;
            if (nextIdx > questionTotalIdx) {
                showMessage('info', 'ini adalah pertanyaan terakhir');
                return;
            }
            setQuestion(nextIdx);
            vm.questionIdx = nextIdx;
        }

        function prevQuestion() {
            vm.isLastQuestion = false;
            var questionIdx = angular.copy(vm.questionIndex);
            var prevIdx = questionIdx - 1;
            if (prevIdx < 0) {
                showMessage('info', 'Ini adalah pertanyaan pertama');
                return;
            }
            setQuestion(prevIdx);
            vm.questionIdx = prevIdx;
        }

        function getLastIndex(data) {
            var lastIndex = 0;
            if (data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                    if (data[i].is_last_index) {
                        lastIndex = i;
                        break;
                    }
                }
            }
            return lastIndex;
        }

        function setLastIndex(idx) {
            vm.scheme.questions.map(function(val) {
                val.is_last_index = false;
            });
            vm.scheme.questions[idx].is_last_index = true;
        }

        function showMessage(status, message) {
            switch (status) {
                case 'success':
                    toastr.success(message);
                    break;
                case 'warning':
                    toastr.warning(message);
                    break;
                case 'error':
                    toastr.error(message);
                    break;
                case 'info':
                    toastr.info(message);
                    break;
            }
        }

        function onAnswerChange() {
            var ctr = 0;

            for (var i = 0; i < vm.activeQuestion.answers.length; i++) {
                var element = vm.activeQuestion.answers[i];
                if (element.checked) {
                    ctr += 1;
                }
            }

            if (ctr > 0) {
                vm.activeQuestion.is_submitted = true;
            } else {
                vm.activeQuestion.is_submitted = false;
            }
        }

        function setCountdownExpired() {
            vm.countdownInterval = $interval(function() {
                vm.countdownExp -= 1;
                if (vm.countdownExp <= 0) {
                    $interval.cancel(vm.countdownInterval);
                    goToMenu();
                }
            }, 1000);
        }

        function goToMenu() {
            $state.go('app.clients.menus');
        }

        $scope.$on('$destroy', function() {
            if (angular.isDefined(vm.countdownInterval)) {
                $interval.cancel(vm.countdownInterval);
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('app.clients.assessment_case_study', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.clients.assessment_case_study', {
            url: '/case_study/{session_id}/{pool_id}/{guide_id}',
            views: {
                client_content: {
                    templateUrl:
                        'app/main/clients/assessment-case-study/assessment-case-study.html',
                    controller: 'AssessmentCaseStudyController as vm'
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.clients.assessment_case_study')
        .controller('AssessmentCaseStudyController', AssessmentCaseStudyController);

    /** @ngInject */
    function AssessmentCaseStudyController(
        $mdToast,
        $state,
        apiService,
        blockUI,
        $localStorage,
        $scope,
        $stateParams,
        $q,
        $mdDialog,
        fuseTheming,
        $rootScope,
        toastr,
        $interval,
        $anchorScroll,
        $location,
        $timeout,
        appConfig,
        $sce
    ) {
        var vm = this;
        var Assessment = apiService.Assessment();
        var alert;
        vm.themes = fuseTheming.themes;
        vm.scheme = {};
        vm.params = {
            session_type: 'case_study',
            pool_id: $stateParams.pool_id,
            session_id: $stateParams.session_id,
            guide_id: $stateParams.guide_id,
        };

        vm.isGuideFinish = false;
        vm.isLoading = false;
        vm.syncDelay = 10000; // in ms
        vm.isSyncRunning = false;
        vm.countdownExp = 30;
        vm.countdownInterval = undefined;
        vm.countdownExpired = undefined;
        vm.displayTimer = '00:00';
        vm.timeIsOver = false;
        vm.goToMenu = goToMenu;
        vm.start = start;
        vm.goToQuestion = goToQuestion;
        vm.submit = submit;
        vm.timeIsOver = false;
        vm.getResource = getResource;
        vm.isSubmit = false;
        vm.isPreparing = false;

        activate();

        function activate() {
            vm.isPreparing = true;
            checkGuideIsRead().then(function (status) {
                if (status) {
                    init();
                }
            });
        }

        function init() {
            vm.isGuideFinish = true;
            loadQuestion()
                .then(initQuestion)
                .catch(function (err) {
                    vm.scheme = {};
                    vm.isPreparing = false;
                });

            $scope.$on('TIMER::TIME_IS_OVER', function (ev, val) {
                vm.timeIsOver = val;
            });
        }

        function start(ev) {
            var confirm = $mdDialog
                .confirm()
                .title('Apakah anda yakin ?')
                .textContent(
                    'Saat test dimulai waktu pengerjaan akan dimulai dan anda tidak dapat kembali lagi'
                )
                .ariaLabel('Start')
                .targetEvent(ev)
                .ok('OK')
                .cancel('NO');

            $mdDialog.show(confirm).then(init);
        }

        function checkGuideIsRead() {
            var defer = $q.defer();
            var request = Assessment.isGuideRead({
                session_id: vm.params.session_id,
            });
            request.$promise.then(function (res) {
                defer.resolve(res.status);
            });
            request.$promise.catch(function () {
                defer.reject(false);
            });
            return defer.promise;
        }

        function loadQuestion() {
            var request = Assessment.question(vm.params);
            return request.$promise;
        }

        function initQuestion(scheme) {
            vm.isPreparing = false;
            vm.scheme = scheme.data;
            vm.remainingTimes = vm.scheme.remaining_times;
            if (!vm.scheme.is_valid) {
                setCountdownExpired();
            } else {
                setCountdownInterval();
            }
        }

        function submit(ev) {
            for (var i = 0; i < vm.scheme.questions.length; i++) {
                if (!vm.scheme.questions[i].answer) {
                    showMessage('error', 'Pertanyaan Belum diisi');
                    return;
                }
            }
            confirmDialog(ev).then(function () {
                saveData();
            });
        }

        function confirmDialog(ev) {
            var message =
                'Jika anda melakukan ini, anda tidak dapat melanjutkan kembali test';
            if (vm.remainingTimes > 60) {
                message =
                    'Anda masih memiliki waktu untuk mengerjakan test, jika anda melakukan ini, anda tidak dapat melanjutkan kembali test';
            }
            var confirm = $mdDialog
                .confirm()
                .title('Apakah anda yakin ?')
                .textContent(message)
                .ariaLabel('Submit')
                .targetEvent(ev)
                .ok('OK')
                .cancel('NO');

            return $mdDialog.show(confirm);
        }

        function saveData() {
            vm.isSubmit = true;
            blockUI.start({ message: 'Submitting' });
            $timeout(function () {
                var request = Assessment.submit(vm.scheme);
                request.$promise.then(function (res) {
                    blockUI.stop();
                    showFinishDialog();
                    vm.isSubmit = false;
                });
                request.$promise.catch(function (res) {
                    showErrorDialog();
                    blockUI.stop();
                    vm.isSubmit = false;
                });
            }, 2000);
        }

        function showErrorDialog() {
            blockUI.stop();
            alert = $mdDialog
                .alert()
                .title('Terjadi kesalahan')
                .textContent(
                    'Essay anda tidak berhasil tersubmit, silahkan check kembali koneksi internet anda'
                )
                .ok('Tutup');

            $mdDialog.show(alert).finally(function () {
                alert = undefined;
                goToMenu();
            });
        }

        function showFinishDialog() {
            blockUI.stop();
            alert = $mdDialog
                .alert()
                .title('Terima kasih')
                .textContent(
                    'Essay anda telah berhasil tersubmit, anda akan segera di alihkan kehalaman menu'
                )
                .ok('Tutup');

            $mdDialog.show(alert).finally(function () {
                alert = undefined;
                goToMenu();
            });
        }

        function showMessage(status, message) {
            switch (status) {
                case 'success':
                    toastr.success(message);
                    break;
                case 'warning':
                    toastr.warning(message);
                    break;
                case 'error':
                    toastr.error(message);
                    break;
                case 'info':
                    toastr.info(message);
                    break;
            }
        }

        function goToMenu() {
            $state.go('app.clients.menus');
        }

        function setCountdownExpired() {
            vm.countdownExpired = $interval(function () {
                vm.countdownExp -= 1;
                if (vm.countdownExp <= 0) {
                    $interval.cancel(vm.countdownExpired);
                    goToMenu();
                }
            }, 1000);
        }

        function setCountdownInterval() {
            vm.countdownInterval = $interval(function () {
                vm.remainingTimes -= 1;
                vm.displayTimer = fmtMSS(vm.remainingTimes);
                if (vm.remainingTimes <= 0) {
                    $interval.cancel(vm.countdownInterval);
                    saveData();
                    return;
                }
                if (vm.remainingTimes % 20 == 0) {
                    if (!vm.isSyncRunning && !vm.isSubmit) {
                        runSync(vm.scheme);
                    }
                }
            }, 1000);
        }

        function runSync(scheme) {
            vm.isSyncRunning = true;
            var request = Assessment.sync(scheme);
            request.$promise.then(function (res) {
                vm.isSyncRunning = false;
                // showMessage('success', 'Progress berhasil tersimpan');
            });
            request.$promise.catch(function (err) {
                vm.isSyncRunning = false;
                showMessage(
                    'error',
                    'Progress gagal tersimpan, mohon pastikan internet anda terhubung'
                );
            });
        }

        $scope.$on('$destroy', function () {
            if (angular.isDefined(vm.countdownInterval)) {
                $interval.cancel(vm.countdownInterval);
            }
            if (angular.isDefined(vm.countdownExpired)) {
                $interval.cancel(vm.countdownExpired);
            }
        });

        function goToQuestion(id) {
            if ($location.hash() !== id) {
                $location.hash(id);
            } else {
                $anchorScroll();
            }
        }

        function fmtMSS(s) {
            if (!s || s <= 0) {
                return '00:00';
            }
            return (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + s;
        }

        function getResource(filename) {
            var token = $localStorage.token;
            var url =
                appConfig.apiUrl +
                'assessment/getResource?filename=' +
                filename +
                '&session_type=case_study&token=' +
                token +
                '&page=hsn#toolbar=0';
            return $sce.trustAsResourceUrl(url);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.account', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.account', {
            url: '/account',
            views: {
                'content@app': {
                    templateUrl: 'app/main/account/account.html',
                    controller: 'AccountController as vm'
                }
            },
            resolve: {
                hasAccess: [
                    '$q',
                    'authService',
                    '$state',
                    function($q, authService, $state) {
                        var defer = $q.defer();
                        authService
                            .hasAccess('app.account')
                            .then(function() {
                                defer.resolve();
                            })
                            .catch(function(state) {
                                $state.go(state.redirectTo);
                                defer.reject();
                            });
                        return defer.promise;
                    }
                ]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.account')
        .controller(
            'ChangePasswordAccountController',
            ChangePasswordAccountController
        );

    ChangePasswordAccountController.$inject = [
        'apiService',
        '$mdDialog',
        'theme',
        'refData',
        '$scope',
        '$timeout',
        '$document'
    ];

    /** @ngInject */
    function ChangePasswordAccountController(
        apiService,
        $mdDialog,
        theme,
        refData,
        $scope,
        $timeout,
        $document
    ) {
        // data
        var vm = this;
        var Account = apiService.Account();
        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.theme = theme;
        vm.form = {};
        vm.data = {
            password: '',
            password_confirmation: ''
        };

        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;

        init();

        function init() {
            vm.data.nik = refData.nik;
            vm.data.name = refData.name;
            vm.data.group = refData.roles.gid;
            vm.data.roles_id = refData.roles.id;
            vm.data.user_id = refData.id;
            initWatcher();
            $timeout(function() {
                vm.isLoading = false;
            }, 1000);
        }

        function submit(ev, form) {
            var request = Account.changePassword(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Submitting Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function setForm(form) {
            vm.form = form;
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element($document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function() {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function initWatcher() {
            $scope.$watch('vm.data.password_confirmation', function(nVal) {
                if (nVal && !angular.equals(vm.form, {})) {
                    if (nVal !== vm.data.password) {
                        vm.form.password_confirmation.$setValidity(
                            'isNotMatch',
                            false
                        );
                    } else {
                        vm.form.password_confirmation.$setValidity(
                            'isNotMatch',
                            true
                        );
                    }
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.account')
        .controller('FormAccountController', FormAccountController);

    FormAccountController.$inject = [
        'apiService',
        '$mdDialog',
        'theme',
        'refData',
        'dialogType',
        '$scope',
        '$timeout',
        '$document'
    ];

    /** @ngInject */
    function FormAccountController(
        apiService,
        $mdDialog,
        theme,
        refData,
        dialogType,
        $scope,
        $timeout,
        $document
    ) {
        // data
        var vm = this;
        var Account = apiService.Account();
        vm.isLoading = true;
        vm.loadingMessage = 'Please Wait';
        vm.errorMessage = '';
        vm.theme = theme;
        vm.form = {};
        vm.dialogType = dialogType;
        vm.listGroup = [
            { id: 1, name: 'super admin' },
            { id: 2, name: 'admin' },
            { id: 3, name: 'user' }
        ];
        vm.data = {
            password: '',
            password_confirmation: ''
        };

        // methods
        vm.setForm = setForm;
        vm.cancel = cancel;
        vm.hide = hide;
        vm.submit = submit;
        vm.update = update;

        init();

        function init() {
            if (vm.dialogType === 'UPDATE') {
                vm.data.nik = refData.nik;
                vm.data.name = refData.name;
                vm.data.group = refData.roles.gid;
                vm.data.roles_id = refData.roles.id;
                vm.data.user_id = refData.id;
                vm.data.email = refData.email;
            } else {
                initWatcher();
            }

            $timeout(function() {
                vm.isLoading = false;
            }, 1000);
        }

        function submit(ev, form) {
            var request = Account.create(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Submitting Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function update(ev, form) {
            var request = Account.update(vm.data);
            vm.isLoading = true;
            vm.loadingMessage = 'Updating Request';
            request.$promise.then(function(res) {
                vm.isLoading = false;
                showDialog(ev, true, res);
            });
            request.$promise.catch(function(err) {
                form.$setPristine();
                form.$setUntouched();
                vm.isLoading = false;
                showDialog(ev, false, err.data);
            });
        }

        function setForm(form) {
            vm.form = form;
        }

        function showDialog(ev, status, response) {
            $mdDialog
                .show(
                    $mdDialog
                        .alert()
                        .parent(angular.element($document.body))
                        .clickOutsideToClose(true)
                        .title(status ? 'Success' : 'Failed')
                        .textContent(response.message)
                        .ariaLabel('Response Dialog')
                        .multiple(true)
                        .ok('OK')
                        .targetEvent(ev)
                )
                .finally(function() {
                    if (status) {
                        hide();
                    } else {
                        vm.errorMessage = response.message;
                    }
                });
        }

        function hide() {
            $mdDialog.hide();
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function initWatcher() {
            $scope.$watch('vm.data.password_confirmation', function(nVal) {
                if (nVal && !angular.equals(vm.form, {})) {
                    if (nVal !== vm.data.password) {
                        vm.form.password_confirmation.$setValidity(
                            'isNotMatch',
                            false
                        );
                    } else {
                        vm.form.password_confirmation.$setValidity(
                            'isNotMatch',
                            true
                        );
                    }
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.case_study.scheme')
        .controller('CaseStudySchemeController', CaseStudySchemeController);

    /** @ngInject */
    function CaseStudySchemeController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $q,
        $sce,
        $state
    ) {
        var vm = this;
        var SchemeCaseStudy = apiService.CaseStudyScheme();
        var Ref = apiService.Reference();
        var Menu = apiService.Menu();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false,
        };
        vm.state = $state.current.name;
        vm.permissionList = [];
        vm.actionPermit = {
            view: false,
            delete: false,
            update: false,
            create: false,
        };

        // method
        vm.onPageChange = onPageChange;
        vm.showDialog = showDialog;
        vm.loadData = loadData;
        vm.uploadDialog = uploadDialog;

        activate();

        function activate() {
            loadPermission().then(function () {
                if (vm.actionPermit.view) {
                    loadData(1);
                } else {
                    vm.pagination.is_loading = false;
                }
            });
        }

        function loadPermission() {
            var defer = $q.defer();
            var request = Menu.getPermissionByState({ state: vm.state });
            request.$promise.then(function (res) {
                vm.permissionList = res;
                setPermission(res);
                defer.resolve();
            });
            request.$promise.catch(function (res) {
                vm.permissionList = [];
                defer.reject();
            });
            return defer.promise;
        }

        function setPermission(permission) {
            permission.map(function (val) {
                for (var key in vm.actionPermit) {
                    if (val.actions == key) {
                        vm.actionPermit[key] = val.checked;
                    }
                }
            });
        }

        function loadData(page) {
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var request = SchemeCaseStudy.view({
                page: page,
                page_size: vm.pagination.page_size,
                search: vm.pagination.search,
            });
            request.$promise.then(function (res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function () {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function (res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function deleteAction(ev, item, isSingle) {
            var ref = [];
            if (isSingle) {
                var message = item.name + ' will be deleted, are you sure ?';
                ref.push(item.id);
            } else {
                ref = [];
            }
            deleteDialog(ev, ref, message);
        }

        function deleteRequest(ref) {
            blockView.start({ message: 'Please wait' });
            var request = SchemeCaseStudy.delete({
                ids: ref,
            });
            request.$promise.then(function (res) {
                blockView.stop();
                showToast(res.message);
                loadData(1);
            });
            request.$promise.catch(function (err) {
                blockView.stop();
                showToast(err.data.message);
                loadData(1);
            });
        }

        function showToast(message) {
            $mdToast.show(
                $mdToast.simple().textContent(message).position('top right')
            );
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function showDialog(ev, type, ref, isSingle) {
            switch (type) {
                case 'UPDATE':
                case 'CREATE':
                    formDialog(ev, type, ref);
                    break;
                case 'DELETE':
                    deleteAction(ev, ref, isSingle);
                    break;
            }
        }

        function formDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'FormCaseStudySchemeController as vm',
                    templateUrl: 'app/main/case-study/scheme/form/form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type,
                    },
                })
                .then(
                    function (res) {
                        loadData(1);
                    },
                    function () {
                        // loadData(1);
                    }
                );
        }

        function uploadDialog(ev) {
            $mdDialog
                .show({
                    controller: 'QuestionUploadController as vm',
                    templateUrl: 'app/main/qa/qa-general/upload/upload.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                    },
                })
                .then(
                    function (res) {
                        loadData(1);
                    },
                    function () {
                        // loadData(1);
                    }
                );
        }

        function deleteDialog(ev, ref, message) {
            var confirm = $mdDialog
                .confirm()
                .title('Delete Confirmation')
                .textContent(message)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function () {
                deleteRequest(ref);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.case_study.question')
        .controller('CaseStudyQuestionController', CaseStudyQuestionController);

    /** @ngInject */
    function CaseStudyQuestionController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $q,
        $sce,
        $state
    ) {
        var vm = this;
        var QuestionCaseStudy = apiService.CaseStudyQuestion();
        var Ref = apiService.Reference();
        var Menu = apiService.Menu();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false,
        };
        vm.state = $state.current.name;
        vm.permissionList = [];
        vm.actionPermit = {
            view: false,
            delete: false,
            update: false,
            create: false,
        };

        // method
        vm.onPageChange = onPageChange;
        vm.showDialog = showDialog;
        vm.loadData = loadData;
        vm.uploadDialog = uploadDialog;

        activate();

        function activate() {
            loadPermission().then(function () {
                if (vm.actionPermit.view) {
                    loadData(1);
                } else {
                    vm.pagination.is_loading = false;
                }
            });
        }

        function loadPermission() {
            var defer = $q.defer();
            var request = Menu.getPermissionByState({ state: vm.state });
            request.$promise.then(function (res) {
                vm.permissionList = res;
                setPermission(res);
                defer.resolve();
            });
            request.$promise.catch(function (res) {
                vm.permissionList = [];
                defer.reject();
            });
            return defer.promise;
        }

        function setPermission(permission) {
            permission.map(function (val) {
                for (var key in vm.actionPermit) {
                    if (val.actions == key) {
                        vm.actionPermit[key] = val.checked;
                    }
                }
            });
        }

        function loadData(page) {
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var request = QuestionCaseStudy.view({
                page: page,
                page_size: vm.pagination.page_size,
                search: vm.pagination.search,
            });
            request.$promise.then(function (res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function () {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function (res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function deleteAction(ev, item, isSingle) {
            var ref = [];
            if (isSingle) {
                var message = item.filename + ' will be deleted, are you sure ?';
                ref.push(item.id);
            } else {
                ref = [];
            }
            deleteDialog(ev, ref, message);
        }

        function deleteRequest(ref) {
            blockView.start({ message: 'Please wait' });
            var request = QuestionCaseStudy.delete({
                ids: ref,
            });
            request.$promise.then(function (res) {
                blockView.stop();
                showToast(res.message);
                loadData(1);
            });
            request.$promise.catch(function (err) {
                blockView.stop();
                showToast(err.data.message);
                loadData(1);
            });
        }

        function showToast(message) {
            $mdToast.show(
                $mdToast.simple().textContent(message).position('top right')
            );
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function showDialog(ev, type, ref, isSingle) {
            switch (type) {
                case 'UPDATE':
                case 'CREATE':
                    formDialog(ev, type, ref);
                    break;
                case 'DELETE':
                    deleteAction(ev, ref, isSingle);
                    break;
            }
        }

        function formDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'FormQuestionCaseStudyController as vm',
                    templateUrl: 'app/main/case-study/question/form/form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type,
                    },
                })
                .then(
                    function (res) {
                        loadData(1);
                    },
                    function () {
                        // loadData(1);
                    }
                );
        }

        function uploadDialog(ev) {
            $mdDialog
                .show({
                    controller: 'QuestionUploadController as vm',
                    templateUrl: 'app/main/qa/qa-general/upload/upload.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                    },
                })
                .then(
                    function (res) {
                        loadData(1);
                    },
                    function () {
                        // loadData(1);
                    }
                );
        }

        function deleteDialog(ev, ref, message) {
            var confirm = $mdDialog
                .confirm()
                .title('Delete Confirmation')
                .textContent(message)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function () {
                deleteRequest(ref);
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.core', [
        'ngAnimate',
        'ngAria',
        'ngCookies',
        'ngMessages',
        'ngResource',
        'ngSanitize',
        'ngMaterial',
        'pascalprecht.translate',
        'ui.router',
        'blockUI',
        'ngStorage',
        'angular-jwt',
        'angularUtils.directives.dirPagination',
        'toastr'
    ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout) {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        vm.blurred = blurred;

        //////////

        // init();

        function init() {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function(current, old) {
                if (angular.isUndefined(current)) {
                    return;
                }

                if (angular.equals(current, old)) {
                    return;
                }

                if (vm.collapsed) {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {
                        query: current
                    }),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = onSearchEvaluated && !!onSearchEvaluated.then;

                if (isArray) {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if (isPromise) {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated
                        .then(
                            // Success
                            function(response) {
                                // Populate the results
                                vm.populateResults(response);
                            },
                            // Error
                            function() {
                                // Assign an empty array to show
                                // the no-results screen
                                vm.populateResults([]);
                            }
                        )
                        .finally(function() {
                            // Hide the loader
                            vm.resultsLoading = false;
                        });
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results) {
            // Before doing anything,
            // make sure the search bar is expanded
            if (vm.collapsed) {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if (!isArray && !isNull) {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand() {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if (vm.onExpand && angular.isFunction(vm.onExpand)) {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse() {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if (vm.onCollapse && angular.isFunction(vm.onCollapse)) {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event) {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event) {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if (keys.indexOf(keyCode) > -1) {
                event.preventDefault();
            }

            switch (keyCode) {
                // Enter
                case 13:
                    // Trigger result click
                    // vm.handleResultClick(vm.results[vm.selectedResultIndex]);
                    $scope.$parent.$eval(vm.onSearch);
                    break;

                // Escape
                case 27:
                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:
                    // Decrease the selected result index
                    if (vm.selectedResultIndex - 1 >= 0) {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:
                    if (!vm.results) {
                        return;
                    }

                    // Increase the selected result index
                    if (vm.selectedResultIndex + 1 < vm.results.length) {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index) {
            if (vm.ignoreMouseEvents) {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents() {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function() {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item) {
            if (vm.onResultClick) {
                vm.onResultClick({ item: item });
            }

            // Collapse the search bar
            // vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible() {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(
                    resultsEl.find('.result')[vm.selectedResultIndex]
                );

            if (resultsEl && selectedItemEl) {
                var top = selectedItemEl.position().top - 8,
                    bottom =
                        selectedItemEl.position().top +
                        selectedItemEl.outerHeight() +
                        8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if (resultsEl.scrollTop() > top) {
                    resultsEl.scrollTop(top);
                }

                if (bottom > resultsEl.height() + resultsEl.scrollTop()) {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Ensure the query field
         * if not empty
         * cannot collapse
         */
        function blurred() {
            if (!vm.query) {
                vm.collapse();
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document) {
        return {
            restrict: 'E',
            scope: {},
            require: 'msSearchBar',
            controller: 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce: '=?',
                onSearch: '@',
                onResultClick: '&?',
                onExpand: '&?',
                onCollapse: '&?',
                query: '=?'
            },
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile: function(tElement) {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement) {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init() {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand() {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse() {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function() {
    'use strict';

    angular.module('app.core').directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective() {
        return {
            restrict: 'E',
            scope: {
                templatePath: '=template',
                card: '=ngModel',
                vm: '=viewModel'
            },
            template:
                '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile: function(tElement) {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement) {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded() {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();

(function() {
    'use strict';

    angular.module('app.unauthorized', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.unauthorized', {
            url: '/unauthorized',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.unauthorized': {
                    templateUrl: 'app/main/unauthorized/unauthorized.html',
                    controller: 'UnauthorizedController as vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.unauthorized')
        .controller('UnauthorizedController', UnauthorizedController);

    UnauthorizedController.$inject = [];

    /** @ngInject */
    function UnauthorizedController() {
        var vm = this;
    }
})();

(function() {
    'use strict';

    angular.module('app.session').controller('SessionController', SessionController);

    /** @ngInject */
    function SessionController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $q,
        $state,
        $document
    ) {
        var vm = this;
        var Session = apiService.Session();
        var Menu = apiService.Menu();
        var blockView = blockUI.instances.get('block-content');
        var alert;
        vm.themes = fuseTheming.themes;
        vm.startDate = new Date();
        vm.endDate = new Date();
        vm.date = 'all';
        vm.listDate = ['all'];
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false
        };
        vm.state = $state.current.name;
        vm.isWaiting = false;
        vm.permissionList = [];
        vm.actionPermit = {
            view: false,
            delete: false,
            update: false,
            create: false,
            upload: false
        };
        vm.selected = [];
        vm.sessionTypes = ['all', 'general', 'papikostik', 'tiki'];
        vm.sessionType = 'all';

        // method
        vm.toggle = toggle;
        vm.exists = exists;
        vm.isIndeterminate = isIndeterminate;
        vm.isChecked = isChecked;
        vm.toggleAll = toggleAll;

        vm.onPageChange = onPageChange;
        vm.showDialog = showDialog;
        vm.loadData = loadData;
        vm.onSendNotification = onSendNotification;
        vm.confirmDialog = confirmDialog;

        activate();

        function activate() {
            loadPermission().then(function() {
                if (vm.actionPermit.view) {
                    loadData(1);
                } else {
                    vm.pagination.is_loading = false;
                }
            });
        }

        function loadPermission() {
            var defer = $q.defer();
            var request = Menu.getPermissionByState({ state: vm.state });
            request.$promise.then(function(res) {
                vm.permissionList = res;
                setPermission(res);
                defer.resolve();
            });
            request.$promise.catch(function() {
                vm.permissionList = [];
                defer.reject();
            });
            return defer.promise;
        }

        function setPermission(permission) {
            permission.map(function(val) {
                for (var key in vm.actionPermit) {
                    if (val.actions == key) {
                        vm.actionPermit[key] = val.checked;
                    }
                }
            });
        }

        function loadData(page) {
            vm.selected = [];
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var tmpStartDate = angular.copy(vm.startDate);
            var tmpEndDate = angular.copy(vm.endDate);
            var request = Session.view({
                page: page,
                start_date: moment(tmpStartDate).format('YYYY-MM-DD'),
                end_date: moment(tmpEndDate).format('YYYY-MM-DD'),
                type: vm.sessionType,
                page_size: vm.pagination.page_size,
                search: vm.pagination.search
            });
            request.$promise.then(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function() {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function deleteAction(ev, item, isSingle) {
            var ref = [];
            if (isSingle) {
                var message = item.name + ' will be deleted, are you sure ?';
                ref.push(item.id);
            } else {
                ref = [];
            }
            deleteDialog(ev, ref, message);
        }

        function deleteRequest(ref) {
            blockView.start({ message: 'Please wait' });
            var request = Session.delete({
                ids: ref
            });
            request.$promise.then(function(res) {
                blockView.stop();
                showToast(res.message);
                loadData(1);
            });
            request.$promise.catch(function(err) {
                blockView.stop();
                showToast(err.data.message);
                loadData(1);
            });
        }

        function showToast(message) {
            $mdToast.show(
                $mdToast
                    .simple()
                    .textContent(message)
                    .position('top right')
            );
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function showDialog(ev, type, ref, isSingle) {
            switch (type) {
                case 'UPDATE':
                case 'CREATE':
                    formDialog(ev, type, ref);
                    break;
                case 'UPLOAD':
                    uploadDialog(ev);
                    break;
                case 'DELETE':
                    deleteAction(ev, ref, isSingle);
                    break;
            }
        }

        function formDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'FormSessionController as vm',
                    templateUrl: 'app/main/session/form/form.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type
                    }
                })
                .then(
                    function() {
                        loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function uploadDialog(ev) {
            $mdDialog
                .show({
                    controller: 'UploadSessionController as vm',
                    templateUrl: 'app/main/session/upload/upload.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name
                    }
                })
                .then(
                    function() {
                        loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function deleteDialog(ev, ref, message) {
            var confirm = $mdDialog
                .confirm()
                .title('Delete Confirmation')
                .textContent(message)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function() {
                deleteRequest(ref);
            });
        }

        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function exists(item, list) {
            return list.indexOf(item) > -1;
        }

        function isIndeterminate() {
            return (
                vm.selected.length !== 0 &&
                vm.selected.length !== vm.pagination.data.length
            );
        }

        function isChecked() {
            return vm.selected.length === vm.pagination.data.length;
        }

        function toggleAll() {
            if (vm.selected.length === vm.pagination.data.length) {
                vm.selected = [];
            } else if (vm.selected.length === 0 || vm.selected.length > 0) {
                vm.selected = vm.pagination.data.slice(0);
            }
        }

        function confirmDialog(ev, isSingle, ref) {
            var msg = 'You will send emails to ';
            if (isSingle) {
                vm.selected.push(ref);
                msg += ref.user.email;
                msg += ' ?';
            } else {
                msg += vm.selected.length + ' participant ?';
            }

            var confirm = $mdDialog
                .confirm()
                .title('Send Notification Confirmation')
                .textContent(msg)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function() {
                onSendNotification();
            });
        }

        function onSendNotification() {
            blockView.start({ message: 'Please wait, sending email' });
            var promises = [];
            var willSend = angular.copy(vm.selected);
            for (var i = 0; i < willSend.length; i++) {
                promises.push(sendNotification(willSend[i].id));
            }
            var allPromises = $q.all(promises);
            allPromises.then(function(results) {
                vm.selected = [];
                var failed = results.filter(function(val) {
                    return val.status === false;
                });
                var success = results.filter(function(val) {
                    return val.status === true;
                });
                blockView.stop();
                showResponse(success, failed);
            });
        }

        function showResponse(success, failed) {
            var msg = 'Success : ' + success.length + ' Failed : ' + failed.length;
            alert = $mdDialog.alert({
                title: 'Response',
                textContent: msg,
                ok: 'Close'
            });

            $mdDialog.show(alert).finally(function() {
                alert = undefined;
            });
        }

        function sendNotification(sessionId) {
            setState(sessionId, true);
            var defer = $q.defer();
            var request = Session.sendNotification({
                session_id: sessionId
            });
            request.$promise.then(function(res) {
                setState(sessionId, false, res);
                defer.resolve({ status: true, sessionId: sessionId, ref: res.data });
            });
            request.$promise.catch(function(err) {
                setState(sessionId, false, err.data);
                defer.resolve({
                    status: false,
                    sessionId: sessionId,
                    ref: err.data
                });
            });

            return defer.promise;
        }

        function setState(sessionId, state, ref) {
            var index = findIndexData(sessionId);

            vm.pagination.data[index].is_waiting = state;

            if (ref) {
                if (ref.data) {
                    vm.pagination.data[index].send_mail = ref.data.send_mail;
                    vm.pagination.data[index].send_mail_at = ref.data.send_mail_at;
                }
            }
        }

        function findIndexData(sessionId) {
            var index = vm.pagination.data.findIndex(function(obj) {
                return obj.id === sessionId;
            });

            return index;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.login', []).config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.login', {
            url: '/login',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.login': {
                    templateUrl: 'app/main/login/login.html',
                    controller: 'LoginController as vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('app.login').controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController(
        $mdToast,
        $state,
        authService,
        blockUI,
        apiService,
        $localStorage,
        $rootScope,
        $q,
        appConfig
    ) {
        var vm = this;
        var blockLogin = blockUI.instances.get('loginForm');
        vm.login = login;
        vm.form = {
            username: '',
            password: ''
        };
        vm.config = appConfig;

        // Methods

        activate();

        function activate() {
            $rootScope.$broadcast('LOGIN::LOADED');
        }

        function login() {
            blockLogin.start({ message: 'Signing In' });
            var request = authService.login(vm.form.username, vm.form.password);
            request.then(function(res) {
                authService.setToken(res.data);
                authService.stateRedirector().then(function(redirector) {
                    if (redirector.state.indexOf('clients') !== -1) {
                        isDone(
                            true,
                            'Redirecting to playground',
                            1000,
                            redirector.state
                        );
                    } else {
                        setMenu(redirector.state);
                    }
                });
            });

            request.catch(function(err) {
                isDone(false, err.data.message, 2000);
            });
        }

        function showAlert(status, message, delay, redirectTo) {
            $mdToast
                .show(
                    $mdToast
                        .simple()
                        .textContent(message)
                        .position('bottom right')
                        .hideDelay(delay)
                )
                .then(function() {
                    if (status) {
                        $state.go(redirectTo);
                    }
                });
        }

        function getMenu() {
            var menu = apiService.Menu();
            var request = menu.getMenu();
            return request.$promise;
        }

        function isDone(status, message, delay, redirectTo) {
            setTimeout(function() {
                showAlert(status, message, delay, redirectTo);
            }, 1000);
            setTimeout(function() {
                blockLogin.stop();
            }, 1000);
        }

        function setMenu(redirector) {
            getMenu()
                .then(function(menu) {
                    $localStorage.menus = menu.data;
                    $rootScope.$broadcast('MENU::LOADED');
                    isDone(
                        true,
                        'Success, Redirecting to Dashboard',
                        1000,
                        redirector
                    );
                })
                .catch(function() {
                    isDone(false, 'You are not registered', 2000, redirector);
                });
        }
    }
})();

(function () {
    'use strict';

    angular.module('app.guides').controller('GuidesController', GuidesController);

    /** @ngInject */
    function GuidesController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $state,
        $q
    ) {
        var vm = this;
        var Guides = apiService.Guides();
        var Menu = apiService.Menu();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.group = 'all';
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false,
        };
        vm.state = $state.current.name;
        vm.permissionList = [];
        vm.actionPermit = {
            view: false,
            delete: false,
            update: false,
            create: false,
        };

        // method
        vm.onPageChange = onPageChange;
        vm.showDialog = showDialog;
        vm.loadData = loadData;
        vm.viewDialog = viewDialog;

        activate();

        function activate() {
            loadPermission().then(function () {
                if (vm.actionPermit.view) {
                    loadData(1);
                } else {
                    vm.pagination.is_loading = false;
                }
            });
        }

        function loadPermission() {
            var defer = $q.defer();
            var request = Menu.getPermissionByState({ state: vm.state });
            request.$promise.then(function (res) {
                vm.permissionList = res;
                setPermission(res);
                defer.resolve();
            });
            request.$promise.catch(function (res) {
                vm.permissionList = [];
                defer.reject();
            });
            return defer.promise;
        }

        function setPermission(permission) {
            permission.map(function (val) {
                for (var key in vm.actionPermit) {
                    if (val.actions == key) {
                        vm.actionPermit[key] = val.checked;
                    }
                }
            });
        }

        function loadData(page) {
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var request = Guides.view({
                page: page,
                page_size: vm.pagination.page_size,
                group: vm.group,
                search: vm.pagination.search,
            });
            request.$promise.then(function (res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function () {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function (res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function deleteAction(ev, item, isSingle) {
            var ref = [];
            if (isSingle) {
                var message = item.title + ' will be deleted, are you sure ?';
                ref.push(item.id);
            } else {
                ref = [];
            }
            deleteDialog(ev, ref, message);
        }

        function deleteRequest(ref) {
            blockView.start({ message: 'Please wait' });
            var request = Guides.delete({
                ids: ref,
            });
            request.$promise.then(function (res) {
                blockView.stop();
                showToast(res.message);
                loadData(1);
            });
            request.$promise.catch(function (err) {
                blockView.stop();
                showToast(err.data.message);
                loadData(1);
            });
        }

        function showToast(message) {
            $mdToast.show(
                $mdToast.simple().textContent(message).position('top right')
            );
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function showDialog(ev, type, ref, isSingle) {
            switch (type) {
                case 'UPDATE':
                case 'CREATE':
                    formDialog(ev, type, ref);
                    break;
                case 'DELETE':
                    deleteAction(ev, ref, isSingle);
                    break;
            }
        }

        function formDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'FormGuidesController as vm',
                    templateUrl: 'app/main/guides/form/form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type,
                    },
                })
                .then(
                    function (res) {
                        loadData(1);
                    },
                    function () {
                        // loadData(1);
                    }
                );
        }

        function viewDialog(ev, item) {
            ev.preventDefault();
            $mdDialog
                .show({
                    controller: 'ViewGuidesController as vm',
                    templateUrl: 'app/main/guides/view/view.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: item,
                    },
                })
                .then(
                    function (res) {
                        loadData(1);
                    },
                    function () {
                        // loadData(1);
                    }
                );
        }

        function deleteDialog(ev, ref, message) {
            var confirm = $mdDialog
                .confirm()
                .title('Delete Confirmation')
                .textContent(message)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function () {
                deleteRequest(ref);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);

    DashboardController.$inject = [
        '$q',
        'apiService',
        '$timeout',
        'blockUI',
        '$state',
        '$mdDialog',
        'fuseTheming'
    ];

    /** @ngInject */
    function DashboardController(
        $q,
        apiService,
        $timeout,
        blockUI,
        $state,
        $mdDialog,
        fuseTheming
    ) {
        var vm = this;
        var Dashboard = apiService.Dashboard();
        var blockLatestSubmit = blockUI.instances.get('block-latest-submit');
        var blockMostQuestion = blockUI.instances.get('block-most-question');
        var blockChart = blockUI.instances.get('block-chart');
        vm.themes = fuseTheming.themes;
        var date = new Date();
        vm.isLoading = {
            widget: false,
            questionStats: false
        };
        vm.questionStats = {
            correct: [],
            incorrect: []
        };

        vm.date = moment(date)
            .locale('id')
            .format('YYYY-MM-DD hh:mm:ss');

        vm.widget = {
            active_session: 0,
            percentage_finished: 0,
            percentage_in_init: 0,
            percentage_in_progress: 0,
            percentage_total_user_online: 0,
            percentage_total_user_test: 0,
            today_finished: 0,
            today_in_init: 0,
            today_in_progress: 0,
            total_user: 0,
            total_user_online: 0,
            total_user_taken_test: 0,
            total_user_test: 0
        };

        vm.paginationSubmit = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 5,
            is_loading: true,
            is_error: false
        };

        vm.userStats = {
            labels: [],
            data: []
        };

        vm.chartOptions = {
            legend: {
                display: true
            },
            layout: {
                padding: {
                    left: 50,
                    right: 10,
                    top: 20,
                    bottom: 20
                }
            },
            title: {
                display: true,
                text: 'Total Participant Statistics'
            }
        };

        vm.getPercentage = getPercentage;
        vm.reloadData = reloadData;
        vm.onPageChange = onPageChange;
        vm.goToDetail = goToDetail;
        vm.showDialog = showDialog;

        activate();

        function activate() {
            loadWidget()
                .then(loadData.bind(1))
                .then(loadQuestionStats)
                .then(loadChartUserStats)
                .then(function() {});
        }

        function reloadData() {
            loadQuestionStats();
            loadWidget().then(function() {
                var dt = new Date();
                vm.date = moment(dt)
                    .locale('id')
                    .format('YYYY-MM-DD hh:mm:ss');
            });
            loadChartUserStats();
        }

        function loadWidget() {
            vm.isLoading.widget = true;
            var defer = $q.defer();
            var dt = moment(date).format('YYYY-MM-DD');
            var request = Dashboard.loadWidget({ date: dt });
            request.$promise.then(function(res) {
                vm.widget = res.data;
                vm.isLoading.widget = false;
                defer.resolve();
            });
            request.$promise.catch(function() {
                vm.isLoading.widget = false;
                vm.widget = {
                    active_session: 0,
                    percentage_finished: 0,
                    percentage_in_init: 0,
                    percentage_in_progress: 0,
                    percentage_total_user_online: 0,
                    percentage_total_user_test: 0,
                    today_finished: 0,
                    today_in_init: 0,
                    today_in_progress: 0,
                    total_user: 0,
                    total_user_online: 0,
                    total_user_taken_test: 0,
                    total_user_test: 0
                };
                defer.reject();
            });
            return defer.promise;
        }

        function loadData(page) {
            vm.paginationSubmit.current = page;
            vm.paginationSubmit.is_loading = true;
            blockLatestSubmit.start({ message: 'Please wait' });
            var dt = moment(date).format('YYYY-MM-DD');
            var request = Dashboard.loadLatestSubmit({
                page: page,
                page_size: vm.paginationSubmit.page_size,
                date: dt,
                search: vm.paginationSubmit.search
            });
            request.$promise.then(function(res) {
                vm.paginationSubmit.page_size = res.per_page;
                vm.paginationSubmit.from = res.from;
                vm.paginationSubmit.data = res.data;
                vm.paginationSubmit.total = res.total;
                vm.paginationSubmit.is_error = false;
                $timeout(function() {
                    vm.paginationSubmit.is_loading = false;
                    blockLatestSubmit.stop();
                }, 1000);
            });
            request.$promise.catch(function(res) {
                blockLatestSubmit.stop();
                vm.paginationSubmit.page_size = res.per_page;
                vm.paginationSubmit.from = res.from;
                vm.paginationSubmit.data = res.data;
                vm.paginationSubmit.total = res.total;
                vm.paginationSubmit.is_loading = false;
                vm.paginationSubmit.is_error = true;
            });

            return request.$promise;
        }

        function loadChartUserStats() {
            var defer = $q.defer();
            var request = Dashboard.getChartUserStats();
            blockChart.start({ message: 'Please wait' });
            request.$promise.then(function(res) {
                defer.resolve();
                vm.userStats = res;
                blockChart.stop();
            });
            request.$promise.catch(function(res) {
                defer.reject();
                vm.userStats = {
                    labels: [],
                    data: []
                };
                blockChart.stop();
            });
            return defer.promise;
        }

        function loadQuestionStats() {
            var defer = $q.defer();
            var request = Dashboard.getQuestionStats();
            vm.isLoading.questionStats = true;
            blockMostQuestion.start({ message: 'Please wait' });
            request.$promise.then(function(stats) {
                defer.resolve();
                vm.questionStats = stats;
                vm.isLoading.questionStats = false;
                $timeout(function() {
                    blockMostQuestion.stop();
                }, 1000);
            });
            request.$promise.catch(function(stats) {
                vm.questionStats = {
                    correct: [],
                    incorrect: []
                };
                defer.reject();
                vm.isLoading.questionStats = false;
                $timeout(function() {
                    blockMostQuestion.stop();
                }, 1000);
            });
            return defer.promise;
        }

        function getPercentage(item, divider) {
            if (divider == 0) {
                return 0;
            }
            return (item / divider) * 100;
        }

        function onPageChange(pageNumber) {
            loadData(pageNumber);
        }

        function goToDetail(item) {
            $state.go('app.report_general_detail', { achievement_id: item.id });
        }

        function showDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'ViewUserDashboardController as vm',
                    templateUrl: 'app/main/dashboard/view-user/view-user.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type
                    }
                })
                .then(
                    function(res) {
                        // loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.clients').controller('ClientsController', ClientsController);

    /** @ngInject */
    function ClientsController($state, $rootScope, $localStorage) {
        var vm = this;
        vm.reloadScheme = reloadScheme;
        vm.logout = logout;
        vm.name = $localStorage.username ? $localStorage.username : 'Guest';

        init();

        function init() {}

        function reloadScheme() {
            $rootScope.$broadcast('GENERAL::QUESTION_RELOAD');
        }

        function logout() {
            $state.go('app.login');
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.account').controller('AccountController', AccountController);

    AccountController.$inject = [
        'apiService',
        'fuseTheming',
        '$mdDialog',
        '$timeout',
        'blockUI',
        '$mdToast',
        '$state',
        '$q',
        '$document'
    ];

    /** @ngInject */
    function AccountController(
        apiService,
        fuseTheming,
        $mdDialog,
        $timeout,
        blockUI,
        $mdToast,
        $state,
        $q,
        $document
    ) {
        var vm = this;
        var Account = apiService.Account();
        var Menu = apiService.Menu();
        var blockView = blockUI.instances.get('block-content');
        vm.themes = fuseTheming.themes;
        vm.group = 'all';
        vm.pagination = {
            current: 1,
            from: 1,
            total: 0,
            load: loadData,
            search: '',
            data: [],
            page_size: 20,
            is_loading: true,
            is_error: false
        };
        vm.state = $state.current.name;
        vm.permissionList = [];
        vm.actionPermit = {
            view: false,
            delete: false,
            update: false,
            changePassword: false,
            upload: false,
            create: false
        };

        // method
        vm.onPageChange = onPageChange;
        vm.showDialog = showDialog;
        vm.loadData = loadData;
        vm.changePassword = changePassword;

        activate();

        function activate() {
            loadPermission().then(function() {
                if (vm.actionPermit.view) {
                    loadData(1);
                } else {
                    vm.pagination.is_loading = false;
                }
            });
        }

        function loadPermission() {
            var defer = $q.defer();
            var request = Menu.getPermissionByState({ state: vm.state });
            request.$promise.then(function(res) {
                vm.permissionList = res;
                setPermission(res);
                defer.resolve();
            });
            request.$promise.catch(function() {
                vm.permissionList = [];
                defer.reject();
            });
            return defer.promise;
        }

        function setPermission(permission) {
            permission.map(function(val) {
                for (var key in vm.actionPermit) {
                    if (val.actions == key) {
                        vm.actionPermit[key] = val.checked;
                    }
                }
            });
        }

        function loadData(page) {
            vm.pagination.current = page;
            vm.pagination.is_loading = true;
            var request = Account.view({
                page: page,
                page_size: vm.pagination.page_size,
                group: vm.group,
                search: vm.pagination.search
            });
            request.$promise.then(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_error = false;
                $timeout(function() {
                    vm.pagination.is_loading = false;
                }, 1000);
            });
            request.$promise.catch(function(res) {
                vm.pagination.from = res.from;
                vm.pagination.data = res.data;
                vm.pagination.total = res.total;
                vm.pagination.is_loading = false;
                vm.pagination.is_error = true;
            });

            return request.$promise;
        }

        function deleteAction(ev, item, isSingle) {
            var ref = [];
            if (isSingle) {
                var message = item.nik + ' will be deleted, are you sure ?';
                ref.push(item.id);
            } else {
                ref = [];
            }
            deleteDialog(ev, ref, message);
        }

        function deleteRequest(ref) {
            blockView.start({ message: 'Please wait' });
            var request = Account.delete({
                ids: ref
            });
            request.$promise.then(function(res) {
                blockView.stop();
                showToast(res.message);
                loadData(1);
            });
            request.$promise.catch(function(err) {
                blockView.stop();
                showToast(err.data.message);
                loadData(1);
            });
        }

        function showToast(message) {
            $mdToast.show(
                $mdToast
                    .simple()
                    .textContent(message)
                    .position('top right')
            );
        }

        function onPageChange(pageNumber) {
            vm.pagination.current = pageNumber;
            loadData(pageNumber);
        }

        function showDialog(ev, type, ref, isSingle) {
            switch (type) {
                case 'UPDATE':
                case 'CREATE':
                    formDialog(ev, type, ref);
                    break;
                case 'DELETE':
                    deleteAction(ev, ref, isSingle);
                    break;
            }
        }

        function formDialog(ev, type, ref) {
            $mdDialog
                .show({
                    controller: 'FormAccountController as vm',
                    templateUrl: 'app/main/account/form/form.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref,
                        dialogType: type
                    }
                })
                .then(
                    function() {
                        loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function changePassword(ev, ref) {
            $mdDialog
                .show({
                    controller: 'ChangePasswordAccountController as vm',
                    templateUrl:
                        'app/main/account/change-password/change-password.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true,
                    multiple: true,
                    locals: {
                        theme: vm.themes.active.name,
                        refData: ref
                    }
                })
                .then(
                    function() {
                        loadData(1);
                    },
                    function() {
                        // loadData(1);
                    }
                );
        }

        function deleteDialog(ev, ref, message) {
            var confirm = $mdDialog
                .confirm()
                .title('Delete Confirmation')
                .textContent(message)
                .ariaLabel('delete dialog')
                .targetEvent(ev)
                .ok('YES')
                .cancel('NO');

            $mdDialog.show(confirm).then(function() {
                deleteRequest(ref);
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.core').config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes) {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies',
            function(_$cookies) {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if (customTheme) {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function(palette) {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function(theme, themeName) {
            $mdThemingProvider
                .theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }
})();

(function() {
    'use strict';

    var fuseThemes = {
        default: {
            primary: {
                name: 'fuse-paleblue',
                hues: {
                    default: '700',
                    'hue-1': '500',
                    'hue-2': '600',
                    'hue-3': 'A100'
                }
            },
            accent: {
                name: 'light-blue',
                hues: {
                    default: '600',
                    'hue-1': '400',
                    'hue-2': '700',
                    'hue-3': 'A100'
                }
            },
            warn: {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    default: 'A100',
                    'hue-1': 'A100',
                    'hue-2': '100',
                    'hue-3': '300'
                }
            }
        },
        pinkTheme: {
            primary: {
                name: 'blue-grey',
                hues: {
                    default: '900',
                    'hue-1': '700',
                    'hue-2': '600',
                    'hue-3': 'A100'
                }
            },
            accent: {
                name: 'pink',
                hues: {
                    default: '600',
                    'hue-1': '400',
                    'hue-2': '700',
                    'hue-3': 'A100'
                }
            },
            warn: {
                name: 'brown',
                hues: {
                    default: '500',
                    'hue-1': '300',
                    'hue-2': '800',
                    'hue-3': 'A100'
                }
            },
            background: {
                name: 'grey',
                hues: {
                    default: 'A100',
                    'hue-1': 'A100',
                    'hue-2': '100',
                    'hue-3': '300'
                }
            }
        },
        tealTheme: {
            primary: {
                name: 'blue-grey',
                hues: {
                    default: '900',
                    'hue-1': '600',
                    'hue-2': '500',
                    'hue-3': 'A100'
                }
            },
            accent: {
                name: 'teal',
                hues: {
                    default: '500',
                    'hue-1': '400',
                    'hue-2': '600',
                    'hue-3': 'A100'
                }
            },
            warn: {
                name: 'deep-orange',
                hues: {
                    default: '500',
                    'hue-1': '300',
                    'hue-2': '800',
                    'hue-3': 'A100'
                }
            },
            background: {
                name: 'grey',
                hues: {
                    default: 'A100',
                    'hue-1': 'A100',
                    'hue-2': '100',
                    'hue-3': '300'
                }
            }
        },
        redTheme: {
            primary: {
                name: 'blue-grey',
                hues: {
                    default: '900',
                    'hue-1': '700',
                    'hue-2': '600',
                    'hue-3': 'A100'
                }
            },
            accent: {
                name: 'red',
                hues: {
                    default: '600',
                    'hue-1': '400',
                    'hue-2': '700',
                    'hue-3': 'A100'
                }
            },
            warn: {
                name: 'amber',
                hues: {
                    default: '500',
                    'hue-1': '300',
                    'hue-2': '800',
                    'hue-3': 'A100'
                }
            },
            background: {
                name: 'grey',
                hues: {
                    default: 'A100',
                    'hue-1': 'A100',
                    'hue-2': '100',
                    'hue-3': '300'
                }
            }
        }
    };

    angular.module('app.core').constant('fuseThemes', fuseThemes);
})();

(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function() {
    'use strict';

    angular.module('app.core').factory('authService', AuthService);

    /** @ngInject */
    function AuthService($localStorage, $location, jwtHelper, apiService, $q) {
        var environment = {
            AP: 2,
            AS: 3,
            BP: 2,
            BS: 1,
            CP: 1,
            CS: 2,
        };

        var service = {
            login: login,
            refreshToken: refreshToken,
            logout: logout,
            isAuthenticated: isAuthenticated,
            setToken: setToken,
            getToken: getToken,
            clearToken: clearToken,
            stateRedirector: stateRedirector,
            hasAccess: hasAccess,
            redirectToLogin: redirectToLogin,
            generateNewToken: generateNewToken,
            _unwrapToken: _unwrapToken
        };

        return service;

        function isAuthenticated() {
            return typeof $localStorage.token !== 'undefined';
        }

        function login(username, password) {
            var auth = apiService.Auth();
            var request = auth.login({
                username: username,
                password: password
            });
            return request.$promise;
        }

        function refreshToken() {
            var auth = apiService.Auth();
            var request = auth.refresh({
                token: getToken()
            });
            return request.$promise;
        }

        function logout() {
            var auth = apiService.Auth();
            var request = auth.logout({
                token: getToken()
            });
            request.$promise.then(redirectToLogin);
            request.$promise.catch(redirectToLogin);
            return true;
        }

        function setToken(token) {
            try {
                var decoded = jwtHelper.decodeToken(token);
                var data = decoded.data;
                Object.keys(data).forEach(function(key) {
                    $localStorage[key] = data[key];
                });
                $localStorage.token = token;
                return true;
            } catch (error) {
                console.log('setToken', error);
                return false;
            }
        }

        function getToken() {
            var token = angular.copy($localStorage.token);
            return token;
        }

        function clearToken() {
            delete $localStorage.token;
        }

        function redirectToLogin() {
            $location.path('/login');
        }

        function stateRedirector() {
            var auth = apiService.Auth();
            var request = auth.stateRedirector();
            return request.$promise;
        }

        function hasAccess(state) {
            var defer = $q.defer();
            if (!isAuthenticated()) {
                defer.reject({ redirectTo: 'app.login' });
            } else {
                var auth = apiService.Auth();
                var request = auth.hasAccess({ state: state });
                request.$promise.then(function(res) {
                    defer.resolve();
                });
                request.$promise.catch(function() {
                    defer.reject({ redirectTo: 'app.unauthorized' });
                });
            }
            return defer.promise;
        }

        function generateNewToken(params) {
            var defer = $q.defer();
            var auth = apiService.Auth();
            var request = auth.getNewToken({
                token: params.token,
                mainAppID: params.mainAppID,
                username: params.username,
                menuID: params.menuID,
            });
            request.$promise.then(function (success) {
                defer.resolve({token: success.data});
                console.log(success);
            });
            request.$promise.catch(function (error) {
                defer.reject({token: null});
                console.log(error);
            });
            return defer.promise;
        }

        function _unwrapToken(token) {
            var tokenPart = token.split('.');
            var header = _removePS(tokenPart[0], environment.AP, environment.AS);
            var payload = _removePS(tokenPart[1], environment.BP, environment.BS);
            var sign = _removePS(tokenPart[2], environment.CP, environment.CS);
            return header + '.' + payload + '.' + sign;
        }

        function _removePS(str, pre, suf) {
            var totWrapper = pre + suf;
            var total = str.length - totWrapper;
            return str.substr(pre, total);
        }
    }
})();

(function() {
  'use strict';

  angular.module('app.core').factory('apiResolver', apiResolverService);

  /** @ngInject */
  function apiResolverService($q, $log, api) {
    var service = {
      resolve: resolve
    };

    return service;

    //////////
    /**
     * Resolve api
     * @param action
     * @param parameters
     */
    function resolve(action, parameters) {
      var actionParts = action.split('@'),
        resource = actionParts[0],
        method = actionParts[1],
        params = parameters || {};

      if (!resource || !method) {
        $log.error(
          'apiResolver.resolve requires correct action parameter (ResourceName@methodName)'
        );
        return false;
      }

      // Create a new deferred object
      var deferred = $q.defer();

      // Get the correct api object from api service
      var apiObject = getApiObject(resource);

      if (!apiObject) {
        $log.error('Resource "' + resource + '" is not defined in the api service!');
        deferred.reject(
          'Resource "' + resource + '" is not defined in the api service!'
        );
      } else {
        apiObject[method](
          params,

          // Success
          function(response) {
            deferred.resolve(response);
          },

          // Error
          function(response) {
            deferred.reject(response);
          }
        );
      }

      // Return the promise
      return deferred.promise;
    }

    /**
     * Get correct api object
     *
     * @param resource
     * @returns {*}
     */
    function getApiObject(resource) {
      // Split the resource in case if we have a dot notated object
      var resourceParts = resource.split('.'),
        apiObject = api;

      // Loop through the resource parts and go all the way through
      // the api object and return the correct one
      for (var l = 0; l < resourceParts.length; l++) {
        if (angular.isUndefined(apiObject[resourceParts[l]])) {
          $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
          apiObject = false;
          break;
        }

        apiObject = apiObject[resourceParts[l]];
      }

      if (!apiObject) {
        return false;
      }

      return apiObject;
    }
  }
})();

(function() {
    angular.module('app.core').directive('viewPdf', function() {
        return {
            restrict: 'E',
            link: function(scope, element, attrs) {
                var url = scope.$eval(attrs.src);
                element.replaceWith(
                    '<object type="application/pdf" data="' + url + '"></object>'
                );
            }
        };
    });
})();

(function() {
    angular.module('app.core').directive('onErrorSrc', function() {
        return {
            link: function(scope, element, attrs) {
                element.bind('error', function() {
                    if (attrs.src != attrs.onErrorSrc) {
                        attrs.$set('src', attrs.onErrorSrc);
                    }
                });
            }
        };
    });
})();

(function() {
    angular.module('app.core').directive('lazyLoadMedia', lazyLoadMedia);

    function lazyLoadMedia() {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                loader: '=',
                filename: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            var spinner = 'assets/images/loader.svg';

            function setupImage() {
                element.attr('src', spinner);
                element.addClass('loading-images');
                scope.loader(scope.filename).then(function(url) {
                    element.attr('src', url);
                    element.removeClass('loading-images');
                    element.addClass('rendered-images');
                });
            }

            scope.$watch('filename', function(oldValue, newValue) {
                if (newValue) {
                    setupImage();
                }
            });
        }
    }
})();

(function() {
    angular.module('app.core').directive('imageonload', [
        '$timeout',
        function($timeout) {
            return {
                link: function($scope, element, attrs) {
                    function waitForImage(url) {
                        var tempImg = new Image();
                        tempImg.onload = function() {
                            $timeout(function() {
                                element.attr('src', url);
                            });
                        };
                        tempImg.onerror = function() {
                            $timeout(function() {
                                element.attr(
                                    'src',
                                    'assets/images/avatars/profile.jpg'
                                );
                            });
                        };
                        tempImg.src = url;
                    }

                    attrs.$observe('imageonload', function(newValue) {
                        if (newValue) {
                            waitForImage(newValue);
                        }
                    });
                }
            };
        }
    ]);
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter)
        .filter('titleCase', titleCase)
        .filter('trustResourceUrl', trustResourceUrl);

    /** @ngInject */
    function toTrustedFilter($sce) {
        return function(value) {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter() {
        return function(text) {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter() {
        return function(value) {
            return !value ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter() {
        return function(doc) {
            if (!doc) {
                return;
            }
            if (doc.type === 'directive') {
                return doc.name.replace(/([A-Z])/g, function($1) {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

    /** @ngInject */
    function titleCase() {
        return function(input) {
            input = input || '';
            return input.replace(/\w\S*/g, function(txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
        };
    }

    /** @ngInject */
    function trustResourceUrl($sce) {
        return function(val) {
            return $sce.trustAsResourceUrl(val);
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function() {
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, appConfig) {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };
        vm.appTitle = appConfig.appTitle;

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded() {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function() {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function() {
    'use strict';

    angular.module('app.toolbar').controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController(
        $rootScope,
        $q,
        $state,
        $timeout,
        $mdSidenav,
        $translate,
        $mdToast,
        msNavigationService,
        authService,
        fuseTheming,
        $cookies,
        $scope,
        $localStorage
    ) {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                title: 'Online',
                icon: 'icon-checkbox-marked-circle',
                color: '#4CAF50'
            },
            {
                title: 'Away',
                icon: 'icon-clock',
                color: '#FFC107'
            },
            {
                title: 'Do not Disturb',
                icon: 'icon-minus-circle',
                color: '#F44336'
            },
            {
                title: 'Invisible',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#BDBDBD'
            },
            {
                title: 'Offline',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#616161'
            }
        ];
        vm.languages = {
            en: {
                title: 'English',
                translation: 'TOOLBAR.ENGLISH',
                code: 'en',
                flag: 'us'
            },
            id: {
                title: 'Bahasa',
                translation: 'TOOLBAR.BAHASA',
                code: 'id',
                flag: 'id'
            }
        };

        vm.userName = $localStorage.username;
        vm.groupName = $localStorage.group;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.theme = $cookies.get('selectedTheme') || fuseTheming.themes.active.name;

        $scope.$watch(
            function() {
                return $cookies.get('selectedTheme');
            },
            function(val) {
                vm.theme = val;
            }
        );

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout() {
            authService.logout();
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            // if (lang.code !== 'en') {
            //     var message =
            //         'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

            //     $mdToast.show({
            //         template:
            //             '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' +
            //             message +
            //             '</div></md-toast>',
            //         hideDelay: 7000,
            //         position: 'top right',
            //         parent: '#content'
            //     });

            //     return;
            // }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query) {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if (query) {
                navigation = navigation.filter(function(item) {
                    if (
                        angular
                            .lowercase(item.title)
                            .search(angular.lowercase(query)) > -1
                    ) {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function() {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                } else {
                    $state.go(item.state);
                }
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function () {
    'use strict';

    angular
        .module('assessmentapp', [
            'app.core',
            'textAngular',
            'app.navigation',
            'app.toolbar',
            'app.quick-panel',
            'app.login',
            'app.dashboard',
            'app.account',
            'app.qa',
            'app.clients',
            'app.session',
            'app.report',
            'app.utility',
            'app.unauthorized',
            'app.gates',
            'app.survey',
            'app.case_study',
            'app.guides',
        ])
        .config(config);

    function config() {}
})();

(function() {
    'use strict';

    angular.module('assessmentapp').controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope) {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function(event) {
            if (event.targetScope.$id === $scope.$id) {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('app.core').run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig) {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if (
            fuseConfig.getConfig('disableMdInkRippleOnMobile') &&
            msUtils.isMobile()
        ) {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if (msUtils.isMobile()) {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if (browserInfo) {
            var htmlClass =
                browserInfo.browser +
                ' ' +
                browserInfo.version +
                ' ' +
                browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.core').config(config);

    /** @ngInject */
    function config(
        $ariaProvider,
        $logProvider,
        msScrollConfigProvider,
        fuseConfigProvider
    ) {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: true
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            disableCustomScrollbars: false,
            disableCustomScrollbarsOnMobile: true,
            disableMdInkRippleOnMobile: true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();

(function() {
    'use strict';

    angular.module('assessmentapp').run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state) {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function() {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on(
            '$stateChangeSuccess',
            function() {
                $timeout(function() {
                    $rootScope.loadingProgress = false;
                });
            }
        );

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function() {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();

/* eslint-disable no-unused-vars */
(function() {
    'use strict';

    angular.module('assessmentapp').config(routeConfig);

    /** @ngInject */
    function routeConfig(
        $stateProvider,
        $urlRouterProvider,
        $locationProvider,
        $httpProvider
    ) {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies',
            function(_$cookies) {
                $cookies = _$cookies;
            }
        ]);

        $httpProvider.interceptors.push('AuthInterceptor');

        // Get active layout
        var layoutStyle = 'verticalNavigation';

        var layouts = {
            verticalNavigation: {
                main: 'app/core/layouts/vertical-navigation.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation:
                    'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar:
                    'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation:
                    'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2: {
                main:
                    'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar:
                    'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation:
                    'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main: 'app/core/layouts/horizontal-navigation.html',
                toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation:
                    'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly: {
                main: 'app/core/layouts/content-only.html',
                toolbar: '',
                navigation: ''
            },
            contentWithToolbar: {
                main: 'app/core/layouts/content-with-toolbar.html',
                toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'main@': {
                    templateUrl: layouts[layoutStyle].main,
                    controller: 'MainController as vm'
                },
                'toolbar@app': {
                    templateUrl: layouts[layoutStyle].toolbar,
                    controller: 'ToolbarController as vm'
                },
                'navigation@app': {
                    templateUrl: layouts[layoutStyle].navigation,
                    controller: 'NavigationController as vm'
                },
                'quickPanel@app': {
                    templateUrl: 'app/quick-panel/quick-panel.html',
                    controller: 'QuickPanelController as vm'
                }
            }
        });
    }
})();

/* eslint-disable angular/di */
(function() {
    'use strict';
    angular.module('assessmentapp').factory('AuthInterceptor', [
        '$q',
        '$injector',
        function($q, $injector) {
            var cachedRequest = null;
            return {
                request: function(config) {
                    // If request need credentials
                    if (angular.isDefined(config.withCredentials)) {
                        if (config.withCredentials) {
                            var accessToken = $injector
                                .get('authService')
                                .getToken();
                            config.headers['Authorization'] =
                                'Bearer ' + accessToken;
                        }
                    }
                    return config;
                },
                responseError: function(response) {
                    switch (response.status) {
                        //Detect if reponse error is 401 (Unauthorized)
                        case 401:
                            //Cache this request
                            var deferred = $q.defer();

                            // check if there is token in storage
                            var authenticated = $injector
                                .get('authService')
                                .isAuthenticated();

                            // if no token then redirect to login
                            if (!authenticated) {
                                deferred.reject({ message: 'Unauthorized' });
                                $injector.get('authService').redirectToLogin();
                            }

                            if (!cachedRequest) {
                                //Cache request for renewing Access Token and wait for Promise
                                cachedRequest = $injector
                                    .get('authService')
                                    .refreshToken();
                            }
                            //When Promise is resolved, new Access Token is returend
                            cachedRequest.then(function(accessToken) {
                                cachedRequest = null;
                                if (accessToken) {
                                    $injector
                                        .get('authService')
                                        .setToken(accessToken.data);
                                    //Resend this request when Access Token is renewed
                                    $injector
                                        .get('$http')(response.config)
                                        .then(
                                            function(resp) {
                                                //Resolve this request (successfully this time)
                                                deferred.resolve(resp);
                                            },
                                            function() {
                                                deferred.reject({
                                                    message: 'Unauthorized'
                                                });
                                            }
                                        );
                                } else {
                                    //If any error occurs reject the Promise
                                    deferred.reject();
                                }
                            });
                            cachedRequest.catch(function() {
                                //If any error occurs reject the Promise
                                cachedRequest = null;
                                $injector.get('authService').redirectToLogin();
                                deferred.reject({ message: 'Unauthorized' });
                                return;
                            });
                            return deferred.promise;
                    }
                    //If any error occurs reject the Promise
                    return $q.reject(response);
                }
            };
        }
    ]);
})();

(function() {
    'use strict';

    angular.module('assessmentapp').controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(
        fuseTheming,
        msNavigationService,
        $scope,
        $localStorage,
        $q
    ) {
        var vm = this;

        fuseTheming.setActiveTheme('tealTheme');

        vm.themes = fuseTheming.themes;

        initMenu();

        $scope.$on('MENU::LOADED', function() {
            initMenu();
        });

        $scope.$on('LOGIN::LOADED', function() {
            resetMenu();
        });

        function initMenu() {
            if (angular.isDefined($localStorage.menus)) {
                var menu = angular.copy($localStorage.menus);
                menu.map(function(val) {
                    setMenu(val);
                });
            }
        }

        function setMenu(params) {
            var options = {
                title: params.title,
                translate: params.translate,
                weight: params.weight,
                icon: params.icon,
                group: false
            };
            if (params.is_group == 0) {
                options.state = params.state;
            }
            msNavigationService.saveItem(params.name, options);
        }

        function resetMenu() {
            function deleteMenu() {
                var defer = $q.defer();
                if (angular.isDefined($localStorage.menus)) {
                    var menu = angular.copy($localStorage.menus);
                    menu.map(function(val) {
                        msNavigationService.deleteItem(val.name);
                    });
                    defer.resolve();
                } else {
                    defer.resolve();
                }
                return defer.promise;
            }

            deleteMenu().then(function() {
                $localStorage.$reset();
            });
        }

        //////////
    }
})();

(function () {
    'use strict';

    angular.module('assessmentapp').constant('appConfig', {
        appTitle: 'PAS Assessment',
        appName: 'PAS Assessment',
        appDesc: 'PAS Assessment Tools',
        appVersion: 'v2',
        apiUrl: '/api/public/api/v2/',
        port: '',
    });
})();

(function() {
    'use strict';

    angular.module('assessmentapp').config(config);

    /** @ngInject */
    function config($translateProvider, blockUIConfig, $provide) {
        // Put your common app configurations here

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'app/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        blockUIConfig.message = 'Please wait';
        blockUIConfig.delay = 300;
        blockUIConfig.autoBlock = false;

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate',
            function(taOptions) {
                taOptions.toolbar = [
                    [
                        'bold',
                        'italics',
                        'underline',
                        'ul',
                        'ol',
                        'quote',
                        'insertImage',
                        'justifyLeft',
                        'justifyCenter',
                        'justifyRight',
                        'indent',
                        'outdent',
                        'insertVideo'
                    ]
                ];

                taOptions.classes = {
                    focussed: 'focussed',
                    toolbar: 'ta-toolbar',
                    toolbarGroup: 'ta-group',
                    toolbarButton: 'md-button',
                    toolbarButtonActive: 'active',
                    disabled: '',
                    textEditor: 'form-control',
                    htmlEditor: 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate',
            function(taTools) {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);
    }
})();

(function () {
    'use strict';

    angular.module('assessmentapp').factory('apiService', apiService);

    /** @ngInject */
    function apiService($resource, appConfig) {
        var service = {
            Auth: Auth,
            Menu: Menu,
            Account: Account,
            Competency: Competency,
            Pool: Pool,
            Category: Category,
            Reference: Reference,
            QuestionGeneral: QuestionGeneral,
            Assessment: Assessment,
            Session: Session,
            Guides: Guides,
            Report: Report,
            Dashboard: Dashboard,
            ReportTiki: ReportTiki,
            QuestionTiki: QuestionTiki,
            QuestionPapikostik: QuestionPapikostik,
            CaseStudyQuestion: CaseStudyQuestion,
            CaseStudyScheme: CaseStudyScheme,
            SurveyCategory: SurveyCategory,
            SurveyQuestion: SurveyQuestion,
            SurveyScheme: SurveyScheme,
        };

        return service;

        // method
        function Auth() {
            return $resource(appConfig.apiUrl + 'auth/:action', null, {
                login: {
                    params: { action: 'login' },
                    method: 'POST',
                    withCredentials: false,
                },
                refresh: {
                    params: { action: 'refresh' },
                    method: 'POST',
                    withCredentials: false,
                },
                logout: {
                    params: { action: 'logout' },
                    method: 'POST',
                    withCredentials: false,
                },
                hasAccess: {
                    params: { action: 'hasAccess' },
                    method: 'POST',
                    withCredentials: true,
                },
                stateRedirector: {
                    params: { action: 'stateRedirect' },
                    method: 'POST',
                    withCredentials: true,
                },
                getNewToken: {
                    params: { action: 'generateNewToken' },
                    method: 'POST',
                    withCredentials: false,
                },
            });
        }

        function Menu() {
            return $resource(appConfig.apiUrl + 'menu/:action', null, {
                getMenu: {
                    params: { action: 'getMenu' },
                    method: 'GET',
                    withCredentials: true,
                },
                view: {
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true,
                },
                getPermissionByState: {
                    params: { action: 'getPermissionByState' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true,
                },
                switchMenu: {
                    params: { action: 'switchMenu' },
                    method: 'POST',
                    withCredentials: true,
                },
                switchAction: {
                    params: { action: 'switchAction' },
                    method: 'POST',
                    withCredentials: true,
                },
            });
        }

        function Account() {
            return $resource(appConfig.apiUrl + 'account/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true,
                },
                create: {
                    params: { action: 'create' },
                    method: 'POST',
                    withCredentials: true,
                },
                delete: {
                    params: { action: 'delete' },
                    method: 'POST',
                    withCredentials: true,
                },
                update: {
                    params: { action: 'update' },
                    method: 'POST',
                    withCredentials: true,
                },
                changePassword: {
                    params: { action: 'changePassword' },
                    method: 'POST',
                    withCredentials: true,
                },
                sendInvitationCode: {
                    params: { action: 'sendInvitationCode' },
                    method: 'POST',
                    withCredentials: true,
                },
            });
        }

        function Competency() {
            return $resource(appConfig.apiUrl + 'competency/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true,
                },
                create: {
                    params: { action: 'create' },
                    method: 'POST',
                    withCredentials: true,
                },
                delete: {
                    params: { action: 'delete' },
                    method: 'POST',
                    withCredentials: true,
                },
                update: {
                    params: { action: 'update' },
                    method: 'POST',
                    withCredentials: true,
                },
            });
        }

        function Category() {
            return $resource(appConfig.apiUrl + 'question-category/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true,
                },
                create: {
                    params: { action: 'create' },
                    method: 'POST',
                    withCredentials: true,
                },
                delete: {
                    params: { action: 'delete' },
                    method: 'POST',
                    withCredentials: true,
                },
                update: {
                    params: { action: 'update' },
                    method: 'POST',
                    withCredentials: true,
                },
            });
        }

        function Guides() {
            return $resource(appConfig.apiUrl + 'guide/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true,
                },
                create: {
                    params: { action: 'create' },
                    method: 'POST',
                    withCredentials: true,
                },
                delete: {
                    params: { action: 'delete' },
                    method: 'POST',
                    withCredentials: true,
                },
                update: {
                    params: { action: 'update' },
                    method: 'POST',
                    withCredentials: true,
                },
                loadGuide: {
                    params: { action: 'getGuide' },
                    method: 'GET',
                    responseType: 'blob',
                    transformResponse: function (data) {
                        // Stores the ArrayBuffer object in a property called "data"
                        return { data: data };
                    },
                    withCredentials: true,
                },
                loadGuideById: {
                    cache: false,
                    params: { action: 'getGuideById' },
                    method: 'GET',
                    withCredentials: true,
                },
            });
        }

        function Pool() {
            return $resource(appConfig.apiUrl + 'question-pool/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true,
                },
                create: {
                    params: { action: 'create' },
                    method: 'POST',
                    withCredentials: true,
                },
                delete: {
                    params: { action: 'delete' },
                    method: 'POST',
                    withCredentials: true,
                },
                update: {
                    params: { action: 'update' },
                    method: 'POST',
                    withCredentials: true,
                },
            });
        }

        function Session() {
            return $resource(appConfig.apiUrl + 'session/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true,
                },
                create: {
                    params: { action: 'create' },
                    method: 'POST',
                    withCredentials: true,
                },
                delete: {
                    params: { action: 'delete' },
                    method: 'POST',
                    withCredentials: true,
                },
                update: {
                    params: { action: 'update' },
                    method: 'POST',
                    withCredentials: true,
                },
                getAvailableDate: {
                    cache: false,
                    params: { action: 'getAvailableDate' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true,
                },
                upload: {
                    params: { action: 'upload' },
                    method: 'POST',
                    withCredentials: true,
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined },
                },
                sendNotification: {
                    params: { action: 'sendNotification' },
                    method: 'POST',
                    withCredentials: true,
                },
            });
        }

        function Assessment() {
            return $resource(appConfig.apiUrl + 'assessment/:action', null, {
                session: {
                    cache: false,
                    params: { action: 'session' },
                    method: 'GET',
                    withCredentials: true,
                },
                question: {
                    cache: false,
                    params: { action: 'question' },
                    method: 'GET',
                    withCredentials: true,
                },
                isGuideRead: {
                    cache: false,
                    params: { action: 'isGuideRead' },
                    method: 'GET',
                    withCredentials: true,
                },
                sync: {
                    cache: false,
                    params: { action: 'synchronize' },
                    method: 'POST',
                    withCredentials: true,
                },
                submit: {
                    cache: false,
                    params: { action: 'submit' },
                    method: 'POST',
                    withCredentials: true,
                },
                setTikiSession: {
                    cache: false,
                    params: { action: 'setTikiSession' },
                    method: 'POST',
                    withCredentials: true,
                },
                getTikiSection: {
                    cache: false,
                    params: { action: 'getTikiSection' },
                    method: 'GET',
                    withCredentials: true,
                },
                checkTikiSession: {
                    cache: false,
                    params: { action: 'checkTikiSession' },
                    method: 'GET',
                    withCredentials: true,
                },
                initTikiSession: {
                    cache: false,
                    params: { action: 'initTikiSession' },
                    method: 'POST',
                    withCredentials: true,
                },
                setTikiGuideIsRead: {
                    cache: false,
                    params: { action: 'setTikiGuideIsRead' },
                    method: 'POST',
                    withCredentials: true,
                },
                syncTikiSection: {
                    cache: false,
                    params: { action: 'syncTikiSection' },
                    method: 'POST',
                    withCredentials: true,
                },
                setTikiSectionFinished: {
                    cache: false,
                    params: { action: 'setTikiSectionFinished' },
                    method: 'POST',
                    withCredentials: true,
                },
                setGuideIsReaded: {
                    cache: false,
                    params: { action: 'setGuideIsReaded' },
                    method: 'POST',
                    withCredentials: true,
                },
                checkTikiGuideIsRead: {
                    cache: false,
                    params: { action: 'checkTikiGuideIsRead' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: false,
                },
            });
        }

        function Reference() {
            return $resource(appConfig.apiUrl + 'reference/:action', null, {
                competencies: {
                    cache: false,
                    params: { action: 'competencies' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true,
                },
                questionCategory: {
                    cache: false,
                    params: { action: 'questionCategory' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true,
                },
                questionPool: {
                    cache: false,
                    params: { action: 'questionPool' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true,
                },
                guides: {
                    cache: false,
                    params: { action: 'guides' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true,
                },
                users: {
                    cache: false,
                    params: { action: 'users' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true,
                },
                listGroupParticipant: {
                    cache: false,
                    params: { action: 'listGroupParticipant' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true,
                },
                tikiSections: {
                    cache: false,
                    params: { action: 'tikiSections' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true,
                },
                surveyCategory: {
                    cache: false,
                    params: { action: 'surveyCategory' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true,
                },
                surveyScheme: {
                    cache: false,
                    params: { action: 'surveyScheme' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true,
                },
                caseStudyScheme: {
                    cache: false,
                    params: { action: 'caseStudyScheme' },
                    method: 'GET',
                    withCredentials: true,
                    isArray: true,
                },
            });
        }

        function Report() {
            return $resource(appConfig.apiUrl + 'report/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true,
                },
                detail: {
                    cache: false,
                    params: { action: 'detail' },
                    method: 'GET',
                    withCredentials: true,
                },
            });
        }

        function ReportTiki() {
            return $resource(appConfig.apiUrl + 'report-tiki/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true,
                },
            });
        }

        function QuestionGeneral() {
            return $resource(appConfig.apiUrl + 'question-general/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true,
                },
                create: {
                    params: { action: 'create' },
                    method: 'POST',
                    withCredentials: true,
                },
                delete: {
                    params: { action: 'delete' },
                    method: 'POST',
                    withCredentials: true,
                },
                update: {
                    params: { action: 'update' },
                    method: 'POST',
                    withCredentials: true,
                },
                upload: {
                    params: { action: 'upload' },
                    method: 'POST',
                    withCredentials: true,
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined },
                },
                images: {
                    params: { action: 'getQuestionImage' },
                    method: 'GET',
                    responseType: 'blob',
                    transformResponse: function (data) {
                        // Stores the ArrayBuffer object in a property called "data"
                        return { data: data };
                    },
                },
            });
        }

        function QuestionTiki() {
            return $resource(appConfig.apiUrl + 'question-tiki/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true,
                },
            });
        }

        function QuestionPapikostik() {
            return $resource(
                appConfig.apiUrl + 'question-papikostik/:action',
                null,
                {
                    view: {
                        cache: false,
                        params: { action: 'view' },
                        method: 'GET',
                        withCredentials: true,
                    },
                    update: {
                        params: { action: 'update' },
                        method: 'POST',
                        withCredentials: true,
                    },
                }
            );
        }

        function CaseStudyQuestion() {
            return $resource(
                appConfig.apiUrl + 'question-case-study/:action',
                null,
                {
                    view: {
                        cache: false,
                        params: { action: 'view' },
                        method: 'GET',
                        withCredentials: true,
                    },
                    create: {
                        params: { action: 'create' },
                        method: 'POST',
                        withCredentials: true,
                    },
                    update: {
                        params: { action: 'update' },
                        method: 'POST',
                        withCredentials: true,
                    },
                    delete: {
                        params: { action: 'delete' },
                        method: 'POST',
                        withCredentials: true,
                    },
                    loadMedia: {
                        params: { action: 'getMedia' },
                        method: 'GET',
                        responseType: 'blob',
                        transformResponse: function (data) {
                            // Stores the ArrayBuffer object in a property called "data"
                            return { data: data };
                        },
                        withCredentials: true,
                    },
                    lists: {
                        cache: false,
                        params: { action: 'lists' },
                        method: 'GET',
                        withCredentials: true,
                        isArray: true,
                    },
                }
            );
        }

        function CaseStudyScheme() {
            return $resource(appConfig.apiUrl + 'scheme-case-study/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true,
                },
                create: {
                    params: { action: 'create' },
                    method: 'POST',
                    withCredentials: true,
                },
                update: {
                    params: { action: 'update' },
                    method: 'POST',
                    withCredentials: true,
                },
                delete: {
                    params: { action: 'delete' },
                    method: 'POST',
                    withCredentials: true,
                },
            });
        }

        function Dashboard() {
            return $resource(appConfig.apiUrl + 'dashboard/:action', null, {
                loadWidget: {
                    cache: false,
                    params: { action: 'loadWidget' },
                    method: 'GET',
                    withCredentials: true,
                },
                loadLatestSubmit: {
                    cache: false,
                    params: { action: 'loadLatestSubmit' },
                    method: 'GET',
                    withCredentials: true,
                },
                getQuestionStats: {
                    cache: false,
                    params: { action: 'getQuestionStats' },
                    method: 'GET',
                    withCredentials: true,
                },
                getChartUserStats: {
                    cache: false,
                    params: { action: 'getChartUserStats' },
                    method: 'GET',
                    withCredentials: true,
                },
            });
        }

        function SurveyCategory() {
            return $resource(appConfig.apiUrl + 'survey-category/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true,
                },
                safeActions: {
                    cache: false,
                    params: { action: 'safeActions' },
                    method: 'GET',
                    withCredentials: true,
                },
                create: {
                    params: { action: 'create' },
                    method: 'POST',
                    withCredentials: true,
                },
                delete: {
                    params: { action: 'delete' },
                    method: 'POST',
                    withCredentials: true,
                },
                update: {
                    params: { action: 'update' },
                    method: 'POST',
                    withCredentials: true,
                },
            });
        }

        function SurveyQuestion() {
            return $resource(appConfig.apiUrl + 'survey-question/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true,
                },
                safeActions: {
                    cache: false,
                    params: { action: 'safeActions' },
                    method: 'GET',
                    withCredentials: true,
                },
                create: {
                    params: { action: 'create' },
                    method: 'POST',
                    withCredentials: true,
                },
                delete: {
                    params: { action: 'delete' },
                    method: 'POST',
                    withCredentials: true,
                },
                update: {
                    params: { action: 'update' },
                    method: 'POST',
                    withCredentials: true,
                },
            });
        }

        function SurveyScheme() {
            return $resource(appConfig.apiUrl + 'survey-scheme/:action', null, {
                view: {
                    cache: false,
                    params: { action: 'view' },
                    method: 'GET',
                    withCredentials: true,
                },
                create: {
                    params: { action: 'create' },
                    method: 'POST',
                    withCredentials: true,
                },
                delete: {
                    params: { action: 'delete' },
                    method: 'POST',
                    withCredentials: true,
                },
                update: {
                    params: { action: 'update' },
                    method: 'POST',
                    withCredentials: true,
                },
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('app.utility', ['app.utility.menu']).config(config);

    /** @ngInject */
    function config($stateProvider) {}
})();

(function () {
    'use strict';

    angular
        .module('app.survey', [
            'app.survey.category',
            'app.survey.question',
            'app.survey.scheme',
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {}
})();

(function () {
    'use strict';

    angular
        .module('app.report', [
            'app.report.general',
            'app.report.tiki',
            'app.report.papikostik',
            'app.report.case_study',
            'app.report.survey',
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {}
})();

(function () {
    'use strict';

    angular
        .module('app.qa', [
            'app.qa.pool',
            'app.qa.competency',
            'app.qa.category',
            'app.qa.questions_general',
            'app.qa.questions_tiki',
            'app.qa.questions_papikostik',
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {}
})();

(function () {
    'use strict';

    angular.module('app.gates', []).config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider.state('app.auth', {
            url: '/auth?token&id',

            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm',
                },
                'content@app.auth': {
                    template:
                        '<div layout="column" layout-align="center center" id="auth-session"><div class="message">{{vm.message}}</div><md-progress-circular md-mode="indeterminate"></md-progress-circular></div>',
                    controllerAs: 'vm',
                    controller: function ($state, $timeout, isAuthenticated) {
                        var vm = this;
                        var isauth = isAuthenticated;
                        vm.message = 'SSO ... Please Wait';
                        if (isauth.status) {
                            vm.message = 'Success, redirecting to dashboard';
                            $timeout(function () {
                                $state.go(isauth.redirect_to);
                            }, 2000);
                        } else {
                            vm.message = 'Failed, validating request';
                            alert(
                                'Failed validating request, window will be closed soon'
                            );
                            $timeout(function () {
                                window.close();
                            }, 5000);
                        }
                    },
                    resolve: {
                        isAuthenticated: function (
                            $q,
                            $stateParams,
                            $localStorage,
                            authService,
                            apiService,
                            jwtHelper,
                            $rootScope
                        ) {
                            console.log($stateParams);
                            var defer = $q.defer();
                            try {
                                var token = authService._unwrapToken(
                                    $stateParams.token
                                );
                                var decode = jwtHelper.decodeToken(token);
                                var reqToken = authService.generateNewToken({
                                    token: $stateParams.token,
                                    mainAppID: decode.iss,
                                    username: decode.data.username,
                                    menuID: $stateParams.id,
                                });
                                reqToken.then(function (res) {
                                    authService.setToken(res.token);
                                    authService
                                        .stateRedirector()
                                        .then(function (redirector) {
                                            if (
                                                redirector.state.indexOf(
                                                    'clients'
                                                ) !== -1
                                            ) {
                                                defer.resolve({
                                                    redirect_to: redirector.state,
                                                });
                                            } else {
                                                var menu = apiService.Menu();
                                                var reqMenu = menu.getMenu();
                                                reqMenu.$promise
                                                    .then(function (resMenu) {
                                                        $localStorage.menus =
                                                            resMenu.data;
                                                        $rootScope.$broadcast(
                                                            'MENU::LOADED'
                                                        );
                                                        defer.resolve({
                                                            status: true,
                                                            message: 'success',
                                                            redirect_to:
                                                                redirector.state,
                                                        });
                                                    })
                                                    .catch(function () {
                                                        defer.resolve({
                                                            status: false,
                                                            message:
                                                                "You're not registered",
                                                            redirect_to: null,
                                                        });
                                                    });
                                            }
                                        });
                                });
                                reqToken.catch(function (err) {
                                    console.log(err);
                                    defer.resolve({
                                        status: false,
                                        message: 'Failed Authenticated',
                                        redirect_to: null,
                                    });
                                });
                            } catch (error) {
                                console.log(error);
                                defer.resolve({
                                    status: false,
                                    message: 'Failed Authenticated',
                                    redirect_to: null,
                                });
                            }

                            return defer.promise;
                        },
                    },
                },
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.case_study', [
            'app.case_study.question',
            'app.case_study.scheme',
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {}
})();

angular.module("assessmentapp").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/templates/pagination.html","<div class=\"pagination-container\" layout=\"row\" layout-xs=\"column\" layout-align=\"end center\" flex><div \nclass=\"pagination-label\">Displaying {{ range.lower }} - {{ range.upper }} of {{ range.total }}</div><ul \nclass=\"pagination-custom\" ng-if=\"1 < pages.length || !autoHide\"><li ng-if=\"boundaryLinks\" \nng-class=\"{ disabled : pagination.current == 1 }\"><a class=\"is-dark-bg\" href=\"\" ng-click=\"setCurrent(1)\">&laquo;</a>\n</li><li ng-if=\"directionLinks\" ng-class=\"{ disabled : pagination.current == 1 }\"><a class=\"is-dark-bg\" href=\"\" \nng-click=\"setCurrent(pagination.current - 1)\">&lsaquo;</a></li><li \nng-repeat=\"pageNumber in pages track by tracker(pageNumber, $index)\" \nng-class=\"{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' }\"><a class=\"is-dark-bg\" href=\"\" \nng-click=\"setCurrent(pageNumber)\">{{ pageNumber }}</a></li><li ng-if=\"directionLinks\" \nng-class=\"{ disabled : pagination.current == pagination.last }\"><a class=\"is-dark-bg\" href=\"\" \nng-click=\"setCurrent(pagination.current + 1)\">&rsaquo;</a></li><li ng-if=\"boundaryLinks\" \nng-class=\"{ disabled : pagination.current == pagination.last }\"><a class=\"is-dark-bg\" href=\"\" \nng-click=\"setCurrent(pagination.last)\">&raquo;</a></li></ul></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div>\n<md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\">\n<md-radio-button ng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}\n</md-radio-button></md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div \nclass=\"option-title\">Color Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/account/account.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.ACCOUNT.TITLE\">Accounts</div><div \ntranslate=\"PAGE.ACCOUNT.SUB_TITLE\" class=\"sub-title\">This is accounts page</div></div><div flex></div><div \nclass=\"header-toolbox\"><md-button class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25,50,100,150]\" \nng-value=\"val\">{{val}}</md-option></md-select></md-input-container><md-button aria-label=\"reload\" \nng-if=\"vm.actionPermit.view\" ng-click=\"vm.loadData(1)\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button><md-button aria-label=\"create\" \nng-if=\"vm.actionPermit.create\" ng-click=\"vm.showDialog($event, \'CREATE\', null)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n<md-button aria-label=\"upload\" ng-if=\"vm.actionPermit.upload\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-upload\"></md-icon></md-button>\n</div><div flex></div><ms-search-bar on-search=\"vm.pagination.load(1)\" query=\"vm.pagination.search\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><div class=\"content md-background-bg\" ms-scroll><md-content layout=\"column\" \nclass=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table class=\"app-table condensed\" \nms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">NO</th><th \nclass=\"text-center\">NIK</th><th class=\"text-start\">NAME</th><th class=\"text-start\">EMAIL</th><th class=\"text-center\">\nGROUP</th><th translate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr></thead><tbody><tr \nng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"7\"><div flex layout-align=\"center center\" \nlayout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div></td></tr><tr \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + ($index)}}</td><td \nclass=\"text-center\">{{val.nik}}</td><td class=\"text-start\">{{val.name}}</td><td class=\"text-start\">{{val.email}}</td>\n<td class=\"text-center\">{{val.roles.group.name}}</td><td class=\"text-center\"><div layout=\"row\" layout-align=\"center\">\n<md-menu><md-button aria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\">\n<md-icon md-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"4\">\n<md-menu-item><md-button aria-label=\"update\" ng-if=\"vm.actionPermit.update\" \nng-click=\"vm.showDialog($event, \'UPDATE\', val)\" class=\"md-raised md-accent md-hue-2 small-8\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon>Edit</md-button></md-menu-item><md-menu-item><md-button \naria-label=\"change password\" ng-if=\"vm.actionPermit.changePassword\" ng-click=\"vm.changePassword($event, val)\" \nclass=\"md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-key\"></md-icon>Change Password</md-button>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button aria-label=\"delete\" \nng-if=\"vm.actionPermit.delete\" ng-click=\"vm.showDialog($event, \'DELETE\', val, true)\" \nclass=\"md-raised md-warn md-hue-2 small-8\"><md-icon md-font-icon=\"icon-trash\"></md-icon>Delete</md-button>\n</md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table><dir-pagination-controls \non-page-change=\"vm.onPageChange(newPageNumber)\" template-url=\"app/core/templates/pagination.html\">\n</dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/clients/clients.html","<div id=\"clients-layout\" class=\"page-layout simple\" layout=\"column\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg md-hue-2 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\">{{vm.name}}</div><div class=\"sub-title\">Welcome to PAS Assessment</div></div><div \nflex></div><div class=\"header-toolbox\"><md-button class=\"md-raised md-warn\" ng-click=\"vm.logout()\"><md-icon \nmd-font-icon=\"icon-exit-to-app\"></md-icon>Keluar</md-button></div></div><div class=\"content animate-slide-right\" \nui-view=\"client_content\"></div></div></div>");
$templateCache.put("app/main/dashboard/dashboard.html","<div id=\"dashboard\"><div layout-gt-sm=\"row\" class=\"header md-primary-bg\" layout=\"column\" layout-align=\"start center\">\n<md-button ng-click=\"vm.reloadData()\" class=\"md-icon-button md-accent\"><md-icon md-font-icon=\"icon-refresh\"></md-icon>\n</md-button><div class=\"md-title\">Last Updated : {{vm.date}}</div></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"p-16 teal-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-account-multiple\"></md-icon><div\n class=\"h3\">Total Active User</div></div></div><div ng-show=\"vm.isLoading.widget\" layout=\"row\" \nlayout-align=\"center center\" flex><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div \nng-show=\"!vm.isLoading.widget\" class=\"pb-24\" layout=\"row\" layout-align=\"start end\"><div class=\"h2\">\n{{vm.widget.total_user_online}}</div><div class=\"h2 pl-8 secondary-text\">/ {{vm.widget.total_user}}</div></div><div \nng-show=\"!vm.isLoading.widget\" layout=\"row\" layout-align=\"start center\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.widget.percentage_total_user_online}}\"></md-progress-linear><div class=\"margin-left-10 w-50\">\n{{vm.widget.percentage_total_user_online}} %</div></div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 deep-orange-bg white-fg\"><div \nclass=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"m-0 mr-8\" md-font-icon=\"icon-account-network\"></md-icon><div class=\"h3\">Initialize Test</div></div></div><div \nng-show=\"vm.isLoading.widget\" layout=\"row\" layout-align=\"center center\" flex><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div ng-show=\"!vm.isLoading.widget\" class=\"pb-24\" layout=\"row\" \nlayout-align=\"start end\"><div class=\"h2\">{{vm.widget.today_in_init}}</div><div class=\"h2 pl-8 secondary-text\">\n/ {{vm.widget.total_user_test}}</div></div><div ng-show=\"!vm.isLoading.widget\" layout=\"row\" \nlayout-align=\"start center\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.widget.percentage_in_init}}\">\n</md-progress-linear><div class=\"margin-left-10 w-50\">{{vm.widget.percentage_in_init}} %</div></div></ms-widget-front>\n</ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 indigo-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-chart-line\"></md-icon><div class=\"h3\">\nIn Progress</div></div></div><div ng-show=\"vm.isLoading.widget\" layout=\"row\" layout-align=\"center center\" flex>\n<md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div ng-show=\"!vm.isLoading.widget\" \nclass=\"pb-24\" layout=\"row\" layout-align=\"start end\"><div class=\"h2\">{{vm.widget.today_in_progress}}</div><div \nclass=\"h2 pl-8 secondary-text\">/ {{vm.widget.total_user_test}}</div></div><div ng-show=\"!vm.isLoading.widget\" \nlayout=\"row\" layout-align=\"start center\"><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.widget.percentage_in_progress}}\"></md-progress-linear><div class=\"margin-left-10 w-50\">\n{{vm.widget.percentage_in_progress}} %</div></div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 blue-bg white-fg\"><div \nclass=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"m-0 mr-8\" md-font-icon=\"icon-checkbox-marked-circle\"></md-icon><div class=\"h3\">Finished</div></div></div><div \nng-show=\"vm.isLoading.widget\" layout=\"row\" layout-align=\"center center\" flex><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular></div><div class=\"pb-24\" ng-show=\"!vm.isLoading.widget\" layout=\"row\" \nlayout-align=\"start end\"><div class=\"h2\">{{vm.widget.today_finished}}</div><div class=\"h2 pl-8 secondary-text\">\n/ {{vm.widget.total_user_test}}</div></div><div ng-show=\"!vm.isLoading.widget\" layout=\"row\" \nlayout-align=\"start center\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.widget.percentage_finished}}\">\n</md-progress-linear><div class=\"margin-left-10 w-50\">{{vm.widget.percentage_finished}} %</div></div></ms-widget-front>\n</ms-widget></div><div class=\"table-container\" layout=\"row\" block-ui=\"block-latest-submit\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><div class=\"table-title\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div>Latest Submit</div><div><form ng-clock \nng-submit=\"vm.paginationSubmit.load(1)\"><input class=\"input-search\" placeholder=\"search\" type=\"text\" \nng-model=\"vm.paginationSubmit.search\"></form></div></div></div><table class=\"app-table condensed\" ms-responsive-table>\n<thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">NO</th><th class=\"text-start\">NIK</th><th \nclass=\"text-start\">NAME</th><th class=\"text-center\">FINISHED AT</th><th class=\"text-right\">CORRECT</th><th \nclass=\"text-right\">INCORRECT</th><th class=\"text-right\">SCORE</th><th translate=\"PAGE.COMMON.TOOLBOX.ACTION\" \nclass=\"text-center\">ACTION</th></tr></thead><tbody><tr \ndir-paginate=\"val in vm.paginationSubmit.data | itemsPerPage: vm.paginationSubmit.page_size\" \ntotal-items=\"vm.paginationSubmit.total\" current-page=\"vm.paginationSubmit.current\"><td class=\"text-center w-50\">\n{{vm.paginationSubmit.from + $index}}</td><td class=\"text-start\">{{val.user.nik}}</td><td class=\"text-start\">\n{{val.user.name}}</td><td class=\"text-center\">{{val.created_at}}</td><td class=\"text-right\">{{val.correct_answer}}</td>\n<td class=\"text-right\">{{val.wrong_answer}}</td><td class=\"text-right\">{{val.score}}</td><td class=\"text-center\"><div \nlayout=\"row\" layout-align=\"center\"><md-button aria-label=\"update\" ng-click=\"vm.goToDetail(val)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button>\n</div></td></tr></tbody></table><dir-pagination-controls on-page-change=\"vm.onPageChange(newPageNumber)\" \ntemplate-url=\"app/core/templates/pagination.html\"></dir-pagination-controls></div></div><div \nclass=\"chart-container padding-15\" block-ui=\"block-chart\"><md-content><canvas id=\"base\" class=\"chart-horizontal-bar\" \nchart-data=\"vm.userStats.data\" chart-options=\"vm.chartOptions\" chart-colors=\"[\'md-accent\']\" \nchart-series=\"vm.userStats.series\" chart-labels=\"vm.userStats.labels\"></canvas></md-content></div><div layout=\"column\" \nlayout-gt-sm=\"row\" flex layout-align=\"space-between start\" class=\"list-container padding-15\"><div flex-gt-sm=\"50\" \nflex=\"100\"><md-content><md-toolbar layout=\"row\" class=\"red-400-bg md-hue-1\"><div class=\"md-toolbar-tools\"><span>\nTop 10 questions that are answered incorrectly the most</span></div></md-toolbar><md-list flex \nblock-ui=\"block-most-question\"><md-list-item class=\"md-2-line\" ng-repeat-start=\"item in vm.questionStats.incorrect\" \nng-click=\"vm.showDialog($event, \'INCORRECT\', item.user_incorrect)\"><md-button \nng-class=\"{\'amber-600-bg md-hue-3\' : $index >= 0 && $index <= 2}\" class=\"w-30 md-raised md-accent\">{{$index + 1}}\n</md-button><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ item.question.question }}</h3><p>\n{{ item.question_category.name }}</p></div><md-button \nng-class=\"{\'amber-600-bg md-hue-3\' : $index >= 0 && $index <= 2}\" class=\"w-50 md-raised md-accent\">\n{{item.total_user_incorrect}}</md-button></md-list-item><md-divider ng-repeat-end></md-divider></md-list></md-content>\n</div><md-divider show hide-gt-sm></md-divider><div class=\"w-10\" hide show-gt-sm></div><div flex-gt-sm=\"50\" flex=\"100\">\n<md-content><md-toolbar layout=\"row\" class=\"teal-400-bg md-hue-1\"><div class=\"md-toolbar-tools\"><span>\nTop 10 questions that are answered correctly the most</span></div></md-toolbar><md-list flex \nblock-ui=\"block-most-question\"><md-list-item class=\"md-2-line\" ng-repeat-start=\"item in vm.questionStats.correct\" \nng-click=\"vm.showDialog($event, \'CORRECT\', item.user_correct)\"><md-button \nng-class=\"{\'amber-600-bg md-hue-3\' : $index >= 0 && $index <= 2}\" class=\"w-30 md-raised md-accent\">{{$index + 1}}\n</md-button><div class=\"md-list-item-text\" layout=\"column\"><h3>{{ item.question.question }}</h3><p>\n{{ item.question_category.name }}</p></div><md-button \nng-class=\"{\'amber-600-bg md-hue-3\' : $index >= 0 && $index <= 2}\" class=\"w-50 md-raised md-accent\">\n{{item.total_user_correct}}</md-button></md-list-item><md-divider ng-repeat-end></md-divider></md-list></md-content>\n</div></div></div>");
$templateCache.put("app/main/login/login.html","<div id=\"login\" block-ui=\"loginForm\" layout=\"row\" class=\"md-accent-bg md-hue-2\" layout-align=\"start\"><div \nid=\"login-intro\" flex hide show-gt-sm><div class=\"title\"></div></div><div id=\"login-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-form\"><div class=\"logo\"><img \nsrc=\"assets/images/logos/logo.png\" alt=\"\"></div><div class=\"title teal-900-fg\">Hi, welcome !</div><div \nclass=\"description black-500-fg text-bold\">{{vm.config.appName}} Log IN</div><form name=\"loginForm\" novalidate \nng-submit=\"vm.login()\"><md-input-container class=\"md-block\"><label>Username</label><input type=\"text\" name=\"username\" \nng-model=\"vm.form.username\" placeholder=\"Username\" required><div ng-messages=\"loginForm.username.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>username field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label>Password</label><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"Password\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Password field is required</span></div></div></md-input-container><md-button \ntype=\"submit\" class=\"md-raised md-primary submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\">LOG IN</md-button></form><div class=\"separator\"></div></div>\n</div></div>");
$templateCache.put("app/main/guides/guides.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.GUIDES.TITLE\">Guides</div><div translate=\"PAGE.GUIDES.SUB_TITLE\" \nclass=\"sub-title\">This is guides page</div></div><div flex></div><div class=\"header-toolbox\"><md-button \naria-label=\"help\" class=\"md-icon-button md-primary md-hue-3\"><md-icon md-font-icon=\"icon-question-mark-circle\">\n</md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span></md-tooltip></md-button></div></div>\n<md-toolbar layout=\"row\" layout-align=\"space-between center\" class=\"md-background md-hue-3 toolbar\"><div \nclass=\"md-toolbar-tools\"><div layout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"total-page\">\n<label>Total</label><md-select ng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option \nng-repeat=\"val in [5,15,20,25,50,100,150]\" ng-value=\"val\">{{val}}</md-option></md-select></md-input-container>\n<md-button aria-label=\"reload\" ng-if=\"vm.actionPermit.view\" ng-click=\"vm.loadData(1)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button>\n<md-button aria-label=\"create\" ng-if=\"vm.actionPermit.create\" ng-click=\"vm.showDialog($event, \'CREATE\', null)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div><div flex></div><ms-search-bar ng-if=\"vm.actionPermit.view\" on-search=\"vm.pagination.load(1)\" \nquery=\"vm.pagination.search\" debounce=\"300\"></ms-search-bar></div></md-toolbar><div class=\"content md-background-bg\" \nms-scroll><md-content layout=\"column\" class=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table \nclass=\"app-table condensed\" ms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">\nNO</th><th class=\"text-center w-50\">ID</th><th class=\"text-start\">TITLE</th><th class=\"text-start\">CONTENT</th><th \ntranslate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr></thead><tbody><tr \nng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"7\"><div flex layout-align=\"center center\" \nlayout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div></td></tr><tr \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + $index}}</td><td \nclass=\"text-center\">{{val.id}}</td><td class=\"text-start\">{{val.title}}</td><td class=\"text-start\"><span \nng-bind-html=\"val.description\"></span></td><td class=\"text-center\"><div layout=\"row\" layout-align=\"center\"><md-button \naria-label=\"update\" ng-if=\"vm.actionPermit.update\" ng-click=\"vm.showDialog($event, \'UPDATE\', val)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button>\n<md-button aria-label=\"delete\" ng-if=\"vm.actionPermit.delete\" ng-click=\"vm.showDialog($event, \'DELETE\', val, true)\" \nclass=\"md-icon-button md-raised md-warn md-hue-2 small-8\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button>\n</div></td></tr></tbody></table><dir-pagination-controls on-page-change=\"vm.onPageChange(newPageNumber)\" \ntemplate-url=\"app/core/templates/pagination.html\"></dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/session/session.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.SESSION.TITLE\">Session Group</div><div \ntranslate=\"PAGE.SESSION.SUB_TITLE\" class=\"sub-title\">This is session group page</div></div><div flex></div><div \nclass=\"header-toolbox\"><md-button aria-label=\"help\" class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25,50,100,150]\" \nng-value=\"val\">{{val}}</md-option></md-select></md-input-container><md-button aria-label=\"reload\" \nng-if=\"vm.actionPermit.view\" ng-click=\"vm.loadData(1)\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip>Reload</md-tooltip></md-button><md-button \naria-label=\"create\" ng-if=\"vm.actionPermit.create\" ng-click=\"vm.showDialog($event, \'CREATE\', null)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip>\nCreate</md-tooltip></md-button><md-button aria-label=\"upload\" ng-if=\"vm.actionPermit.upload\" \nng-click=\"vm.showDialog($event, \'UPLOAD\', null)\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><md-tooltip>Upload</md-tooltip></md-button><md-button \naria-label=\"sendNotification\" ng-if=\"vm.actionPermit.upload\" ng-disabled=\"vm.selected.length == 0\" \nng-click=\"vm.confirmDialog($event, false, null)\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon \nmd-font-icon=\"icon-email\"></md-icon><md-tooltip>Send Notification</md-tooltip></md-button><md-button \nng-click=\"vm.showFilter = !vm.showFilter\" ng-if=\"vm.actionPermit.view\" aria-label=\"filter\" \nng-class=\"{\'green-400-bg\' : vm.showFilter}\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><md-tooltip>Show filter</md-tooltip></md-button></div><div flex></div>\n<ms-search-bar ng-if=\"vm.actionPermit.view\" on-search=\"vm.pagination.load(1)\" query=\"vm.pagination.search\" \ndebounce=\"300\"></ms-search-bar></div></md-toolbar><md-toolbar layout=\"row\" ng-show=\"vm.showFilter\" \nlayout-align=\"space-between center\" class=\"md-hue-3 secondary-toolbar\"><div class=\"md-toolbar-tools\">\n<md-input-container flex class=\"wrapper-input\"><label>Start Date</label><input type=\"date\" name=\"start_date\" \nng-model=\"vm.startDate\"></md-input-container><md-input-container flex class=\"wrapper-input\"><label>End Date</label>\n<input type=\"date\" name=\"end_date\" ng-model=\"vm.endDate\"></md-input-container><md-input-container flex \nclass=\"wrapper-input\"><label>Session Type</label><md-select ng-model=\"vm.sessionType\" class=\"md-accent md-hue-1\" \nname=\"session_type\"><md-option ng-repeat=\"val in vm.sessionTypes\" ng-value=\"val\">{{val}}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div></md-toolbar><div class=\"content md-background-bg\" ms-scroll>\n<md-content layout=\"column\" class=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table \nclass=\"app-table condensed\" ms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th \nclass=\"text-center w-50 checkable\"><input type=\"checkbox\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\"></th><th class=\"text-center w-30\">NO</th><th \nclass=\"text-start\">NAME</th><th class=\"text-start\">EMAIL</th><th class=\"text-start\">POOL</th><th class=\"text-center\">\nTYPE</th><th class=\"text-center\">GUIDES</th><th class=\"text-center\">DURATION</th><th class=\"text-center\">Q-LIMIT</th>\n<th class=\"text-center\">START DATE</th><th class=\"text-center\">END DATE</th><th class=\"text-center\">START TIME</th><th \nclass=\"text-center\">END TIME</th><th class=\"text-center\">INVITATION</th><th translate=\"PAGE.COMMON.TOOLBOX.ACTION\" \nclass=\"text-center\">ACTION</th></tr></thead><tbody><tr ng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\">\n<td colspan=\"14\"><div flex layout-align=\"center center\" layout=\"column\" class=\"padding-20\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div></td></tr><tr \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\" pagination-id=\"session-table\" ng-init=\"val.is_waiting = false\"><td \nclass=\"text-center w-50 checkable\"><input ng-if=\"!val.is_waiting\" ng-checked=\"vm.exists(val, vm.selected)\" \nng-click=\"vm.toggle(val, vm.selected)\" type=\"checkbox\"><md-progress-circular ng-if=\"val.is_waiting\" md-diameter=\"20\" \nmd-mode=\"indeterminate\"></md-progress-circular></td><td class=\"text-center w-50\">{{vm.pagination.from + $index}}</td>\n<td class=\"text-start\">{{val.user.name}}</td><td class=\"text-start\">{{val.user.email != \'NULL\' ? val.user.email : \'-\'}}\n</td><td class=\"text-start\">{{val.question_pool.name}}</td><td class=\"text-center\">{{val.session_type | uppercase}}\n</td><td class=\"text-center\">{{val.guides.title}}</td><td class=\"text-center\">{{val.session_duration}}</td><td \nclass=\"text-center\">{{val.question_limit == 0 ? \'NO LIMIT\' : val.question_limit}}</td><td class=\"text-center\">\n{{val.session_start_date}}</td><td class=\"text-center\">{{val.session_end_date}}</td><td class=\"text-center\">\n{{val.session_start_time}}</td><td class=\"text-center\">{{val.session_end_time}}</td><td class=\"text-center\"><span \nclass=\"grey-400-fg\" ng-if=\"val.send_mail == \'none\'\">REGISTER</span> <span class=\"green-400-fg\" \nng-if=\"val.send_mail == \'success\'\">SUCCESS</span> <span class=\"red-400-fg\" ng-if=\"val.send_mail == \'failed\'\">FAILED\n</span></td><td class=\"text-center\"><div layout=\"row\" layout-align=\"center\"><md-menu><md-button \naria-label=\"Open phone interactions menu\" class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item>\n<md-button aria-label=\"update\" ng-if=\"vm.actionPermit.update\" ng-click=\"vm.showDialog($event, \'UPDATE\', val)\" \nclass=\"md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>Edit</md-button>\n</md-menu-item><md-menu-item><md-button aria-label=\"change password\" ng-click=\"vm.confirmDialog($event, true, val)\" \nclass=\"md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-email\"></md-icon>Send Invitation</md-button>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button aria-label=\"delete\" \nng-if=\"vm.actionPermit.delete\" ng-click=\"vm.showDialog($event, \'DELETE\', val, true)\" \nclass=\"md-raised md-warn md-hue-2 small-8\"><md-icon md-font-icon=\"icon-trash\"></md-icon>Delete</md-button>\n</md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table><dir-pagination-controls \npagination-id=\"session-table\" on-page-change=\"vm.onPageChange(newPageNumber)\" \ntemplate-url=\"app/core/templates/pagination.html\"></dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/unauthorized/unauthorized.html","<div class=\"page-layout simple fullwidth\"><div layout=\"column\" layout-align=\"center center\" class=\"unauthorized\">\n<md-icon class=\"md-warn-fg s50\" md-font-icon=\"icon-block-helper\"></md-icon><div class=\"h1 margin-top-15 md-warn-fg\">\nUnauthorized</div></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" \nstyle=\"color:rgba(0,0,0,0.6)\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular \nclass=\"md-accent\" md-diameter=\"32\" md-mode=\"indeterminate\"></md-progress-circular></div></label><input \nid=\"ms-search-bar-input\" type=\"text\" placeholder=\"Search\" flex ng-model=\"MsSearchBar.query\" \nng-model-options=\"MsSearchBar.queryOptions\" ng-blur=\"MsSearchBar.blurred()\" \nng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button class=\"ms-search-bar-collapser md-icon-button\" \nng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\"><md-icon md-font-icon=\"icon-close\" class=\"icon s24\" \nstyle=\"color:rgba(0,0,0,0.6)\"></md-icon></md-button><div class=\"ms-search-bar-results\" ng-if=\"MsSearchBar.results\" \nms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-primary md-hue-1 md-whiteframe-1dp\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"logo-image md-accent-bg md-hue-2\">P</span> <span class=\"logo-text\">Assessment</span></div><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\">\n</md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\">\n</ms-navigation>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon>\n</md-button></form></div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/main/account/change-password/change-password.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-md=\"60\" md-theme=\"{{vm.theme}}\"><form name=\"frmRequest\" ng-cloak>\n<md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">Change Password\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content ng-init=\"vm.setForm(frmRequest)\">\n<div class=\"form-overlay-wrapper animate-fade-in-out\" ng-show=\"vm.isPreparing\"><div flex layout=\"column\" layout-fill \nlayout-align=\"center center\" class=\"text-overlay\"><md-progress-circular md-diameter=\"20px\" class=\"md-warn\">\n</md-progress-circular><div class=\"padding-top-10\">{{vm.loadingMessage}}</div></div></div><div \nclass=\"md-dialog-content\"><div layout=\"column\"><md-input-container class=\"md-accent\" flex><label>Password</label><input\n name=\"password\" type=\"password\" placeholder=\"password\" required ng-model=\"vm.data.password\"><div \nng-messages=\"frmRequest.password.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container>\n<md-input-container class=\"md-accent\" flex><label>Password Confirmation</label><input name=\"password_confirmation\" \ntype=\"password\" placeholder=\"Password Confirmation\" required ng-model=\"vm.data.password_confirmation\"><div \nng-messages=\"frmRequest.password_confirmation.$error\"><div ng-message=\"required\">This is required!</div><div \nng-message=\"isNotMatch\">Password Confirmation Not Match !</div></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout=\"start center\"><span ng-show=\"vm.errorMessage\" \nclass=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} </span><span flex></span><md-button \nng-click=\"vm.cancel()\">CLOSE</md-button><md-button ng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" \nmd-autofocus class=\"md-accent\" ng-click=\"vm.submit($event, frmRequest)\">CHANGE PASSWORD</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/account/form/form.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-md=\"70\" md-theme=\"{{vm.theme}}\"><form name=\"frmRequest\" ng-cloak>\n<md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">\n{{vm.dialogType | titleCase }} Account</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ng-init=\"vm.setForm(frmRequest)\"><div class=\"form-overlay-wrapper animate-fade-in-out\" \nng-show=\"vm.isPreparing\"><div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\">\n<md-progress-circular md-diameter=\"20px\" class=\"md-warn\"></md-progress-circular><div class=\"padding-top-10\">\n{{vm.loadingMessage}}</div></div></div><div class=\"md-dialog-content\"><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container class=\"md-accent\" flex><label>Username / NIK</label><input name=\"nik\" type=\"text\" \nplaceholder=\"ex: 190xxxx / TA00\" required ng-model=\"vm.data.nik\"><div ng-messages=\"frmRequest.nik.$error\"><div \nng-message=\"required\">This is required!</div></div></md-input-container><md-input-container class=\"md-accent\" flex>\n<label>Name</label><input name=\"name\" type=\"text\" placeholder=\"ex: John Doe\" required ng-model=\"vm.data.name\"><div \nng-messages=\"frmRequest.name.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container>\n<md-input-container class=\"md-accent\" flex><label>Group</label><md-select name=\"group\" required placeholder=\"group\" \nng-model=\"vm.data.group\"><md-option ng-value=\"val.id\" ng-selected=\"vm.data.group == val.id\" \nng-repeat=\"val in vm.listGroup\">{{val.name}}</md-option></md-select><div ng-messages=\"frmRequest.group.$error\"><div \nng-message=\"required\">This is required!</div></div></md-input-container></div><div layout=\"column\" \nng-if=\"vm.dialogType === \'CREATE\'\" layout-gt-sm=\"row\"><md-input-container class=\"md-accent\" flex><label>Email</label>\n<input name=\"email\" type=\"email\" placeholder=\"ex: john@gmail.com\" required ng-model=\"vm.data.email\"><div \nng-messages=\"frmRequest.email.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container>\n<md-input-container class=\"md-accent\" flex><label>Password</label><input name=\"password\" type=\"password\" \nplaceholder=\"password\" required ng-model=\"vm.data.password\"><div ng-messages=\"frmRequest.password.$error\"><div \nng-message=\"required\">This is required!</div></div></md-input-container><md-input-container class=\"md-accent\" flex>\n<label>Password Confirmation</label><input name=\"password_confirmation\" type=\"password\" \nplaceholder=\"Password Confirmation\" required ng-model=\"vm.data.password_confirmation\"><div \nng-messages=\"frmRequest.password_confirmation.$error\"><div ng-message=\"required\">This is required!</div><div \nng-message=\"isNotMatch\">Password Confirmation Not Match !</div></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout=\"start center\"><span ng-show=\"vm.errorMessage\" \nclass=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} </span><span flex></span><md-button \nng-click=\"vm.cancel()\">CLOSE</md-button><md-button ng-if=\"vm.dialogType === \'CREATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.submit($event, frmRequest)\">CREATE</md-button><md-button ng-if=\"vm.dialogType === \'UPDATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.update($event, frmRequest)\">UPDATE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/clients/assessment-case-study/assessment-case-study.html","<div class=\"container-essay\"><guide-assessment ng-if=\"!vm.isGuideFinish\" on-click-start=\"vm.start($event)\" \nguide-id=\"vm.params.guide_id\" session-id=\"vm.params.session_id\"></guide-assessment><div \nng-if=\"vm.isGuideFinish && vm.scheme.is_valid\" flex class=\"white-bg md-whiteframe-10dp\" layout=\"column\" \nid=\"case-study-wrapper\"><div layout=\"row\" layout-align=\"space-between center\" class=\"case-study-toolbar\"><div \nclass=\"h2\">Case Study</div><div class=\"h2 timer\">{{vm.displayTimer}}</div><md-button ng-click=\"vm.submit($event)\" \nclass=\"md-raised md-accent\">SUBMIT</md-button></div><div layout-wrap ng-repeat=\"item in vm.scheme.questions\" \nlayout=\"row\"><div layout=\"column\" flex-gt-sm=\"50\"><div class=\"frame-desc\">{{item.description}}</div><iframe \nclass=\"frame-question\" ng-src=\"{{vm.getResource(item.filename)}}\" frameborder=\"0\"></iframe></div><div layout=\"row\" \nflex-gt-sm><text-angular class=\"frame-answer\" name=\"answer_{{item.case_study_question_id}}\" \nta-toolbar=\"[[\'undo\',\'redo\',\'bold\',\'italics\',\'ol\',\'ul\',\'justifyLeft\',\'justifyCenter\',\'justifyRight\',\'justifyFull\',\'indent\',\'outdent\']]\" \ndata-ng-required=\"true\" ng-model=\"item.answer\"></text-angular></div></div></div><div layout=\"column\" \nclass=\"margin-top-50\" layout-align=\"center center\" ng-if=\"vm.isGuideFinish && vm.isPreparing\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular><div class=\"margin-top-20\">Loading Question</div></div><div \nlayout=\"column\" ng-if=\"!vm.scheme.is_valid && vm.isGuideFinish && !vm.isPreparing\" class=\"padding-15\"><div \nclass=\"h3 margin-bottom-10\">Sesi telah kadaluarsa</div><div class=\"h4 margin-bottom-10\">\nSesi anda dimulai pukul : {{vm.scheme.validation.taken_time}} dan telah berakhir pada {{vm.scheme.validation.lead_time.text}}\n</div><div class=\"h4 margin-bottom-10\">\nAnda akan segera di alihkan ke halaman utama dalam {{vm.countdownExp}} atau anda dapat klik tombol dibawah ini untuk menuju ke halaman menu\n</div><md-button ng-click=\"vm.goToMenu()\" class=\"md-warn md-raised\">Klik disini untuk kembali ke halaman menu\n</md-button></div></div>");
$templateCache.put("app/main/clients/assessment-general/assessment-general.html","<div class=\"container\"><guide-assessment ng-if=\"!vm.isGuideFinish\" on-click-start=\"vm.start($event)\" \nguide-id=\"vm.params.guide_id\" session-id=\"vm.params.session_id\"></guide-assessment><toolbar-assessment \nng-if=\"vm.isGuideFinish && vm.scheme.is_valid\" scheme=\"vm.scheme\" questions=\"vm.scheme.questions\" \nactive-question=\"vm.activeQuestion\" question-index=\"vm.questionIndex\" remaining-times=\"vm.scheme.remaining_times\" \ntheme=\"vm.themes\"></toolbar-assessment><div layout=\"column\" ng-if=\"vm.timeIsOver\" class=\"padding-15\"><div \nclass=\"h2 text-center\">Waktu pengerjaan telah berakhir silahkan klik <span class=\"md-warn-fg\">FINISH</span>\n untuk mengakhiri test</div></div><div ng-if=\"vm.isGuideFinish && !vm.timeIsOver\" ng-init=\"vm.showNav = true\" \nlayout=\"column\" layout-align=\"space-between\" id=\"general-container\" class=\"md-whiteframe-10dp\"><div \nclass=\"collapsable-nav\" ng-if=\"vm.scheme.is_valid\"><md-button ng-click=\"vm.showNav = !vm.showNav\" \nclass=\"md-icon-button md-raised md-primary\"><md-icon ng-class=\"{\'turn-down\' : !vm.showNav}\" \nmd-font-icon=\"icon-chevron-up\"></md-icon></md-button></div><div layout=\"row\" ng-if=\"vm.scheme.is_valid\" \nng-show=\"vm.showNav\" layout-wrap class=\"navigation\"><button ng-disabled=\"vm.timeIsOver\" \nng-class=\"{\'empty\' : item.id !== vm.activeQuestion.id, \'active\' : item.id === vm.activeQuestion.id, \'submitted\' : item.is_submitted}\" \nng-click=\"vm.setQuestion($index)\" ng-repeat=\"item in vm.scheme.questions\" class=\"nav-item white-fg\">{{$index + 1}}\n</button></div><div layout=\"column\" ng-if=\"vm.scheme.is_valid\"><div class=\"question-wrapper\" layout=\"row\"><span \nclass=\"question\" ng-bind-html=\"vm.activeQuestion.question\"></span></div><div layout=\"column\" class=\"question-media\" \nlayout-align=\"center\" ng-if=\"vm.activeQuestion.having_images == 1\"><img class=\"img-container\" \nsrc=\"assets/images/loader.svg\" filename=\"vm.activeQuestion.images\" loader=\"vm.getQuestionImages\" lazy-load-media></div>\n<div class=\"answer-wrapper\" flex layout=\"column\"><div layout=\"row\" layout-align=\"start center\" \nng-repeat=\"item in vm.activeQuestion.answers\"><div ng-class=\"{\'md-accent-bg\': item.checked}\" \nclass=\"abjact md-primary-bg\">{{item.abjact}}</div><md-checkbox ng-disabled=\"vm.timeIsOver\" \nng-change=\"vm.onAnswerChange()\" ng-model=\"item.checked\" class=\"md-accent\">{{item.answer}}</md-checkbox></div></div>\n</div><div layout=\"row\" ng-if=\"vm.scheme.is_valid\" layout-align=\"center\" class=\"navigation-bottom\"><md-button flex \nng-click=\"vm.prevQuestion()\" ng-if=\"!vm.isFirstQuestion\" class=\"md-accent md-raised md-hue-2\">Sebelumnya</md-button>\n<md-button flex md-autofocus ng-if=\"!vm.isLastQuestion\" ng-click=\"vm.nextQuestion()\" \nclass=\"md-accent md-raised md-hue-2\">Selanjutnya</md-button></div><div layout=\"column\" ng-if=\"!vm.scheme.is_valid\" \nclass=\"padding-15\"><div class=\"h3 margin-bottom-10\">Sesi telah kadaluarsa</div><div class=\"h4 margin-bottom-10\">\nSesi anda dimulai pukul : {{vm.scheme.validation.taken_time}} dan telah berakhir pada {{vm.scheme.validation.lead_time.text}}\n</div><div class=\"h4 margin-bottom-10\">\nAnda akan segera di alihkan ke halaman utama dalam {{vm.countdownExp}} atau anda dapat klik tombol dibawah ini untuk menuju ke halaman menu\n</div><md-button ng-click=\"vm.goToMenu()\" class=\"md-warn md-raised\">Klik disini untuk kembali ke halaman menu\n</md-button></div></div></div>");
$templateCache.put("app/main/clients/assessment-papikostik/assessment-papikostik.html","<div class=\"container-papikostik\" block-ui=\"block-content\"><guide-assessment ng-if=\"!vm.isGuideFinish\" \non-click-start=\"vm.start($event)\" guide-id=\"vm.params.guide_id\" session-id=\"vm.params.session_id\"></guide-assessment>\n<div class=\"papikostik-wrapper\" ng-if=\"vm.isGuideFinish\"><div layout=\"column\" class=\"questions-container\" \nlayout-gt-sm=\"row\"><div hide show-gt-sm layout=\"column\" class=\"hint-wrapper\" flex-gt-sm=\"30\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-button ng-click=\"vm.submit($event)\" class=\"md-primary md-raised\">Finish\n</md-button><span flex></span><div class=\"times\">{{vm.displayTimer}}</div><span flex=\"10\"></span></div><div \nlayout=\"row\" layout-wrap class=\"hint-nav\"><div ng-repeat=\"item in vm.scheme.questions\" \nng-click=\"vm.goToQuestion(item.id)\" ng-class=\"{\'success\': item.selected}\" class=\"nav\">{{$index + 1}}</div></div></div>\n<div layout=\"column\" flex-gt-sm=\"70\" class=\"questions-content\"><div layout=\"row\" class=\"question-header\"><div hide \nshow-gt-sm class=\"desktop-view\">Pilihlah satu pernyataan yang anda rasakan paling mendekati gambaran diri anda.</div>\n<div hide-gt-sm layout=\"row\" layout-align=\"space-between center\" class=\"mobile-view\"><div layout=\"row\" \nclass=\"mobile-hint\">Pilihlah satu pernyataan yang anda rasakan paling mendekati gambaran diri anda.</div><span flex>\n</span><div class=\"times\">{{vm.displayTimer}}</div></div></div><div class=\"questions-wrapper\" \nng-class=\"{\'block\' : vm.lockQuestion}\"><div class=\"overlay-wrapper\" ng-if=\"vm.lockQuestion\"><div class=\"overlay-text\">\n<p>\nWaktu anda telah habis, jawaban anda akan tersimpan secara otomatis dan anda akan segera dialihkan dari halaman ini dalam waktu\n</p><h2>{{vm.countdownTime}}</h2><p>Atau anda dapat mempercepat proses ini dengan klik finish.</p></div></div><div \nlayout=\"column\" ng-repeat=\"item in vm.scheme.questions\" class=\"questions\"><div id=\"question_{{item.id}}\" \nclass=\"question-title\" layout=\"row\">{{item.text}}</div><div class=\"answers-wrapper\"><md-radio-group layout=\"column\" \nng-model=\"item.selected\"><md-radio-button ng-disabled=\"vm.lockQuestion\" ng-repeat=\"val in item.papikostik_answers\" \nng-value=\"val.id\" class=\"md-primary\"><span class=\"answer\">{{val.text}}</span></md-radio-button></md-radio-group></div>\n</div></div></div><div hide-gt-sm layout=\"row\" layout-align=\"start center\" class=\"toolbar-mobile\"><div layout=\"row\" \nclass=\"nav-container\"><div ng-repeat=\"item in vm.scheme.questions\" ng-click=\"vm.goToQuestion(item.id)\" \nng-class=\"{\'success\': item.selected}\" class=\"nav\">{{$index + 1}}</div></div><span flex></span><md-button \nng-click=\"vm.submit($event)\" class=\"md-primary md-raised\">Finish</md-button></div></div></div></div>");
$templateCache.put("app/main/clients/assessment-survey/assessment-survey.html","<div class=\"container white-bg\"><guide-assessment ng-if=\"!vm.isGuideFinish\" on-click-start=\"vm.start($event)\" \nguide-id=\"vm.params.guide_id\" session-id=\"vm.params.session_id\"></guide-assessment><div \nng-if=\"vm.isGuideFinish && vm.scheme.is_valid\" flex layout-wrap layout=\"row\" id=\"survey-wrapper\"><div flex-gt-sm=\"70\" \nflex-order=\"2\" flex-order-gt-sm=\"1\" class=\"survey-content\"><form name=\"formRequest\" ng-cloack><div \nng-init=\"hashId = item.survey_category_id + \'_scheme_\'\" id=\"{{hashId}}\" ng-repeat=\"item in vm.scheme.questions\" \nclass=\"survey-parent\"><div class=\"simple-table-container md-whiteframe-4dp\"><div class=\"table-title\">{{item.name}}\n</div><table class=\"app-table survey condensed\" ms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th \nclass=\"text-center w-50\">NO</th><th class=\"text-start\">PERNYATAAN</th><th class=\"text-center w-60\">1</th><th \nclass=\"text-center w-60\">2</th><th class=\"text-center w-60\">3</th><th class=\"text-center w-60\">4</th><th \nclass=\"text-center w-60\">5</th></tr></thead><tbody><tr id=\"question_{{val.id}}\" \nng-class=\"{\'red-200-bg\': vm.locationHash === \'question_\' + val.id}\" ng-repeat=\"val in item.questions\"><td \nclass=\"text-center w-50\">{{val.question_order}}</td><td class=\"text-start\">{{val.question}}</td><td \nclass=\"text-center w-60\" ng-repeat=\"answer in val.answers\"><label class=\"answer-area\" \nfor=\"answer_{{val.id}}_{{$index}}\"><input id=\"answer_{{val.id}}_{{$index}}\" type=\"radio\" \nng-change=\"vm.locationHash = null\" ng-value=\"answer.value\" name=\"answer_{{val.id}}\" ng-model=\"val.selected\"></label>\n</td></tr></tbody></table></div></div></form></div><div layout=\"column\" flex-gt-sm=\"30\" flex-order=\"1\" \nflex-order-gt-sm=\"2\" class=\"survey-timer\"><div layout=\"row\" class=\"padding-top-10 padding-bottom-10\" \nlayout-align=\"space-between center\"><div class=\"h4\">Remaining Time</div><div class=\"h2\">{{vm.displayTimer}}</div></div>\n<md-divider></md-divider><div layout=\"column\"><div class=\"toolbar-title\">Keterangan</div><ol><li>Sangat Tidak Setuju\n</li><li>Tidak Setuju</li><li>Netral</li><li>Setuju</li><li>Sangat Setuju</li></ol></div><md-divider></md-divider><div \nlayout=\"column\" hide show-gt-sm><div class=\"toolbar-title\">Navigation</div><ol class=\"parent-list\"><li \nng-repeat=\"item in vm.scheme.questions\"><p><a href=\"#\" ng-init=\"hashIdParent = item.survey_category_id + \'_scheme_\'\" \nng-click=\"$event.preventDefault();vm.goToQuestion(hashIdParent)\">{{item.name}}</a></p></li></ol></div><div hide \nshow-gt-sm layout=\"row\"><md-button ng-click=\"vm.submit(ev, formRequest)\" flex class=\"md-accent md-raised\">SUBMIT\n</md-button></div></div><md-button hide-gt-sm ng-click=\"vm.submit($event, formRequest)\" \nclass=\"md-fab small-8 md-fab-bottom-left\" aria-label=\"finish\"><md-icon \nmd-font-icon=\"icon-checkbox-marked-circle-outline\"></md-icon></md-button></div><div layout=\"column\" \nclass=\"margin-top-50\" layout-align=\"center center\" ng-if=\"vm.isGuideFinish && vm.isPreparing\"><md-progress-circular \nmd-mode=\"indeterminate\"></md-progress-circular><div>Loading Question</div></div><div layout=\"column\" \nng-if=\"!vm.scheme.is_valid && vm.isGuideFinish && !vm.isPreparing\" class=\"padding-15\"><div class=\"h3 margin-bottom-10\">\nSesi telah kadaluarsa</div><div class=\"h4 margin-bottom-10\">\nSesi anda dimulai pukul : {{vm.scheme.validation.taken_time}} dan telah berakhir pada {{vm.scheme.validation.lead_time.text}}\n</div><div class=\"h4 margin-bottom-10\">\nAnda akan segera di alihkan ke halaman utama dalam {{vm.countdownExp}} atau anda dapat klik tombol dibawah ini untuk menuju ke halaman menu\n</div><md-button ng-click=\"vm.goToMenu()\" class=\"md-warn md-raised\">Klik disini untuk kembali ke halaman menu\n</md-button></div></div>");
$templateCache.put("app/main/clients/guides/guides.directive.html","<div layout=\"column\" class=\"guide-wrapper\"><div layout=\"column\" ng-if=\"vm.isErrorLoad\"><div class=\"h3 text-boxed\">\nGuide Not Found</div><md-button ng-click=\"vm.getGuide()\" class=\"md-accent\">RELOAD</md-button></div><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-around\" ng-if=\"vm.isLoading\"><md-progress-circular md-mode=\"indeterminate\">\n</md-progress-circular></div><div layout=\"column\" class=\"guide-header\" ng-if=\"!vm.isErrorLoad && !vm.isLoading\"><div \nclass=\"h2\">{{vm.title}}</div></div><div class=\"guide-content md-whiteframe-10dp md-background md-hue-2\" \nng-if=\"!vm.isErrorLoad && !vm.isLoading && !vm.media\" layout=\"row\"><div class=\"p-20\" ng-bind-html=\"vm.description\">\n</div></div><div layout=\"row\" ng-if=\"!vm.isErrorLoad && !vm.isLoading\" class=\"guide-footer\"><div flex></div><md-button \nflex ng-click=\"vm.onClickStart()\" class=\"md-raised md-accent\">MULAI TEST</md-button><div flex></div></div></div>");
$templateCache.put("app/main/clients/assessment-tiki/assessment-tiki.html","<guide-assessment ng-if=\"!vm.isGuideFinish && !vm.isPreparing\" on-click-start=\"vm.start($event)\" \nguide-id=\"vm.params.guide_id\" session-id=\"vm.params.session_id\"></guide-assessment><div layout=\"column\" \nng-if=\"vm.isPreparing\" layout-fill flex layout-align=\"center center\"><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\"></md-progress-circular><div class=\"margin-top-20\">{{vm.message}}</div></div><div \nng-if=\"vm.isGuideFinish && !vm.isPreparing\" id=\"tiki-content\" flex class=\"animate-slide-right\" ui-view=\"tiki_content\">\n</div>");
$templateCache.put("app/main/clients/menus/menus.html","<md-content layout=\"column\" id=\"client-menus\" flex block-ui=\"block-content\"><div layout=\"row\" class=\"card-wrapper\" \nng-if=\"vm.listSession.length > 0\"><div flex-gt-sm=\"33\" flex-xs=\"100\" class=\"app-card md-whiteframe-5dp\" \nng-repeat=\"item in vm.listSession\"><div class=\"app-card-content-wrapper\" layout=\"column\" layout-align=\"center center\">\n<div class=\"app-card-header text-center md-accent-bg\"><div class=\"md-title\">{{item.session_type_name | uppercase}}\n</div></div><div class=\"app-card-content\"><div class=\"md-subhead\">{{ item.group_name | titleCase }}</div><div>\n{{item.session_start_date}} s.d {{item.session_start_date}}<br>\n{{item.session_start_time}} s.d {{item.session_end_time}}</div></div><md-button ng-disabled=\"item.disabled\" \nng-click=\"vm.launchTest(item)\" class=\"md-primary md-raised md-hue-2\">{{item.note}}</md-button></div></div></div><div \nlayout=\"row\" flex class=\"no-session\" layout-align=\"center center\" ng-if=\"vm.listSession.length === 0\"><div flex \nlayout=\"row\" class=\"app-card md-whiteframe-5dp\"><div class=\"app-card-content-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"app-card-content\"><span class=\"h3\">Anda tidak memiliki sesi test</span></div>\n<md-button layout=\"row\" ng-click=\"vm.loadSession()\" class=\"md-primary md-raised md-hue-2\"><div>Muat Ulang</div>\n<md-progress-circular ng-if=\"vm.isLoading\" class=\"margin-left-10 md-warn\" md-diameter=\"20\"></md-progress-circular>\n</md-button></div></div></div></md-content>");
$templateCache.put("app/main/clients/toolbar/toolbar.directive.html","<md-toolbar id=\"toolbar-assessment\" layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div layout=\"row\" flex \nlayout-align=\"space-between center\"><div flex class=\"h2 badge-info\">\n{{vm.questionIndex + 1}} from {{vm.questions.length}}</div><div class=\"h2\">{{vm.fmtMSS(vm.remainingTimes)}}</div>\n<md-button aria-label=\"reload\" ng-click=\"vm.submit($event)\" ng-class=\"{\'green-400-bg\' : vm.remainingTimes <= 0}\" \nclass=\"md-raised md-accent md-hue-2 small-8\">Finish</md-button></div></div></md-toolbar>");
$templateCache.put("app/main/dashboard/view-user/view-user.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-md=\"70\" md-theme=\"{{vm.theme}}\"><md-toolbar class=\"md-accent-bg\"><div \nclass=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">{{vm.dialogType | titleCase }} User Answered List\n</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" flex>\n<md-content><md-list flex><md-list-item class=\"md-2-line\" \ndir-paginate-start=\"item in vm.filtered | itemsPerPage: vm.numPerPage\" total-items=\"vm.totalItems\" \ncurrent-page=\"vm.currentPage\" ng-click=\"null\"><div class=\"h2 margin-right-10\">{{vm.end + ($index + 1)}}</div><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{ item.achievement.user.name }}</h3><p>{{ item.achievement.user.nik }}\n</p></div></md-list-item><md-divider dir-paginate-end></md-divider></md-list></md-content><div class=\"p-24 mb-8\" \nlayout=\"row\" layout-align=\"end center\"><dir-pagination-controls template-url=\"app/core/templates/pagination.html\" \non-page-change=\"vm.pageChanged(newPageNumber)\"></dir-pagination-controls></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout=\"start center\"><span flex></span><md-button ng-click=\"vm.cancel()\">CLOSE\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/case-study/question/question.html","<div id=\"app-layout\" class=\"page-layout qa-general-component\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.QUESTION_CASE_STUDY.TITLE\">Tiki Question</div><div \ntranslate=\"PAGE.QUESTION_CASE_STUDY.SUB_TITLE\" class=\"sub-title\">This is tiki question page</div></div><div flex></div>\n<div class=\"header-toolbox\"><md-button aria-label=\"help\" class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" ng-init=\"vm.showFilter = false\" \nlayout-align=\"space-between center\" class=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25,50,100,150]\" \nng-value=\"val\">{{val}}</md-option></md-select></md-input-container><md-button aria-label=\"reload\" \nng-if=\"vm.actionPermit.view\" ng-click=\"vm.loadData(1)\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button><md-button aria-label=\"create\" \nng-if=\"vm.actionPermit.create\" ng-click=\"vm.showDialog($event, \'CREATE\', null)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div><div flex></div><ms-search-bar ng-if=\"vm.actionPermit.view\" on-search=\"vm.pagination.load(1)\" \nquery=\"vm.pagination.search\" debounce=\"300\"></ms-search-bar></div></md-toolbar><div class=\"content md-background-bg\" \nms-scroll><md-content layout=\"column\" class=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table \nclass=\"app-table condensed\" ms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">\nNO</th><th class=\"text-start\">FILENAME</th><th class=\"text-start\">NAME</th><th class=\"text-start\">DESCRIPTION</th><th \ntranslate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr></thead><tbody><tr \nng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"6\"><div flex layout-align=\"center center\" \nlayout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div></td></tr><tr class=\"clickable\" \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + $index}}</td><td \nclass=\"text-start\">{{val.filename}}</td><td class=\"text-start\">{{val.name}}</td><td class=\"text-start\">\n{{val.description}}</td><td class=\"text-center\"><div layout=\"row\" layout-align=\"center\"><md-button aria-label=\"update\" \nng-if=\"vm.actionPermit.update\" ng-click=\"vm.showDialog($event, \'UPDATE\', val)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button>\n<md-button aria-label=\"delete\" ng-if=\"vm.actionPermit.delete\" ng-click=\"vm.showDialog($event, \'DELETE\', val, true)\" \nclass=\"md-icon-button md-raised md-warn md-hue-2 small-8\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button>\n</div></td></tr></tbody></table><dir-pagination-controls on-page-change=\"vm.onPageChange(newPageNumber)\" \ntemplate-url=\"app/core/templates/pagination.html\"></dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/case-study/scheme/scheme.html","<div id=\"app-layout\" class=\"page-layout qa-general-component\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.QUESTION_CASE_STUDY.TITLE\">Tiki Question</div><div \ntranslate=\"PAGE.QUESTION_CASE_STUDY.SUB_TITLE\" class=\"sub-title\">This is tiki question page</div></div><div flex></div>\n<div class=\"header-toolbox\"><md-button aria-label=\"help\" class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" ng-init=\"vm.showFilter = false\" \nlayout-align=\"space-between center\" class=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25,50,100,150]\" \nng-value=\"val\">{{val}}</md-option></md-select></md-input-container><md-button aria-label=\"reload\" \nng-if=\"vm.actionPermit.view\" ng-click=\"vm.loadData(1)\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button><md-button aria-label=\"create\" \nng-if=\"vm.actionPermit.create\" ng-click=\"vm.showDialog($event, \'CREATE\', null)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div><div flex></div><ms-search-bar ng-if=\"vm.actionPermit.view\" on-search=\"vm.pagination.load(1)\" \nquery=\"vm.pagination.search\" debounce=\"300\"></ms-search-bar></div></md-toolbar><div class=\"content md-background-bg\" \nms-scroll><md-content layout=\"column\" class=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table \nclass=\"app-table condensed\" ms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">\nNO</th><th class=\"text-start\">NAME</th><th class=\"text-start\">DESCRIPTION</th><th \ntranslate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr></thead><tbody><tr \nng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"6\"><div flex layout-align=\"center center\" \nlayout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div></td></tr><tr class=\"clickable\" \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + $index}}</td><td \nclass=\"text-start\">{{val.name}}</td><td class=\"text-start\">{{val.description}}</td><td class=\"text-center\"><div \nlayout=\"row\" layout-align=\"center\"><md-button aria-label=\"update\" ng-if=\"vm.actionPermit.update\" \nng-click=\"vm.showDialog($event, \'UPDATE\', val)\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button aria-label=\"delete\" ng-if=\"vm.actionPermit.delete\" \nng-click=\"vm.showDialog($event, \'DELETE\', val, true)\" class=\"md-icon-button md-raised md-warn md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></div></td></tr></tbody></table><dir-pagination-controls \non-page-change=\"vm.onPageChange(newPageNumber)\" template-url=\"app/core/templates/pagination.html\">\n</dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/guides/form/form.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-md=\"60\" md-theme=\"{{vm.theme}}\"><form name=\"frmRequest\" ng-cloak>\n<md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">\n{{vm.dialogType | titleCase }} Guides</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ng-init=\"vm.setForm(frmRequest)\"><div class=\"form-overlay-wrapper animate-fade-in-out\" \nng-show=\"vm.isLoading\"><div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\">\n<md-progress-circular md-diameter=\"20px\" class=\"md-warn\"></md-progress-circular><div class=\"padding-top-10\">\n{{vm.loadingMessage}}</div></div></div><div class=\"md-dialog-content\"><div layout=\"column\"><md-input-container \nclass=\"md-accent\" flex><label>Title</label><input name=\"title\" type=\"text\" placeholder=\"ex: General Instructions\" \nrequired ng-model=\"vm.data.title\"><div ng-messages=\"frmRequest.title.$error\"><div ng-message=\"required\">\nThis is required!</div></div></md-input-container><div layout=\"column\" class=\"ta-container\"><div class=\"title\">Content\n</div><text-angular ng-model=\"vm.data.description\"></text-angular></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout=\"start center\"><span ng-show=\"vm.errorMessage\" \nclass=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} </span><span flex></span><md-button \nng-click=\"vm.cancel()\">CLOSE</md-button><md-button ng-if=\"vm.dialogType === \'CREATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.submit($event, frmRequest)\">CREATE</md-button><md-button ng-if=\"vm.dialogType === \'UPDATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.update($event, frmRequest)\">UPDATE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/guides/view/view.html","<md-dialog aria-label=\"View Dialog\" flex-gt-md=\"70\" class=\"view-dialog\" md-theme=\"{{vm.theme}}\"><md-toolbar \nclass=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">\n{{vm.data.title | titleCase}}</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"form-overlay-wrapper animate-fade-in-out\" ng-show=\"vm.isPreparing\"><div flex layout=\"column\" layout-fill \nlayout-align=\"center center\" class=\"text-overlay\"><md-progress-circular md-diameter=\"20px\" class=\"md-warn\">\n</md-progress-circular><div class=\"padding-top-10\">{{vm.loadingMessage}}</div></div></div><div \nclass=\"md-dialog-content\"><div layout=\"column\" layout-align=\"center center\"><div ng-if=\"vm.isErrorLoad\" \nclass=\"view-error\">{{vm.data.title | titleCase}} not found</div><embed ng-src=\"{{vm.guide}}\" ng-if=\"!vm.isErrorLoad\" \nwidth=\"100%\" height=\"400\"><md-button ng-disabled=\"vm.isErrorLoad\" class=\"md-icon-button md-accent\" \nng-click=\"vm.download()\"><md-icon md-font-icon=\"icon-download\"></md-icon></md-button></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout=\"start center\"><span ng-show=\"vm.errorMessage\" \nclass=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} </span><span flex></span><md-button \nng-click=\"vm.cancel()\">CLOSE</md-button><md-button ng-if=\"vm.dialogType === \'CREATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.submit($event, frmRequest)\">CREATE</md-button><md-button ng-if=\"vm.dialogType === \'UPDATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.update($event, frmRequest)\">UPDATE</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/qa/pool/pool.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.POOL.TITLE\">Questions Pool</div><div \ntranslate=\"PAGE.POOL.SUB_TITLE\" class=\"sub-title\">This is question pool page</div></div><div flex></div><div \nclass=\"header-toolbox\"><md-button class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25,50,100,150]\" \nng-value=\"val\">{{val}}</md-option></md-select></md-input-container><md-button aria-label=\"reload\" \nng-if=\"vm.actionPermit.view\" ng-click=\"vm.loadData(1)\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button><md-button aria-label=\"create\" \nng-if=\"vm.actionPermit.create\" ng-click=\"vm.showDialog($event, \'CREATE\', null)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div><div flex></div><ms-search-bar ng-if=\"vm.actionPermit.view\" on-search=\"vm.pagination.load(1)\" \nquery=\"vm.pagination.search\" debounce=\"300\"></ms-search-bar></div></md-toolbar><div class=\"content md-background-bg\" \nms-scroll><md-content layout=\"column\" class=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table \nclass=\"app-table condensed\" ms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">\nNO</th><th class=\"text-start\">NAME</th><th class=\"text-start\">DESCRIPTION</th><th \ntranslate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr></thead><tbody><tr \nng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"7\"><div flex layout-align=\"center center\" \nlayout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div></td></tr><tr \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + $index}}</td><td \nclass=\"text-start\">{{val.name}}</td><td class=\"text-start\">{{val.description}}</td><td class=\"text-center\"><div \nlayout=\"row\" layout-align=\"center\"><md-button aria-label=\"update\" ng-if=\"vm.actionPermit.update\" \nng-click=\"vm.showDialog($event, \'UPDATE\', val)\" ng-disabled=\"val.allow_change == 0\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button>\n<md-button aria-label=\"delete\" ng-if=\"vm.actionPermit.delete\" ng-disabled=\"val.allow_change == 0\" \nng-click=\"vm.showDialog($event, \'DELETE\', val, true)\" class=\"md-icon-button md-raised md-warn md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></div></td></tr></tbody></table><dir-pagination-controls \non-page-change=\"vm.onPageChange(newPageNumber)\" template-url=\"app/core/templates/pagination.html\">\n</dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/qa/competency/competency.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.COMPETENCY.TITLE\">Competency</div><div \ntranslate=\"PAGE.COMPETENCY.SUB_TITLE\" class=\"sub-title\">This is competency page</div></div><div flex></div><div \nclass=\"header-toolbox\"><md-button aria-label=\"help\" class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25,50,100,150]\" \nng-value=\"val\">{{val}}</md-option></md-select></md-input-container><md-button aria-label=\"reload\" \nng-click=\"vm.loadData(1)\" ng-if=\"vm.actionPermit.view\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button><md-button aria-label=\"create\" \nng-if=\"vm.actionPermit.create\" ng-click=\"vm.showDialog($event, \'CREATE\', null)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div><div flex></div><ms-search-bar ng-if=\"vm.actionPermit.view\" on-search=\"vm.pagination.load(1)\" \nquery=\"vm.pagination.search\" debounce=\"300\"></ms-search-bar></div></md-toolbar><div class=\"content md-background-bg\" \nms-scroll><md-content layout=\"column\" class=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table \nclass=\"app-table condensed\" ms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">\nNO</th><th class=\"text-center w-50\">ID</th><th class=\"text-start\">NAME</th><th class=\"text-start\">DESCRIPTION</th><th \ntranslate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr></thead><tbody><tr \nng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"7\"><div flex layout-align=\"center center\" \nlayout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div></td></tr><tr \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + $index}}</td><td \nclass=\"text-center\">{{val.id}}</td><td class=\"text-start\">{{val.name}}</td><td class=\"text-start\">{{val.description}}\n</td><td class=\"text-center\"><div layout=\"row\" layout-align=\"center\"><md-button aria-label=\"update\" \nng-if=\"vm.actionPermit.update\" ng-click=\"vm.showDialog($event, \'UPDATE\', val)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button>\n<md-button aria-label=\"delete\" ng-if=\"vm.actionPermit.delete\" ng-click=\"vm.showDialog($event, \'DELETE\', val, true)\" \nclass=\"md-icon-button md-raised md-warn md-hue-2 small-8\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button>\n</div></td></tr></tbody></table><dir-pagination-controls on-page-change=\"vm.onPageChange(newPageNumber)\" \ntemplate-url=\"app/core/templates/pagination.html\"></dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/qa/qa-general/qa-general.html","<div id=\"app-layout\" class=\"page-layout qa-general-component\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.QUESTION_GENERAL.TITLE\">General Question</div><div \ntranslate=\"PAGE.QUESTION_GENERAL.SUB_TITLE\" class=\"sub-title\">This is general question page</div></div><div flex></div>\n<div class=\"header-toolbox\"><md-button aria-label=\"help\" class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" ng-init=\"vm.showFilter = false\" \nlayout-align=\"space-between center\" class=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25,50,100,150]\" \nng-value=\"val\">{{val}}</md-option></md-select></md-input-container><md-button aria-label=\"reload\" \nng-if=\"vm.actionPermit.view\" ng-click=\"vm.loadData(1)\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button><md-button aria-label=\"create\" \nng-if=\"vm.actionPermit.create\" ng-click=\"vm.showDialog($event, \'CREATE\', null)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n<md-button aria-label=\"upload\" ng-if=\"vm.actionPermit.upload\" ng-click=\"vm.uploadDialog($event)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-upload\"></md-icon></md-button>\n<md-button ng-click=\"vm.showFilter = !vm.showFilter\" aria-label=\"filter\" ng-if=\"vm.actionPermit.view\" \nng-class=\"{\'green-400-bg\' : vm.showFilter}\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon></md-button></div><div flex></div><ms-search-bar ng-if=\"vm.actionPermit.view\" \non-search=\"vm.pagination.load(1)\" query=\"vm.pagination.search\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-toolbar layout=\"row\" ng-show=\"vm.showFilter\" layout-align=\"space-between center\" \nclass=\"md-hue-3 secondary-toolbar\"><div class=\"md-toolbar-tools\"><md-input-container flex class=\"wrapper-input\"><label>\nCompetency</label><md-select ng-model=\"vm.competency\" class=\"md-accent md-hue-1\" name=\"competency\"><md-option \nng-selected=\"vm.competency == val.id\" ng-repeat=\"val in vm.listCompetencies\" ng-value=\"val.id\">{{val.description}}\n</md-option></md-select></md-input-container><md-input-container flex class=\"wrapper-input\"><label>Category</label>\n<md-select ng-model=\"vm.questionCategory\" class=\"md-accent md-hue-1\" name=\"category\"><md-option \nng-selected=\"vm.questionCategory == val.id\" ng-repeat=\"val in vm.listQuestionCategory\" ng-value=\"val.id\">\n{{val.description}}</md-option></md-select></md-input-container><md-input-container flex class=\"wrapper-input\"><label>\nQuestion Pool</label><md-select ng-model=\"vm.questionPool\" class=\"md-accent md-hue-1\" name=\"category\"><md-option \nng-selected=\"vm.questionPool == val.id\" ng-repeat=\"val in vm.listQuestionPool\" ng-value=\"val.id\">{{val.description}}\n</md-option></md-select></md-input-container></div></md-toolbar><div class=\"content md-background-bg\" ms-scroll>\n<md-content layout=\"column\" class=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table \nclass=\"app-table condensed\" ms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">\nNO</th><th class=\"text-start\">CODE</th><th class=\"text-start\">QUESTION</th><th class=\"text-center\">IMAGES</th><th \nclass=\"text-center\">ANSWERS</th><th translate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr></thead>\n<tbody><tr ng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"6\"><div flex \nlayout-align=\"center center\" layout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></div></td></tr><tr class=\"clickable\" ng-init=\"val.collapse = false\" \nng-click=\"val.collapse = !val.collapse\" \ndir-paginate-start=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" \ntotal-items=\"vm.pagination.total\" current-page=\"vm.pagination.current\"><td class=\"text-center w-50\">\n{{vm.pagination.from + $index}}</td><td class=\"text-start\">{{val.code}}</td><td class=\"text-start\"><span \nng-bind-html=\"vm.getQuestion(val.question.question)\"></span></td><td class=\"text-center\"><md-icon \nmd-font-icon=\"icon-check\" class=\"md-accent md-hue-1\" ng-if=\"val.question.having_images == 1\"></md-icon><md-icon \nmd-font-icon=\"icon-close\" class=\"md-warn md-hue-1\" ng-if=\"val.question.having_images == 0\"></md-icon></td><td \nclass=\"text-center\"><div layout=\"row\"><md-button ng-repeat=\"answer in val.answers\" \nclass=\"md-icon-button white-fg md-raised small-8\" \nng-class=\"{\'green-400-bg\' : answer.flag == 1, \'amber-900-bg\': answer.flag == 0}\">{{answer.abjact}}<md-tooltip>\n{{answer.answer || \'-\' }}</md-tooltip></md-button></div></td><td class=\"text-center\"><div layout=\"row\" \nlayout-align=\"center\"><md-button aria-label=\"update\" ng-if=\"vm.actionPermit.update\" \nng-click=\"vm.showDialog($event, \'UPDATE\', val)\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button aria-label=\"delete\" ng-if=\"vm.actionPermit.delete\" \nng-click=\"vm.showDialog($event, \'DELETE\', val, true)\" class=\"md-icon-button md-raised md-warn md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></div></td></tr><tr class=\"darken-white-10\" dir-paginate-end \nng-if=\"val.collapse\"><td colspan=\"6\"><div flex=\"100\" layout=\"row\" layout-fill layout-align=\"center start\" \nclass=\"container-detail p-10 animate-slide-down\"><div layout=\"column\" class=\"img-container\"><img \nng-init=\"vm.getQuestionImages(val.question.images, val)\" imageonload=\"{{val.question_image}}\" \nsrc=\"assets/images/loader.svg\"></div><div flex layout=\"column\"><div layout=\"row\"><div class=\"w-100\">Competency</div>\n<div class=\"w-10\">:</div><div>{{val.competency.name}}</div></div><div layout=\"row\"><div class=\"w-100\">Category</div>\n<div class=\"w-10\">:</div><div>{{val.question_category.name}}</div></div><div layout=\"row\"><div class=\"w-100\">Answers\n</div><div class=\"w-10\">:</div><div><ul class=\"list-answer\"><li ng-repeat=\"ans in val.answers\"><span \nng-class=\"{\'green-400-fg\' : ans.flag == 1, \'red-400-fg\': ans.flag == 0}\" class=\"margin-right-5\">{{ans.abjact}}</span> \n<span>{{ans.answer}}</span></li></ul></div></div></div></div></td></tr></tbody></table><dir-pagination-controls \non-page-change=\"vm.onPageChange(newPageNumber)\" template-url=\"app/core/templates/pagination.html\">\n</dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/qa/qa-papikostik/qa-papikostik.html","<div id=\"app-layout\" class=\"page-layout qa-general-component\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.QUESTION_PAPIKOSTIK.TITLE\">Papikostik Question</div><div \ntranslate=\"PAGE.QUESTION_PAPIKOSTIK.SUB_TITLE\" class=\"sub-title\">This is papikostik question page</div></div><div flex>\n</div><div class=\"header-toolbox\"><md-button aria-label=\"help\" class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" ng-init=\"vm.showFilter = false\" \nlayout-align=\"space-between center\" class=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25,50,100,150]\" \nng-value=\"val\">{{val}}</md-option></md-select></md-input-container><md-button aria-label=\"reload\" \nng-if=\"vm.actionPermit.view\" ng-click=\"vm.loadData(1)\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button></div><div flex></div><ms-search-bar \nng-if=\"vm.actionPermit.view\" on-search=\"vm.pagination.load(1)\" query=\"vm.pagination.search\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><div class=\"content md-background-bg\" ms-scroll><md-content layout=\"column\" \nclass=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table class=\"app-table condensed\" \nms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">NO</th><th \nclass=\"text-start\">QUESTION</th><th class=\"text-start\">ANSWERS</th><th translate=\"PAGE.COMMON.TOOLBOX.ACTION\" \nclass=\"text-center\">ACTION</th></tr></thead><tbody><tr ng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\">\n<td colspan=\"6\"><div flex layout-align=\"center center\" layout=\"column\" class=\"padding-20\"><md-progress-circular \nmd-mode=\"indeterminate\" md-diameter=\"50\"></md-progress-circular></div></td></tr><tr class=\"clickable\" \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + $index}}</td><td \nclass=\"text-start\">{{val.text}}</td><td class=\"text-center\"><div layout=\"column\"><div layout=\"row\" \nng-repeat=\"answer in val.papikostik_answers\" class=\"papikostik-answer-container\"><div class=\"papikostik-abjact\">\n{{answer.abjact}}</div><div class=\"papikosik-text\">{{answer.text}}</div></div></div></td><td class=\"text-center\"><div \nlayout=\"row\" layout-align=\"center\"><md-button aria-label=\"update\" ng-if=\"vm.actionPermit.update\" \nng-click=\"vm.showDialog($event, \'UPDATE\', val)\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button aria-label=\"delete\" ng-if=\"vm.actionPermit.delete\" \nng-click=\"vm.showDialog($event, \'DELETE\', val, true)\" class=\"md-icon-button md-raised md-warn md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></div></td></tr></tbody></table><dir-pagination-controls \non-page-change=\"vm.onPageChange(newPageNumber)\" template-url=\"app/core/templates/pagination.html\">\n</dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/qa/category/category.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.CATEGORY.TITLE\">Category</div><div \ntranslate=\"PAGE.CATEGORY.SUB_TITLE\" class=\"sub-title\">This is category page</div></div><div flex></div><div \nclass=\"header-toolbox\"><md-button aria-label=\"help\" class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25,50,100,150]\" \nng-value=\"val\">{{val}}</md-option></md-select></md-input-container><md-button aria-label=\"reload\" \nng-click=\"vm.loadData(1)\" ng-if=\"vm.actionPermit.view\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button><md-button aria-label=\"create\" \nng-if=\"vm.actionPermit.create\" ng-click=\"vm.showDialog($event, \'CREATE\', null)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div><div flex></div><ms-search-bar ng-if=\"vm.actionPermit.view\" on-search=\"vm.pagination.load(1)\" \nquery=\"vm.pagination.search\" debounce=\"300\"></ms-search-bar></div></md-toolbar><div class=\"content md-background-bg\" \nms-scroll><md-content layout=\"column\" class=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table \nclass=\"app-table condensed\" ms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">\nNO</th><th class=\"text-center w-50\">ID</th><th class=\"text-start\">NAME</th><th class=\"text-start\">CODE</th><th \nclass=\"text-start\">DESCRIPTION</th><th translate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr>\n</thead><tbody><tr ng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"7\"><div flex \nlayout-align=\"center center\" layout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></div></td></tr><tr \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + $index}}</td><td \nclass=\"text-center\">{{val.id}}</td><td class=\"text-start\">{{val.name}}</td><td class=\"text-start\">{{val.code}}</td><td \nclass=\"text-start\">{{val.description}}</td><td class=\"text-center\"><div layout=\"row\" layout-align=\"center\"><md-button \naria-label=\"update\" ng-if=\"vm.actionPermit.update\" ng-click=\"vm.showDialog($event, \'UPDATE\', val)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button>\n<md-button aria-label=\"delete\" ng-if=\"vm.actionPermit.delete\" ng-click=\"vm.showDialog($event, \'DELETE\', val, true)\" \nclass=\"md-icon-button md-raised md-warn md-hue-2 small-8\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button>\n</div></td></tr></tbody></table><dir-pagination-controls on-page-change=\"vm.onPageChange(newPageNumber)\" \ntemplate-url=\"app/core/templates/pagination.html\"></dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/qa/qa-tiki/qa-tiki.html","<div id=\"app-layout\" class=\"page-layout qa-general-component\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.QUESTION_TIKI.TITLE\">Tiki Question</div><div \ntranslate=\"PAGE.QUESTION_TIKI.SUB_TITLE\" class=\"sub-title\">This is tiki question page</div></div><div flex></div><div \nclass=\"header-toolbox\"><md-button aria-label=\"help\" class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" ng-init=\"vm.showFilter = false\" \nlayout-align=\"space-between center\" class=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div \nlayout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25,50,100,150]\" \nng-value=\"val\">{{val}}</md-option></md-select></md-input-container><md-button aria-label=\"reload\" \nng-if=\"vm.actionPermit.view\" ng-click=\"vm.loadData(1)\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button><md-button aria-label=\"create\" \nng-if=\"vm.actionPermit.create\" ng-click=\"vm.showDialog($event, \'CREATE\', null)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n<md-button aria-label=\"upload\" ng-if=\"vm.actionPermit.upload\" ng-click=\"vm.uploadDialog($event)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-upload\"></md-icon></md-button>\n<md-button ng-click=\"vm.showFilter = !vm.showFilter\" aria-label=\"filter\" ng-if=\"vm.actionPermit.view\" \nng-class=\"{\'green-400-bg\' : vm.showFilter}\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon></md-button></div><div flex></div><ms-search-bar ng-if=\"vm.actionPermit.view\" \non-search=\"vm.pagination.load(1)\" query=\"vm.pagination.search\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-toolbar layout=\"row\" ng-show=\"vm.showFilter\" layout-align=\"space-between center\" \nclass=\"md-hue-3 secondary-toolbar\"><div class=\"md-toolbar-tools\"><md-input-container flex class=\"wrapper-input\"><label>\nSection</label><md-select ng-model=\"vm.section\" class=\"md-accent md-hue-1\" name=\"category\"><md-option \nng-selected=\"vm.section == val.id\" ng-repeat=\"val in vm.listSections\" ng-value=\"val.id\">{{val.description}}</md-option>\n</md-select></md-input-container></div></md-toolbar><div class=\"content md-background-bg\" ms-scroll><md-content \nlayout=\"column\" class=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table \nclass=\"app-table condensed\" ms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">\nNO</th><th class=\"text-start\">QUESTION</th><th class=\"text-center\">ANSWERS</th></tr></thead><tbody><tr \nng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"6\"><div flex layout-align=\"center center\" \nlayout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div></td></tr><tr class=\"clickable\" ng-init=\"val.collapse = false\" \nng-click=\"val.collapse = !val.collapse\" \ndir-paginate-start=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" \ntotal-items=\"vm.pagination.total\" current-page=\"vm.pagination.current\"><td class=\"text-center w-50\">\n{{vm.pagination.from + $index}}</td><td class=\"text-start\"><img ng-if=\"val.type == 2\" \nimageonload=\"assets/images/tiki/{{val.question}}\" src=\"assets/images/loader.svg\"> <span ng-if=\"val.type == 1\">\n{{val.question}}</span></td><td class=\"text-center\"><div layout=\"row\" layout-align=\"center center\"><md-button \nng-repeat=\"answer in val.answer\" class=\"md-icon-button white-fg md-raised small-8\" \nng-class=\"{\'green-400-bg\' : answer.flag == 1, \'amber-900-bg\': answer.flag == 0}\">{{vm.getAbjact($index)}}<md-tooltip>\n{{answer.flag || \'-\' }}</md-tooltip></md-button></div></td></tr><tr class=\"darken-white-10\" dir-paginate-end \nng-if=\"val.collapse\"><td colspan=\"6\"><div flex=\"100\" layout=\"row\" layout-fill layout-align=\"center start\" \nclass=\"container-detail p-10 animate-slide-down\"><div flex layout=\"column\"><div layout=\"row\"><div class=\"w-100\">Section\n</div><div class=\"w-10\">:</div><div>{{val.section.name}}</div></div><div layout=\"row\"><div class=\"w-100\">Answers</div>\n<div class=\"w-10\">:</div><div><ul class=\"list-answer\"><li ng-if=\"val.type == 1\" ng-repeat=\"ans in val.answer\"><span \nng-class=\"{\'green-400-fg\' : ans.flag == 1, \'red-400-fg\': ans.flag == 0}\" class=\"margin-right-5\">\n{{vm.getAbjact($index)}}</span> <span>{{ans.answer}}</span></li><li class=\"list-image\" ng-if=\"val.type == 2\" \nng-repeat=\"ans in val.answer\"><span class=\"abj\">{{vm.getAbjact($index)}}</span> <img \nimageonload=\"assets/images/tiki/{{ans.answer}}\" src=\"assets/images/loader.svg\" ng-if=\"val.type == 2\"></li></ul></div>\n</div></div></div></td></tr></tbody></table><dir-pagination-controls on-page-change=\"vm.onPageChange(newPageNumber)\" \ntemplate-url=\"app/core/templates/pagination.html\"></dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/report/general/general.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.REPORT.GENERAL.TITLE\">Report</div><div \ntranslate=\"PAGE.REPORT.GENERAL.SUB_TITLE\" class=\"sub-title\">This is question report page</div></div><div flex></div>\n<div class=\"header-toolbox\"><md-button class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25]\" ng-value=\"val\">{{val}}\n</md-option></md-select></md-input-container><md-button aria-label=\"reload\" ng-click=\"vm.loadData(1)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button>\n<md-button aria-label=\"export\" ng-click=\"vm.exportData()\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-file-excel-box\"></md-icon></md-button><md-button ng-click=\"vm.showFilter = !vm.showFilter\" \naria-label=\"filter\" ng-class=\"{\'green-400-bg\' : vm.showFilter}\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button>\n</div><div flex></div><ms-search-bar on-search=\"vm.pagination.load(1)\" query=\"vm.pagination.search\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-toolbar layout=\"row\" ng-show=\"vm.showFilter\" \nlayout-align=\"space-between center\" class=\"md-hue-3 secondary-toolbar\"><div class=\"md-toolbar-tools\">\n<md-input-container flex class=\"wrapper-input\"><label>Start Date</label><input type=\"date\" name=\"start_date\" \nng-model=\"vm.tempStart\" class=\"md-accent md-hue-1\"></md-input-container><md-input-container flex class=\"wrapper-input\">\n<label>End Date</label><input type=\"date\" name=\"end_date\" ng-model=\"vm.tempEnd\" class=\"md-accent md-hue-1\">\n</md-input-container></div></md-toolbar><div class=\"content md-background-bg\" ms-scroll><md-content layout=\"column\" \nclass=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table class=\"app-table condensed\" \nms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">NO</th><th \nclass=\"text-start\">NIK</th><th class=\"text-start\">NAME</th><th class=\"text-start\">GROUP</th><th class=\"text-center\">\nFINISHED AT</th><th class=\"text-center\">QUESTION TOTAL</th><th class=\"text-right\">SCORE (AVG BY % CATEGORY)</th><th \ntranslate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr></thead><tbody><tr \nng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"8\"><div flex layout-align=\"center center\" \nlayout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div></td></tr><tr \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + $index}}</td><td \nclass=\"text-start\">{{val.user.nik}}</td><td class=\"text-start\">{{val.user.name | uppercase }}</td><td \nclass=\"text-start\">{{val.session.group_participant.name}}</td><td class=\"text-center\">{{val.created_at}}</td><td \nclass=\"text-center\">{{val.question_total}}</td><td class=\"text-right\">{{ val.avg_category | number:2 }} %</td><td \nclass=\"text-center\"><div layout=\"row\" layout-align=\"center\"><md-button aria-label=\"view\" ng-click=\"vm.goToDetail(val)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button>\n</div></td></tr></tbody></table><dir-pagination-controls on-page-change=\"vm.onPageChange(newPageNumber)\" \ntemplate-url=\"app/core/templates/pagination.html\"></dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/report/papikostik/papikostik.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.REPORT.PAPIKOSTIK.TITLE\">Report</div><div \ntranslate=\"PAGE.REPORT.PAPIKOSTIK.SUB_TITLE\" class=\"sub-title\">This is papikostik report page</div></div><div flex>\n</div><div class=\"header-toolbox\"><md-button class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25]\" ng-value=\"val\">{{val}}\n</md-option></md-select></md-input-container><md-button aria-label=\"reload\" ng-click=\"vm.loadData(1)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button>\n<md-button aria-label=\"export\" ng-click=\"vm.exportData()\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-file-excel-box\"></md-icon></md-button><md-button ng-click=\"vm.showFilter = !vm.showFilter\" \naria-label=\"filter\" ng-class=\"{\'green-400-bg\' : vm.showFilter}\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button>\n</div><div flex></div><ms-search-bar on-search=\"vm.pagination.load(1)\" query=\"vm.pagination.search\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-toolbar layout=\"row\" ng-show=\"vm.showFilter\" \nlayout-align=\"space-between center\" class=\"md-hue-3 secondary-toolbar\"><div class=\"md-toolbar-tools\">\n<md-input-container flex class=\"wrapper-input\"><label>Start Date</label><input type=\"date\" name=\"date\" \nng-model=\"vm.startDate\" class=\"md-accent md-hue-1\"></md-input-container><md-input-container flex class=\"wrapper-input\">\n<label>End Date</label><input type=\"date\" name=\"date\" ng-model=\"vm.endDate\" class=\"md-accent md-hue-1\">\n</md-input-container></div></md-toolbar><div class=\"content md-background-bg\" ms-scroll><md-content layout=\"column\" \nclass=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table class=\"app-table condensed\" \nms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">no</th><th \nclass=\"text-center\">nik</th><th class=\"text-start\">name</th><th class=\"text-center\">finished date</th><th \nclass=\"text-center\">finished time</th><th translate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr>\n</thead><tbody><tr ng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"8\"><div flex \nlayout-align=\"center center\" layout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></div></td></tr><tr \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + $index}}</td><td \nclass=\"text-center\">{{val.nik}}</td><td class=\"text-start\">{{val.name}}</td><td class=\"text-center\">\n{{val.take_in_date}}</td><td class=\"text-center\">{{val.take_in_time}}</td><td><div layout=\"row\" layout-align=\"center\">\n<md-button aria-label=\"view\" ng-click=\"vm.viewDetail($event, val)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button>\n</div></td></tr></tbody></table><dir-pagination-controls on-page-change=\"vm.onPageChange(newPageNumber)\" \ntemplate-url=\"app/core/templates/pagination.html\"></dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/report/survey/survey.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.REPORT.SURVEY.TITLE\">Report</div><div \ntranslate=\"PAGE.REPORT.SURVEY.SUB_TITLE\" class=\"sub-title\">This is case study report page</div></div><div flex></div>\n<div class=\"header-toolbox\"><md-button class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25]\" ng-value=\"val\">{{val}}\n</md-option></md-select></md-input-container><md-button aria-label=\"reload\" ng-click=\"vm.loadData(1)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button>\n<md-button aria-label=\"export\" ng-click=\"vm.exportData()\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-file-pdf-box\"></md-icon></md-button><md-button ng-click=\"vm.showFilter = !vm.showFilter\" \naria-label=\"filter\" ng-class=\"{\'green-400-bg\' : vm.showFilter}\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button>\n</div><div flex></div><ms-search-bar on-search=\"vm.pagination.load(1)\" query=\"vm.pagination.search\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-toolbar layout=\"row\" ng-show=\"vm.showFilter\" \nlayout-align=\"space-between center\" class=\"md-hue-3 secondary-toolbar\"><div class=\"md-toolbar-tools\">\n<md-input-container flex class=\"wrapper-input\"><label>Start Date</label><input type=\"date\" name=\"date\" \nng-model=\"vm.startDate\" class=\"md-accent md-hue-1\"></md-input-container><md-input-container flex class=\"wrapper-input\">\n<label>End Date</label><input type=\"date\" name=\"date\" ng-model=\"vm.endDate\" class=\"md-accent md-hue-1\">\n</md-input-container></div></md-toolbar><div class=\"content md-background-bg\" ms-scroll><md-content layout=\"column\" \nclass=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table class=\"app-table condensed\" \nms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">no</th><th \nclass=\"text-center\">nik</th><th class=\"text-start\">name</th><th class=\"text-center\">finished date</th><th \nclass=\"text-center\">finished time</th><th translate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr>\n</thead><tbody><tr ng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"8\"><div flex \nlayout-align=\"center center\" layout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></div></td></tr><tr \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + $index}}</td><td \nclass=\"text-center\">{{val.nik}}</td><td class=\"text-start\">{{val.name}}</td><td class=\"text-center\">\n{{val.take_in_date}}</td><td class=\"text-center\">{{val.take_in_time}}</td><td><div layout=\"row\" layout-align=\"center\">\n<md-button aria-label=\"view\" ng-click=\"vm.viewDetail($event, val)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button>\n</div></td></tr></tbody></table><dir-pagination-controls on-page-change=\"vm.onPageChange(newPageNumber)\" \ntemplate-url=\"app/core/templates/pagination.html\"></dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/report/tiki/tiki.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.REPORT_TIKI.TITLE\">Report</div><div \ntranslate=\"PAGE.REPORT_TIKI.SUB_TITLE\" class=\"sub-title\">This is question report page</div></div><div flex></div><div \nclass=\"header-toolbox\"><md-button class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25]\" ng-value=\"val\">{{val}}\n</md-option></md-select></md-input-container><md-button aria-label=\"reload\" ng-click=\"vm.loadData(1)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button>\n<md-button aria-label=\"export\" ng-click=\"vm.exportData()\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-file-excel-box\"></md-icon></md-button><md-button ng-click=\"vm.showFilter = !vm.showFilter\" \naria-label=\"filter\" ng-class=\"{\'green-400-bg\' : vm.showFilter}\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button>\n</div><div flex></div><ms-search-bar on-search=\"vm.pagination.load(1)\" query=\"vm.pagination.search\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-toolbar layout=\"row\" ng-show=\"vm.showFilter\" \nlayout-align=\"space-between center\" class=\"md-hue-3 secondary-toolbar\"><div class=\"md-toolbar-tools\">\n<md-input-container flex class=\"wrapper-input\"><label>Start Date</label><input type=\"date\" name=\"date\" \nng-model=\"vm.tempDate\" class=\"md-accent md-hue-1\"></md-input-container></div></md-toolbar><div \nclass=\"content md-background-bg\" ms-scroll><md-content layout=\"column\" class=\"container\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><table class=\"app-table condensed\" ms-responsive-table><thead><tr \nclass=\"md-accent-bg md-hue-2\"><th rowspan=\"2\" class=\"text-center w-50\">NO</th><th rowspan=\"2\" class=\"text-start\">NIK\n</th><th rowspan=\"2\" class=\"text-start\">NAME</th><th class=\"text-center\" colspan=\"3\">Section 1</th><th \nclass=\"text-center\" colspan=\"3\">Section 2</th><th class=\"text-center\" colspan=\"3\">Section 3</th><th \nclass=\"text-center\" colspan=\"3\">Section 4</th><th rowspan=\"2\" class=\"text-center w-40\">F1</th><th rowspan=\"2\" \nclass=\"text-center w-40\">F2</th><th rowspan=\"2\" class=\"text-center w-40\">F3</th><th rowspan=\"2\" \nclass=\"text-center w-40\">IQ</th></tr><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-20\">C</th><th \nclass=\"text-center w-20\">I</th><th class=\"text-center w-20\">STD</th><th class=\"text-center w-20\">C</th><th \nclass=\"text-center w-20\">I</th><th class=\"text-center w-20\">STD</th><th class=\"text-center w-20\">C</th><th \nclass=\"text-center w-20\">I</th><th class=\"text-center w-20\">STD</th><th class=\"text-center w-20\">C</th><th \nclass=\"text-center w-20\">I</th><th class=\"text-center w-20\">STD</th></tr></thead><tbody><tr \nng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"8\"><div flex layout-align=\"center center\" \nlayout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div></td></tr><tr \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + $index}}</td><td \nclass=\"text-start\">{{val.nik}}</td><td class=\"text-start\">{{val.name | uppercase }}</td><td class=\"text-center\">\n{{val.results.section_1_correct}}</td><td class=\"text-center\">{{val.results.section_1_incorrect}}</td><td \nclass=\"text-center\">{{val.results.section_1_std}}</td><td class=\"text-center\">{{val.results.section_2_correct}}</td><td\n class=\"text-center\">{{val.results.section_2_incorrect}}</td><td class=\"text-center\">{{val.results.section_2_std}}</td>\n<td class=\"text-center\">{{val.results.section_3_correct}}</td><td class=\"text-center\">\n{{val.results.section_3_incorrect}}</td><td class=\"text-center\">{{val.results.section_3_std}}</td><td \nclass=\"text-center\">{{val.results.section_4_correct}}</td><td class=\"text-center\">{{val.results.section_4_incorrect}}\n</td><td class=\"text-center\">{{val.results.section_4_std}}</td><td class=\"text-center\">{{val.results.f1}}</td><td \nclass=\"text-center\">{{val.results.f2}}</td><td class=\"text-center\">{{val.results.f3}}</td><td class=\"text-center\">\n{{val.results.iq_score}}</td></tr></tbody></table><dir-pagination-controls \non-page-change=\"vm.onPageChange(newPageNumber)\" template-url=\"app/core/templates/pagination.html\">\n</dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/session/form/form.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-md=\"70\" class=\"session-dialog\" md-theme=\"{{vm.theme}}\"><form \nname=\"frmRequest\" ng-cloak><md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 \nclass=\"text-capitalize\">{{vm.dialogType | titleCase }} Session</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ng-init=\"vm.setForm(frmRequest)\"><div class=\"form-overlay-wrapper animate-fade-in-out\" \nng-show=\"vm.isLoading\"><div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\">\n<md-progress-circular md-diameter=\"20px\" class=\"md-warn\"></md-progress-circular><div class=\"padding-top-10\">\n{{vm.loadingMessage}}</div></div></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container class=\"md-accent\" \nflex><label>Session Type</label><md-select ng-model=\"vm.data.session_type\" required placeholder=\"Select Session Type\" \nng-change=\"vm.onChangeSessionType()\" name=\"session_type\"><md-option ng-selected=\"item == vm.data.session_type\" \nng-repeat=\"item in vm.sessionType\" ng-value=\"item\">{{item.split(\'_\').join(\' \') | uppercase}}</md-option></md-select>\n<div class=\"md-errors-spacer\"></div><div ng-messages=\"frmRequest.session_type.$error\"><div ng-message=\"required\">\nThis is required!</div></div></md-input-container><md-input-container class=\"md-accent\" flex><label>Question Pool\n</label><md-select ng-model=\"vm.data.question_pool_id\" required placeholder=\"Select Question Pool\" \nname=\"question_pool\"><md-option ng-selected=\"item.id == vm.data.question_pool_id\" ng-repeat=\"item in vm.questionPool\" \nng-value=\"item.id\">{{item.description}}</md-option></md-select><div class=\"md-errors-spacer\"></div><div \nng-messages=\"frmRequest.question_pool.$error\"><div ng-message=\"required\">This is required!</div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nng-if=\"vm.showEntity.survey || vm.showEntity.case_study\" class=\"md-accent\" flex><label>{{vm.refTitle}}</label>\n<md-select ng-model=\"vm.data.ref_id\" required class=\"md-accent md-hue-1\" name=\"ref\"><md-option \nng-selected=\"vm.data.ref_id == val.id\" ng-repeat=\"val in vm.listRef\" ng-value=\"val.id\">{{val.description}}</md-option>\n</md-select><div class=\"md-errors-spacer\"></div><div ng-messages=\"frmRequest.ref.$error\"><div ng-message=\"required\">\nThis is required!</div></div></md-input-container><md-input-container class=\"md-accent\" flex><label>Guides</label>\n<md-select ng-model=\"vm.data.guides_id\" required placeholder=\"Select Guides\" name=\"guides\"><md-option \nng-selected=\"item.id == vm.data.guides_id\" ng-repeat=\"item in vm.guides\" ng-value=\"item.id\">{{item.description}}\n</md-option></md-select><div class=\"md-errors-spacer\"></div><div ng-messages=\"frmRequest.guides.$error\"><div \nng-message=\"required\">This is required!</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container ng-show=\"vm.showEntity.duration\" class=\"md-accent\" flex><label>Duration (in minutes)</label><input \nname=\"duration\" type=\"number\" placeholder=\"ex: 30\" required ng-model=\"vm.data.session_duration\"><div \nng-messages=\"frmRequest.duration.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container>\n<md-input-container ng-show=\"vm.showEntity.question_limit\" class=\"md-accent\" flex><label>\nQuestion Limit (0 for no limit)</label><input name=\"question_limit\" type=\"number\" placeholder=\"ex: 10\" required \nng-model=\"vm.data.question_limit\"><div ng-messages=\"frmRequest.question_limit.$error\"><div ng-message=\"required\">\nThis is required!</div></div></md-input-container><md-input-container class=\"md-accent\" flex><label>Order</label><input\n name=\"session_order\" type=\"number\" placeholder=\"ex: 1\" required ng-model=\"vm.data.session_order\"><div \nng-messages=\"frmRequest.session_order.$error\"><div ng-message=\"required\">This is required!</div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container class=\"md-accent\" flex><label>\nStart Date</label><input name=\"session_start_date\" type=\"date\" required ng-model=\"vm.tmpStartDate\"><div \nng-messages=\"frmRequest.session_start_date.$error\"><div ng-message=\"required\">This is required!</div></div>\n</md-input-container><md-input-container class=\"md-accent\" flex><label>Start Time</label><input \nname=\"session_start_time\" type=\"time\" required ng-model=\"vm.tmpStartTime\"><div \nng-messages=\"frmRequest.session_start_time.$error\"><div ng-message=\"required\">This is required!</div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container class=\"md-accent\" flex><label>\nEnd Date</label><input name=\"session_end_date\" type=\"date\" required ng-model=\"vm.tmpEndDate\"><div \nng-messages=\"frmRequest.session_end_date.$error\"><div ng-message=\"required\">This is required!</div></div>\n</md-input-container><md-input-container class=\"md-accent\" flex><label>End Time</label><input name=\"session_end_time\" \ntype=\"time\" required ng-model=\"vm.tmpEndTime\"><div ng-messages=\"frmRequest.session_end_time.$error\"><div \nng-message=\"required\">This is required!</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"column\" ng-if=\"vm.dialogType === \'CREATE\'\"><md-autocomplete md-delay=\"1000\" flex \nmd-selected-item=\"vm.user\" md-selected-item-change=\"vm.selectedItemChange(item)\" md-require-match \nplaceholder=\"Search Users\" md-clear-button=\"true\" md-search-text=\"vm.searchText\" md-input-name=\"users\" \nmd-floating-label=\"Search Users\" md-no-cache=\"false\" md-menu-class=\"autocomplete-custom-template\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"vm.getItemText(item)\" md-min-length=\"2\">\n<md-item-template><span class=\"item-title\" md-highlight-text=\"vm.searchText\">{{ vm.getItemText(item) | uppercase}}\n</span></md-item-template><div class=\"md-errors-spacer\"></div><div ng-messages=\"frmRequest.users.$error\" role=\"alert\">\n<div ng-message=\"required\">This is required</div></div><md-not-found>No Record matching \"{{vm.searchText}}\" were found.\n</md-not-found></md-autocomplete><div layout=\"row\"><md-checkbox ng-true-value=\"1\" ng-false-value=\"0\" \nng-model=\"vm.data.send_mail\">Send Mail</md-checkbox></div><div layout=\"row\"><fieldset><legend>List Users</legend>\n<md-list flex><md-list-item class=\"md-no-proxy\" class=\"md-2-line\" ng-repeat-start=\"item in vm.data.users\"><md-button \nng-click=\"vm.removeUsers($index)\" class=\"md-secondary md-icon-button md-warn\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button><div class=\"md-list-item-text\"><h3>{{item.nik}}</h3><p>{{item.name}}</p></div></md-list-item>\n<md-divider ng-repeat-end></md-divider></md-list></fieldset></div></div><div layout=\"row\" \nng-if=\"vm.dialogType === \'UPDATE\'\"><md-input-container class=\"md-accent\" flex><label>Users</label><input type=\"text\" \nname=\"user\" readonly=\"readonly\" ng-model=\"vm.data.user.name\"></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout=\"start center\"><span ng-show=\"vm.errorMessage\" \nclass=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} </span><span flex></span><md-button \nng-click=\"vm.cancel()\">CLOSE</md-button><md-button ng-if=\"vm.dialogType === \'CREATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid || vm.data.users.length === 0\" md-autofocus class=\"md-accent\" \nng-click=\"vm.submit($event, frmRequest)\">CREATE</md-button><md-button ng-if=\"vm.dialogType === \'UPDATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.update($event, frmRequest)\">UPDATE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/report/case-study/case-study.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.REPORT.CASE_STUDY.TITLE\">Report</div><div \ntranslate=\"PAGE.REPORT.CASE_STUDY.SUB_TITLE\" class=\"sub-title\">This is case study report page</div></div><div flex>\n</div><div class=\"header-toolbox\"><md-button class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25]\" ng-value=\"val\">{{val}}\n</md-option></md-select></md-input-container><md-button aria-label=\"reload\" ng-click=\"vm.loadData(1)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button>\n<md-button aria-label=\"export\" ng-click=\"vm.exportData()\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-file-excel-box\"></md-icon></md-button><md-button ng-click=\"vm.showFilter = !vm.showFilter\" \naria-label=\"filter\" ng-class=\"{\'green-400-bg\' : vm.showFilter}\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-filter\"></md-icon></md-button>\n</div><div flex></div><ms-search-bar on-search=\"vm.pagination.load(1)\" query=\"vm.pagination.search\" debounce=\"300\">\n</ms-search-bar></div></md-toolbar><md-toolbar layout=\"row\" ng-show=\"vm.showFilter\" \nlayout-align=\"space-between center\" class=\"md-hue-3 secondary-toolbar\"><div class=\"md-toolbar-tools\">\n<md-input-container flex class=\"wrapper-input\"><label>Start Date</label><input type=\"date\" name=\"date\" \nng-model=\"vm.startDate\" class=\"md-accent md-hue-1\"></md-input-container><md-input-container flex class=\"wrapper-input\">\n<label>End Date</label><input type=\"date\" name=\"date\" ng-model=\"vm.endDate\" class=\"md-accent md-hue-1\">\n</md-input-container></div></md-toolbar><div class=\"content md-background-bg\" ms-scroll><md-content layout=\"column\" \nclass=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table class=\"app-table condensed\" \nms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">no</th><th \nclass=\"text-center\">nik</th><th class=\"text-start\">name</th><th class=\"text-center\">finished date</th><th \nclass=\"text-center\">finished time</th><th translate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr>\n</thead><tbody><tr ng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"8\"><div flex \nlayout-align=\"center center\" layout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></div></td></tr><tr \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + $index}}</td><td \nclass=\"text-center\">{{val.nik}}</td><td class=\"text-start\">{{val.name}}</td><td class=\"text-center\">\n{{val.take_in_date}}</td><td class=\"text-center\">{{val.take_in_time}}</td><td><div layout=\"row\" layout-align=\"center\">\n<md-button aria-label=\"view\" ng-click=\"vm.viewDetail($event, val)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></md-button>\n</div></td></tr></tbody></table><dir-pagination-controls on-page-change=\"vm.onPageChange(newPageNumber)\" \ntemplate-url=\"app/core/templates/pagination.html\"></dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/survey/category/category.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.SURVEY.CATEGORY.TITLE\">Survey Category</div><div \ntranslate=\"PAGE.SURVEY.CATEGORY.SUB_TITLE\" class=\"sub-title\">This is survey category page</div></div><div flex></div>\n<div class=\"header-toolbox\"><md-button aria-label=\"help\" class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25,50,100,150]\" \nng-value=\"val\">{{val}}</md-option></md-select></md-input-container><md-button aria-label=\"reload\" \nng-click=\"vm.loadData(1)\" ng-if=\"vm.actionPermit.view\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button><md-button aria-label=\"create\" \nng-if=\"vm.actionPermit.create\" ng-click=\"vm.showDialog($event, \'CREATE\', null)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n<md-button ng-click=\"vm.showFilter = !vm.showFilter\" aria-label=\"filter\" ng-if=\"vm.actionPermit.view\" \nng-class=\"{\'green-400-bg\' : vm.showFilter}\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon></md-button></div><div flex></div><ms-search-bar ng-if=\"vm.actionPermit.view\" \non-search=\"vm.pagination.load(1)\" query=\"vm.pagination.search\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-toolbar layout=\"row\" ng-show=\"vm.showFilter\" layout-align=\"space-between center\" \nclass=\"md-hue-3 secondary-toolbar\"><div class=\"md-toolbar-tools\"><md-input-container flex class=\"wrapper-input\"><label>\nType</label><md-select ng-model=\"vm.type\" class=\"md-accent md-hue-1\" name=\"type\"><md-option \nng-selected=\"vm.type == val\" ng-repeat=\"val in vm.listType\" ng-value=\"val\">{{val}}</md-option></md-select>\n</md-input-container></div></md-toolbar><div class=\"content md-background-bg\" ms-scroll><md-content layout=\"column\" \nclass=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table class=\"app-table condensed\" \nms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">NO</th><th \nclass=\"text-center w-50\">ID</th><th class=\"text-start\">NAME</th><th class=\"text-start\">TYPE</th><th class=\"text-start\">\nDESCRIPTION</th><th translate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr></thead><tbody><tr \nng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"7\"><div flex layout-align=\"center center\" \nlayout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div></td></tr><tr \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + $index}}</td><td \nclass=\"text-center\">{{val.id}}</td><td class=\"text-start\">{{val.name}}</td><td class=\"text-start\">{{val.type}}</td><td \nclass=\"text-start\">{{val.description}}</td><td class=\"text-center\"><div layout=\"row\" layout-align=\"center\"><md-button \naria-label=\"update\" ng-if=\"vm.actionPermit.update\" ng-click=\"vm.showDialog($event, \'UPDATE\', val)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button>\n<md-button aria-label=\"delete\" ng-if=\"vm.actionPermit.delete\" ng-click=\"vm.showDialog($event, \'DELETE\', val, true)\" \nclass=\"md-icon-button md-raised md-warn md-hue-2 small-8\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button>\n</div></td></tr></tbody></table><dir-pagination-controls on-page-change=\"vm.onPageChange(newPageNumber)\" \ntemplate-url=\"app/core/templates/pagination.html\"></dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/session/upload/upload.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-sm=\"50\" class=\"session-upload-dialog\" md-theme=\"{{vm.theme}}\"><form \nname=\"frmRequest\" ng-cloak><md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 \nclass=\"text-capitalize\">Upload Session</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"padding-0\"><div class=\"form-overlay-wrapper animate-fade-in-out\" ng-show=\"vm.isLoading\"><div \nflex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\"><md-progress-circular \nmd-diameter=\"20px\" class=\"md-warn\"></md-progress-circular><div class=\"padding-top-10\">{{vm.loadingMessage}}</div></div>\n</div><div class=\"md-dialog-content\"><div layout=\"column\"><div layout=\"column\" layout-padding><input type=\"file\" \nngf-select required ng-model=\"vm.file\" name=\"file\" ngf-pattern=\"\'.xls,.xlsx\'\" accept=\".xls,.xlsx\" ngf-max-size=\"2MB\" \nngf-model-invalid=\"vm.errorFile\"><div class=\"margin-top-10\" ng-show=\"frmRequest.file.$error.maxSize\"><span \nclass=\"text-boxed md-warn-fg margin-0\">File too large {{errorFile.size / 1000000|number:1}} MB: max 2M</span></div><div\n class=\"margin-top-10\" ng-show=\"frmRequest.file.$error.pattern\"><span class=\"text-boxed md-warn-fg margin-0\">\nFile Extension must be .xls or .xlsx</span></div></div><div layout=\"column\" layout-padding><div layout=\"row\">Upload Log\n</div><div layout=\"row\" class=\"simple-table-container\"><table class=\"app-table condensed\" ms-responsive-table><thead>\n<tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center\">Row</th><th class=\"text-center\">Nik</th><th \nclass=\"text-center\">Name</th><th class=\"text-center\">Email</th><th class=\"text-center\">Status</th><th \nclass=\"text-center\">Message</th></tr></thead><tbody><tr \ndir-paginate=\"item in vm.filtered | itemsPerPage: vm.numPerPage\" total-items=\"vm.totalItems\" \ncurrent-page=\"vm.currentPage\" pagination-id=\"more-detail\"><td class=\"text-center\">{{$index + 1}}</td><td \nclass=\"text-center\">{{item.data.nik}}</td><td class=\"text-center\">{{item.data.name}}</td><td class=\"text-center\">\n{{item.data.email}}</td><td class=\"text-center\"><md-icon ng-if=\"item.status\" class=\"green-400-fg\" \nmd-font-icon=\"icon-check\"></md-icon><md-icon ng-if=\"!item.status\" class=\"red-400-fg\" md-font-icon=\"icon-close\">\n</md-icon></td><td class=\"text-center\">{{item.message}}</td></tr></tbody></table></div><div layout=\"row\">\n<dir-pagination-controls template-url=\"app/core/templates/pagination.html\" pagination-id=\"more-detail\">\n</dir-pagination-controls></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout=\"start center\"><span ng-show=\"vm.errorMessage\" class=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} \n</span><span flex></span><md-button ng-click=\"vm.cancel()\">CLOSE</md-button><md-button md-autofocus \nng-click=\"vm.downloadTemplate()\" class=\"md-accent\">DOWNLOAD TEMPLATE</md-button><md-button \nng-disabled=\"vm.isLoading || frmRequest.$pristine || frmRequest.$invalid\" class=\"md-accent\" \nng-click=\"vm.submit($event)\">UPLOAD</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/survey/question/question.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.SURVEY.QUESTION.TITLE\">Survey Question</div><div \ntranslate=\"PAGE.SURVEY.QUESTION.SUB_TITLE\" class=\"sub-title\">This is survey question page</div></div><div flex></div>\n<div class=\"header-toolbox\"><md-button aria-label=\"help\" class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25,50,100,150]\" \nng-value=\"val\">{{val}}</md-option></md-select></md-input-container><md-button aria-label=\"reload\" \nng-click=\"vm.loadData(1)\" ng-if=\"vm.actionPermit.view\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button><md-button aria-label=\"create\" \nng-if=\"vm.actionPermit.create\" ng-click=\"vm.showDialog($event, \'CREATE\', null)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n<md-button ng-click=\"vm.showFilter = !vm.showFilter\" aria-label=\"filter\" ng-if=\"vm.actionPermit.view\" \nng-class=\"{\'green-400-bg\' : vm.showFilter}\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon></md-button></div><div flex></div><ms-search-bar ng-if=\"vm.actionPermit.view\" \non-search=\"vm.pagination.load(1)\" query=\"vm.pagination.search\" debounce=\"300\"></ms-search-bar></div></md-toolbar>\n<md-toolbar layout=\"row\" ng-show=\"vm.showFilter\" layout-align=\"space-between center\" \nclass=\"md-hue-3 secondary-toolbar\"><div class=\"md-toolbar-tools\"><md-input-container flex class=\"wrapper-input\"><label>\nCategory</label><md-select ng-model=\"vm.category\" class=\"md-accent md-hue-1\" name=\"type\"><md-option \nng-selected=\"vm.category == val.id\" ng-repeat=\"val in vm.listCategory\" ng-value=\"val.id\">{{val.description}}\n</md-option></md-select></md-input-container><md-input-container flex class=\"wrapper-input\"><label>Type</label>\n<md-select ng-model=\"vm.type\" class=\"md-accent md-hue-1\" name=\"type\"><md-option ng-selected=\"vm.type == val\" \nng-repeat=\"val in vm.listType\" ng-value=\"val\">{{val}}</md-option></md-select></md-input-container></div></md-toolbar>\n<div class=\"content md-background-bg\" ms-scroll><md-content layout=\"column\" class=\"container\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><table class=\"app-table condensed\" ms-responsive-table><thead><tr \nclass=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">NO</th><th class=\"text-center w-50\">ID</th><th \nclass=\"text-start\">QUESTION</th><th class=\"text-start\">TYPE</th><th class=\"text-start\">CATEGORY</th><th \nclass=\"text-start\">ORDER</th><th translate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr></thead>\n<tbody><tr ng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"7\"><div flex \nlayout-align=\"center center\" layout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></div></td></tr><tr \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + $index}}</td><td \nclass=\"text-center\">{{val.id}}</td><td class=\"text-start\">{{val.question}}</td><td class=\"text-start\">\n{{val.survey_category.type}}</td><td class=\"text-start\">{{val.survey_category.name}}</td><td class=\"text-start\">\n{{val.question_order}}</td><td class=\"text-center\"><div layout=\"row\" layout-align=\"center\"><md-button \naria-label=\"update\" ng-if=\"vm.actionPermit.update\" ng-click=\"vm.showDialog($event, \'UPDATE\', val)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button>\n<md-button aria-label=\"delete\" ng-if=\"vm.actionPermit.delete\" ng-click=\"vm.showDialog($event, \'DELETE\', val, true)\" \nclass=\"md-icon-button md-raised md-warn md-hue-2 small-8\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button>\n</div></td></tr></tbody></table><dir-pagination-controls on-page-change=\"vm.onPageChange(newPageNumber)\" \ntemplate-url=\"app/core/templates/pagination.html\"></dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/survey/scheme/scheme.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.SURVEY.QUESTION.TITLE\">Survey Question</div><div \ntranslate=\"PAGE.SURVEY.QUESTION.SUB_TITLE\" class=\"sub-title\">This is survey question page</div></div><div flex></div>\n<div class=\"header-toolbox\"><md-button aria-label=\"help\" class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"total-page\"><label>Total</label><md-select \nng-model=\"vm.pagination.page_size\" name=\"total_page\"><md-option ng-repeat=\"val in [5,15,20,25,50,100,150]\" \nng-value=\"val\">{{val}}</md-option></md-select></md-input-container><md-button aria-label=\"reload\" \nng-click=\"vm.loadData(1)\" ng-if=\"vm.actionPermit.view\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button><md-button aria-label=\"create\" \nng-if=\"vm.actionPermit.create\" ng-click=\"vm.showDialog($event, \'CREATE\', null)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div><div flex></div><ms-search-bar ng-if=\"vm.actionPermit.view\" on-search=\"vm.pagination.load(1)\" \nquery=\"vm.pagination.search\" debounce=\"300\"></ms-search-bar></div></md-toolbar><div class=\"content md-background-bg\" \nms-scroll><md-content layout=\"column\" class=\"container\"><div class=\"simple-table-container md-whiteframe-4dp\"><table \nclass=\"app-table condensed\" ms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th class=\"text-center w-50\">\nNO</th><th class=\"text-center w-50\">ID</th><th class=\"text-start\">NAME</th><th class=\"text-start\">DESCRIPTION</th><th \nclass=\"text-start\">CATEGORY</th><th translate=\"PAGE.COMMON.TOOLBOX.ACTION\" class=\"text-center\">ACTION</th></tr></thead>\n<tbody><tr ng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"7\"><div flex \nlayout-align=\"center center\" layout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" \nmd-diameter=\"50\"></md-progress-circular></div></td></tr><tr \ndir-paginate=\"val in vm.pagination.data | itemsPerPage: vm.pagination.page_size\" total-items=\"vm.pagination.total\" \ncurrent-page=\"vm.pagination.current\"><td class=\"text-center w-50\">{{vm.pagination.from + $index}}</td><td \nclass=\"text-center\">{{val.id}}</td><td class=\"text-start\">{{val.name}}</td><td class=\"text-start\">{{val.description}}\n</td><td class=\"text-start\"><ol class=\"list-scheme-category\"><li ng-repeat=\"item in val.survey_scheme_category\">\n{{item.survey_category.name}} - {{item.survey_category.type}}</li></ol></td><td class=\"text-center\"><div layout=\"row\" \nlayout-align=\"center\"><md-button aria-label=\"update\" ng-if=\"vm.actionPermit.update\" \nng-click=\"vm.showDialog($event, \'UPDATE\', val)\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button aria-label=\"delete\" ng-if=\"vm.actionPermit.delete\" \nng-click=\"vm.showDialog($event, \'DELETE\', val, true)\" class=\"md-icon-button md-raised md-warn md-hue-2 small-8\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></div></td></tr></tbody></table><dir-pagination-controls \non-page-change=\"vm.onPageChange(newPageNumber)\" template-url=\"app/core/templates/pagination.html\">\n</dir-pagination-controls></div></md-content></div></div>");
$templateCache.put("app/main/utility/menu/menu.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\" translate=\"PAGE.MENU.TITLE\">Menu</div><div translate=\"PAGE.MENU.SUB_TITLE\" \nclass=\"sub-title\">This is menu page</div></div><div flex></div><div class=\"header-toolbox\"><md-button \naria-label=\"help\" class=\"md-icon-button md-primary md-hue-3\"><md-icon md-font-icon=\"icon-question-mark-circle\">\n</md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span></md-tooltip></md-button></div></div>\n<md-toolbar layout=\"row\" layout-align=\"start center\" class=\"md-background md-hue-3 toolbar\"><div \nclass=\"md-toolbar-tools\"><div layout=\"row\" flex-gt-sm=\"30\" flex layout-align=\"start center\"><md-input-container flex \nclass=\"wrapper-input\"><label>Group</label><md-select ng-model=\"vm.group\" class=\"md-accent md-hue-1\" name=\"group\">\n<md-option ng-selected=\"vm.group == val.id\" ng-repeat=\"val in vm.listGroup\" ng-value=\"val.id\">{{val.name}}</md-option>\n</md-select></md-input-container><md-button aria-label=\"reload\" ng-disabled=\"!vm.group || vm.isLoading\" \nng-click=\"vm.loadData()\" class=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon \nmd-font-icon=\"icon-refresh\"></md-icon></md-button></div></div></md-toolbar><div class=\"content md-background-bg\" \nms-scroll><md-content layout=\"column\" class=\"container\"><div layout=\"row\" ng-show=\"!vm.isLoading\" \nclass=\"menu-container animate-fade-in-out\"><md-list flex ng-cloak><md-list-item ng-repeat-start=\"item in vm.listMenu\">\n<md-icon class=\"primary-fg\" md-font-icon=\"{{item.icon}}\"></md-icon><p>{{ item.title }}</p><md-switch \nng-change=\"vm.switchMenu(item)\" class=\"md-secondary\" ng-model=\"item.checked\"></md-switch></md-list-item><div \nng-if=\"item.actions.length > 0 && item.checked\" class=\"actions-wrapper md-primary-bg md-hue-2\" layout=\"column\" \nlayout-align=\"space-between start\"><div class=\"h3\">Actions</div><div layout=\"row\" layout-wrap \nlayout-align=\"space-between start\"><md-switch flex-gt-sm ng-change=\"vm.switchAction(action)\" ng-model=\"action.checked\" \nng-repeat=\"action in item.actions\">{{action.actions}}</md-switch></div></div><div \nclass=\"child-wrapper padding-left-30 padding-right-30\" ng-if=\"item.childs.length > 0 && item.checked\"><md-list-item \nng-repeat-start=\"child in item.childs\"><md-icon class=\"primary-fg\" md-font-icon=\"{{child.icon}}\"></md-icon><p>\n{{ child.title }}</p><md-switch ng-change=\"vm.switchMenu(child)\" class=\"md-secondary\" ng-model=\"child.checked\">\n</md-switch></md-list-item><div ng-if=\"child.actions.length > 0 && child.checked\" \nclass=\"actions-wrapper md-primary-bg md-hue-3\" layout=\"column\" layout-align=\"space-between start\"><div class=\"h3\">\nActions</div><div layout=\"row\" layout-wrap layout-align=\"space-between start\"><md-switch \nng-change=\"vm.switchAction(action)\" flex-gt-sm ng-model=\"action.checked\" ng-repeat=\"action in child.actions\">\n{{action.actions}}</md-switch></div></div><md-divider ng-if=\"$index !== item.childs.length - 1\"></md-divider><span \nstyle=\"display: block; height: 10px\" ng-repeat-end></span></div><md-divider ng-repeat-end></md-divider></md-list></div>\n</md-content></div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\" class=\"md-primary-bg\"><div layout=\"row\" layout-align=\"start center\" flex>\n<md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nmd-colors=\"{background: \'{{vm.theme}}-primary\'}\" class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nng-src=\"assets/images/avatars/{{vm.groupName}}.png\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>{{vm.userName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div>\n</md-button><md-menu-content md-colors=\"{background: \'{{vm.theme}}-primary-600\', color: \'{{vm.theme}}-primary-100\' }\" \nwidth=\"3\"><md-menu-item md-colors=\"{color: \'{{vm.theme}}-primary-100\'}\" class=\"md-indent\"><md-icon \nmd-colors=\"{color: \'{{vm.theme}}-primary-100\'}\" md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/clients/assessment-tiki/tiki-guide/tiki-guide.html","<div class=\"tiki-guide md-whiteframe-10dp md-background md-hue-2\" flex layout=\"column\"><div class=\"intructions\" \nng-if=\"vm.sectionId == 1\"><div class=\"h2 text-bold green-700-fg\">BAGIAN {{ vm.sectionId }}</div><div \nclass=\"h4 text-semibold green-700-fg\">Waktu 7 Menit</div><div class=\"h5 text-semibold\">Instruksi :</div><p \nclass=\"text-info\">\nTest berikut ini terdiri dari soal-soal berhitung. Setiap soal disertai dengan kemungkinan jawaban A, B, C, dan D. Salah satu diantaranya adalah jawaban yang benar dari soal tersebut.\n</p><p class=\"text-info\">Perhatikan sekarang contoh dibawah ini.</p><p class=\"question\">18 + 7 = ...</p><div \nlayout=\"column\"><div layout=\"row\"><md-checkbox ng-checked=\"true\">A. 25</md-checkbox></div><div layout=\"row\">\n<md-checkbox ng-checked=\"false\">B. 26</md-checkbox></div><div layout=\"row\"><md-checkbox ng-checked=\"false\">C. 24\n</md-checkbox></div><div layout=\"row\"><md-checkbox ng-checked=\"false\">D. 23</md-checkbox></div></div><p>\nPada contoh diatas dapat dilihat bahwa 18 + 7 = 25. Jawaban yang benar adalah <b>A</b></p><p>\nUntuk mencorat-coret hitungan diperkenankan untuk menggunakan kertas, tetapi <b \nclass=\"text-danger text-italic text-boxed red-700-fg\">\"Tidak boleh menggunakan kalkulator\"</b><br></p><p \nstyle=\"margin-bottom: 20px\">Ketika anda klik <b>START </b>\n, maka waktu akan mulai berjalan. Pada Bagian 1, waktu yang disediakan adalah <span class=\"text-bold\">7 menit</span>.\n</p></div><div class=\"intructions\" layout=\"column\" ng-if=\"vm.sectionId == 2\"><div class=\"h2 text-bold green-700-fg\">\nBAGIAN {{ vm.sectionId }}</div><div class=\"h4 text-semibold green-700-fg\">Waktu 7 Menit</div><div \nclass=\"h5 text-semibold\">Instruksi :</div><p class=\"text-info\">\nTes berikut ini terdiri dari gambar bentuk-bentuk. Gambar dari setiap soal merupakan bentuk yang terpotong menjadi 3 bagian yang sudah ditentukan. Terdapat 6 gambar a, b, c, d, e, dan f. Dua diantaranya terbuat dari bagian-bagian yang terdapat dipilihan jawaban.\n</p><p class=\"text-info\">\nCarilah kedua gambar tersebut. Apabila sudah ditemukan, Pilih seperti dibawah ini untuk mengisi jawaban.</p><p \nclass=\"question\"><img imageonload=\"assets/images/tiki/S21.JPG\" src=\"assets/images/loader.svg\"></p><div layout=\"column\">\n<div layout=\"row\"><md-checkbox ng-checked=\"false\"><b>A. </b><img imageonload=\"assets/images/tiki/Z21A.JPG\" \nsrc=\"assets/images/loader.svg\"></md-checkbox></div><div layout=\"row\"><md-checkbox ng-checked=\"true\"><b>B. </b><img \nimageonload=\"assets/images/tiki/Z21B.JPG\" src=\"assets/images/loader.svg\"></md-checkbox></div><div layout=\"row\">\n<md-checkbox ng-checked=\"false\"><b>C. </b><img imageonload=\"assets/images/tiki/Z21C.JPG\" \nsrc=\"assets/images/loader.svg\"></md-checkbox></div><div layout=\"row\"><md-checkbox ng-checked=\"true\"><b>D. </b><img \nimageonload=\"assets/images/tiki/Z21D.JPG\" src=\"assets/images/loader.svg\"></md-checkbox></div><div layout=\"row\">\n<md-checkbox ng-checked=\"false\"><b>E. </b><img imageonload=\"assets/images/tiki/Z21E.JPG\" \nsrc=\"assets/images/loader.svg\"></md-checkbox></div><div layout=\"row\"><md-checkbox ng-checked=\"false\"><b>F. </b><img \nimageonload=\"assets/images/tiki/Z21F.JPG\" src=\"assets/images/loader.svg\"></md-checkbox></div></div><p>\nJawaban yang benar adalah <b>B</b> dan <b>D</b></p><p style=\"margin-bottom: 20px\">Ketika anda klik <b>START </b>\n, maka waktu akan mulai berjalan. Pada Bagian 2, waktu yang disediakan adalah <span class=\"text-bold\">7 menit</span>.\n</p></div><div class=\"intructions\" layout=\"column\" ng-if=\"vm.sectionId == 3\"><div class=\"h2 text-bold green-700-fg\">\nBAGIAN {{ vm.sectionId }}</div><div class=\"h4 text-semibold green-700-fg\">Waktu 5 Menit</div><div \nclass=\"h5 text-semibold\">Instruksi :</div><p class=\"text-info\">\nTest berikut ini terdiri dari kata-kata. Setiap soal terdiri dari 4 kata, a, b, c, dan d. Pilihlah 2 buah kata yang memiliki persamaan arti yang paling dekat atau yang mempunyai arti yang berlawanan. Setelah kata-kata itu ditemukan,\n</p><p class=\"text-info\">Pilih seperti dibawah ini untuk mengisi jawaban.</p><p class=\"question\">\nPilihlah 2 buah kata yang memiliki persamaan arti yang paling dekat atau yang mempunyai arti yang berlawanan.</p><div \nlayout=\"column\"><div layout=\"row\"><md-checkbox ng-checked=\"true\"><b>A. </b>Menikah</md-checkbox></div><div \nlayout=\"row\"><md-checkbox ng-checked=\"false\"><b>B. </b>Menebang</md-checkbox></div><div layout=\"row\"><md-checkbox \nng-checked=\"true\"><b>C. </b>Kawin</md-checkbox></div><div layout=\"row\"><md-checkbox ng-checked=\"false\"><b>D. </b>\nMeneduh</md-checkbox></div></div><p>\nPada contoh 1 dapat dilihat, bahwa kata-kata menikah dan kawin memiliki keasamaan arti. Jadi, jawaban contoh 1 adalah \n<b>A</b> dan <b>C</b>.</p><p style=\"margin-bottom: 20px\">Ketika anda klik <b>START </b>\n, maka waktu akan mulai berjalan. Pada Bagian 3, waktu yang disediakan adalah <span class=\"text-bold\">5 menit</span>.\n</p></div><div class=\"intructions\" layout=\"column\" ng-if=\"vm.sectionId == 4\"><div class=\"h2 text-bold green-700-fg\">\nBAGIAN {{ vm.sectionId }}</div><div class=\"h4 text-semibold green-700-fg\">Waktu 15 Menit</div><div \nclass=\"h5 text-semibold\">Instruksi :</div><p class=\"text-info\">\nDalam test ini setiap soal terdiri dari 10 gambar. Empat gambar pertama dari setiap soal menunjukkan kesamaan dalam suatu hal atau segi tertentu.\n<br>Dua diantara enam gambar a, b, c, d, e, dan f berikutnya menunjukkan kesamaan dengan keempat gambar pertama itu.\n</p><p class=\"text-info\">\nCarilah kedua gambar yang dimaksudkan itu. Apabila kedua gambar itu sudah ditemukan, Pilih seperti dibawah ini untuk mengisi jawaban.\n</p><p class=\"question\"><img imageonload=\"assets/images/tiki/S41.JPG\" src=\"assets/images/loader.svg\"></p><div \nlayout=\"row\"><md-checkbox ng-checked=\"false\"><b>A. </b><img imageonload=\"assets/images/tiki/Z41A.JPG\" \nsrc=\"assets/images/loader.svg\"></md-checkbox><md-checkbox ng-checked=\"true\"><b>B. </b><img \nimageonload=\"assets/images/tiki/Z41B.JPG\" src=\"assets/images/loader.svg\"></md-checkbox><md-checkbox ng-checked=\"false\">\n<b>C. </b><img imageonload=\"assets/images/tiki/Z41C.JPG\" src=\"assets/images/loader.svg\"></md-checkbox><md-checkbox \nng-checked=\"true\"><b>D. </b><img imageonload=\"assets/images/tiki/Z41D.JPG\" src=\"assets/images/loader.svg\">\n</md-checkbox><md-checkbox ng-checked=\"false\"><b>E. </b><img imageonload=\"assets/images/tiki/Z41E.JPG\" \nsrc=\"assets/images/loader.svg\"></md-checkbox><md-checkbox ng-checked=\"false\"><b>F. </b><img \nimageonload=\"assets/images/tiki/Z41F.JPG\" src=\"assets/images/loader.svg\"></md-checkbox></div><p>\nJawaban yang benar adalah <b>B</b> dan <b>D</b></p><p style=\"margin-bottom: 20px\">Ketika anda klik <b>START </b>\n, maka waktu akan mulai berjalan. Pada Bagian 4, waktu yang disediakan adalah <span class=\"text-bold\">7 menit</span>.\n</p></div><div layout=\"row\" layout-align=\"end center\"><md-progress-circular md-diameter=\"30\" ng-show=\"vm.isLoading\" \nclass=\"md-accent\" md-mode=\"indeterminate\"></md-progress-circular><md-button ng-disabled=\"vm.isLoading\" \nng-click=\"vm.start($event)\" class=\"md-raised md-warn\">Start</md-button></div></div>");
$templateCache.put("app/main/clients/assessment-tiki/tiki-section/tiki-section.html","<div layout=\"column\" class=\"tiki-section\"><div class=\"tiki-step\" layout=\"row\" layout-align=\"space-between center\"><div \nng-class=\"{active : 1 <= vm.sectionId}\" class=\"round\">1</div><div class=\"divider\"><div \nng-style=\"{width: vm.sectionId == 1 ? vm.progressWidth : 1 <= vm.sectionId ? \'100%\' : \'0%\' }\" class=\"fill\"></div></div>\n<div ng-class=\"{active : 2 <= vm.sectionId}\" class=\"round\">2</div><div class=\"divider\"><div \nng-style=\"{width: vm.sectionId == 2 ? vm.progressWidth : 2 <= vm.sectionId ? \'100%\' : \'0%\' }\" class=\"fill\"></div></div>\n<div ng-class=\"{active : 3 <= vm.sectionId}\" class=\"round\">3</div><div class=\"divider\"><div \nng-style=\"{width: vm.sectionId == 3 ? vm.progressWidth : 3 <= vm.sectionId ? \'100%\' : \'0%\' }\" class=\"fill\"></div></div>\n<div ng-class=\"{active : 4 <= vm.sectionId}\" class=\"round\">4</div></div><div layout-wrap layout=\"column\" flex-gt-sm \nlayout-gt-sm=\"row\"><div layout=\"column\" flex-order=\"2\" flex-order-gt-sm=\"1\" \nclass=\"white-bg padding-25 md-whiteframe-5dp\" flex-gt-sm=\"80\"><div flex-gt-sm layout=\"row\" \nlayout-align=\"center center\" class=\"question-count md-accent-bg\">\n{{vm.activeQuestion.index + 1}} from {{vm.questions.length}}</div><div ng-if=\"vm.activeQuestion.type == 1\" flex-gt-sm \nclass=\"normal-question\" layout=\"column\"><div layout=\"row\" class=\"question-container margin-bottom-10\">\n{{vm.activeQuestion.question}}</div><div layout=\"column\" class=\"answer-container\"><md-checkbox \nng-repeat=\"item in vm.activeQuestion.answer\" ng-model=\"item.selected\">{{item.answer}}</md-checkbox></div></div><div \nng-if=\"vm.activeQuestion.type == 2\" flex-gt-sm class=\"image-question\" layout=\"column\"><div layout=\"row\" \nclass=\"question-container\"><img imageonload=\"assets/images/tiki/{{ vm.activeQuestion.question }}\" \nsrc=\"assets/images/loader.svg\"></div><div layout-gt-sm=\"row\" layout=\"column\" layout-align=\"space-between start\" \nclass=\"answer-container\"><md-checkbox class=\"checkbox-answer\" ng-repeat=\"item in vm.activeQuestion.answer\" \nng-model=\"item.selected\"><div class=\"abjact font-size-20\">{{item.key}}</div><img \nimageonload=\"assets/images/tiki/{{ item.answer }}\" src=\"assets/images/loader.svg\"></md-checkbox></div></div></div><div \nclass=\"tiki-timer padding-10\" layout=\"column\" flex-order=\"1\" flex-order-gt-sm=\"2\" flex-gt-sm=\"20\"><div \nclass=\"tiki-timer-head\" layout=\"column\" layout-align=\"start center\"><div class=\"title\">Section {{vm.sectionId}}</div>\n<div ng-if=\"vm.sectionId == 1\" class=\"h2\">Berhitung Angka</div><div ng-if=\"vm.sectionId == 2\" class=\"h2\">\nGabungan Bagian</div><div ng-if=\"vm.sectionId == 3\" class=\"h2\">Hubungan Kata</div><div ng-if=\"vm.sectionId == 4\" \nclass=\"h2\">Abstraksi Non Verbal</div></div><div class=\"timer\" layout=\"column\" layout-align=\"start center\"><div \nclass=\"title\">Waktu Tersisa</div><div class=\"h2\">{{vm.displayTimer}}</div></div><div class=\"tiki-timer-hint\">\nPerhatian, pada saat anda menekan tombol finish, maka anda tidak dapat kembali ke section ini.</div><md-button flex \nstyle=\"max-height: 40px; min-height: 40px\" ng-click=\"vm.finish($event)\" class=\"md-primary md-raised\">Finish</md-button>\n</div></div><div layout=\"row\" class=\"margin-top-20\" flex layout-align=\"space-between center\"><md-button flex \nng-disabled=\"vm.activeQuestion.index == 0\" ng-click=\"vm.prevQuestion()\" class=\"md-warn md-raised\">Sebelumnya\n</md-button><md-button flex ng-click=\"vm.nextQuestion()\" ng-disabled=\"vm.lastIndex == vm.activeQuestion.index\" \nclass=\"md-accent md-raised\">Selanjutnya</md-button><div flex-gt-sm=\"20\" show-gt-sm></div></div></div>");
$templateCache.put("app/main/clients/toolbar/view-guide/view-guide.html","<md-dialog aria-label=\"View Guide Dialog\" flex-gt-md=\"70\" flex-gt-sm=\"80\" class=\"view-dialog\" md-theme=\"{{vm.theme}}\">\n<md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">GUIDE</h2><span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" \naria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" \nlayout-align=\"center center\"><view-pdf src=\"vm.guide\"></view-pdf></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout=\"start center\"><span flex></span><md-button ng-click=\"vm.cancel()\">CLOSE</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/case-study/question/form/form.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-md=\"60\" md-theme=\"{{vm.theme}}\"><form name=\"frmRequest\" ng-cloak>\n<md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">\n{{vm.dialogType | titleCase }} Case Study</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ng-init=\"vm.setForm(frmRequest)\"><div class=\"form-overlay-wrapper animate-fade-in-out\" \nng-show=\"vm.isLoading\"><div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\">\n<md-progress-circular md-diameter=\"20px\" class=\"md-warn\"></md-progress-circular><div class=\"padding-top-10\">\n{{vm.loadingMessage}}</div></div></div><div class=\"md-dialog-content\"><div layout=\"column\"><md-input-container \nclass=\"md-accent\" flex><label>Name</label><input name=\"name\" type=\"text\" placeholder=\"ex: Math\" required \nng-model=\"vm.data.name\"><div ng-messages=\"frmRequest.name.$error\"><div ng-message=\"required\">This is required!</div>\n</div></md-input-container><md-input-container class=\"md-accent\" flex><label>Description</label><textarea \nname=\"description\" placeholder=\"ex: you need to read carefully this case study ... \" required cols=\"4\" \nng-model=\"vm.data.description\">\n                        </textarea><div ng-messages=\"frmRequest.description.$error\">\n<div ng-message=\"required\">This is required!</div></div></md-input-container><div layout=\"column\" \nclass=\"view-attachment-container\"><div layout=\"column\" class=\"view-pdf-container\" layout-align=\"start\"><md-button \nclass=\"md-warn small-8\" ng-click=\"vm.media = null\" ng-show=\"vm.media\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n<span>remove</span></md-button><embed ng-show=\"vm.media\" ngf-src=\"vm.media\" type=\"application/pdf\"></div><input \ntype=\"file\" required ngf-select ng-model=\"vm.media\" name=\"image_temp\" accept=\"application/pdf\" \nngf-model-invalid=\"vm.errorImage\"></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout=\"start center\"><span ng-show=\"vm.errorMessage\" class=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} \n</span><span flex></span><md-button ng-click=\"vm.cancel()\">CLOSE</md-button><md-button \nng-if=\"vm.dialogType === \'CREATE\'\" ng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus \nclass=\"md-accent\" ng-click=\"vm.create($event, frmRequest)\">CREATE</md-button><md-button \nng-if=\"vm.dialogType === \'UPDATE\'\" ng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus \nclass=\"md-accent\" ng-click=\"vm.update($event, frmRequest)\">UPDATE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/case-study/scheme/form/form.html","<md-dialog aria-label=\"Form Dialog\" flex=\"60\" md-theme=\"{{vm.theme}}\"><form name=\"frmRequest\" ng-cloak><md-toolbar \nclass=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">\n{{vm.dialogType | titleCase }} Case Study Scheme</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ng-init=\"vm.setForm(frmRequest)\"><div class=\"form-overlay-wrapper animate-fade-in-out\" \nng-show=\"vm.isLoading\"><div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\">\n<md-progress-circular md-diameter=\"20px\" class=\"md-warn\"></md-progress-circular><div class=\"padding-top-10\">\n{{vm.loadingMessage}}</div></div></div><div class=\"md-dialog-content\"><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container class=\"md-accent\" flex><label>Name</label><input name=\"name\" type=\"text\" \nplaceholder=\"ex: satisfaction scheme\" required ng-model=\"vm.data.name\"><div ng-messages=\"frmRequest.name.$error\"><div \nng-message=\"required\">This is required!</div></div></md-input-container><md-input-container class=\"md-accent\" flex>\n<label>Description</label><input name=\"description\" type=\"text\" placeholder=\"ex: satisfaction scheme description\" \nrequired ng-model=\"vm.data.description\"><div ng-messages=\"frmRequest.description.$error\"><div ng-message=\"required\">\nThis is required!</div></div></md-input-container></div><div layout=\"column\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"md-accent\" flex><label>Question</label><md-select \nng-model=\"vm.selectedRef\" class=\"md-accent md-hue-1\" name=\"selected_ref\"><md-option \nng-selected=\"vm.selectedRef.id == val.id\" ng-repeat=\"val in vm.listRef\" ng-value=\"val\">{{val.name}}</md-option>\n</md-select></md-input-container><span flex></span><md-button ng-click=\"vm.doAdd(vm.selectedRef)\" \nclass=\"md-icon-button md-raised md-accent\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nlayout=\"column\"><fieldset><legend>Questions</legend><md-list flex class=\"md-dense\"><md-list-item class=\"md-2-line\" \nng-repeat-start=\"item in vm.data.case_study_scheme_question\"><div class=\"md-list-item-text\"><h3>{{ item.name }}</h3><p>\n{{ item.description }}</p></div><md-button class=\"md-secondary md-icon-button\" ng-click=\"vm.doRemove($index)\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></md-list-item><md-divider ng-repeat-end></md-divider></md-list>\n</fieldset></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout=\"start center\"><span \nng-show=\"vm.errorMessage\" class=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} </span><span flex></span>\n<md-button ng-click=\"vm.cancel()\">CLOSE</md-button><md-button ng-if=\"vm.dialogType === \'CREATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.submit($event, frmRequest)\">CREATE</md-button><md-button ng-if=\"vm.dialogType === \'UPDATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.update($event, frmRequest)\">UPDATE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/qa/pool/form/form.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-md=\"60\" md-theme=\"{{vm.theme}}\"><form name=\"frmRequest\" ng-cloak>\n<md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">\n{{vm.dialogType | titleCase }} Question Pool</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ng-init=\"vm.setForm(frmRequest)\"><div class=\"form-overlay-wrapper animate-fade-in-out\" \nng-show=\"vm.isPreparing\"><div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\">\n<md-progress-circular md-diameter=\"20px\" class=\"md-warn\"></md-progress-circular><div class=\"padding-top-10\">\n{{vm.loadingMessage}}</div></div></div><div class=\"md-dialog-content\"><div layout=\"column\"><md-input-container \nclass=\"md-accent\" flex><label>Name</label><input name=\"name\" type=\"text\" placeholder=\"ex: Math\" required \nng-model=\"vm.data.name\"><div ng-messages=\"frmRequest.name.$error\"><div ng-message=\"required\">This is required!</div>\n</div></md-input-container><md-input-container class=\"md-accent\" flex><label>Description</label><input \nname=\"description\" type=\"text\" placeholder=\"ex: Math Category\" required ng-model=\"vm.data.description\"><div \nng-messages=\"frmRequest.description.$error\"><div ng-message=\"required\">This is required!</div></div>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout=\"start center\"><span \nng-show=\"vm.errorMessage\" class=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} </span><span flex></span>\n<md-button ng-click=\"vm.cancel()\">CLOSE</md-button><md-button ng-if=\"vm.dialogType === \'CREATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.submit($event, frmRequest)\">CREATE</md-button><md-button ng-if=\"vm.dialogType === \'UPDATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.update($event, frmRequest)\">UPDATE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/qa/competency/form/form.html","<md-dialog aria-label=\"Form Dialog\" flex=\"60\" md-theme=\"{{vm.theme}}\"><form name=\"frmRequest\" ng-cloak><md-toolbar \nclass=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">\n{{vm.dialogType | titleCase }} Competency</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ng-init=\"vm.setForm(frmRequest)\"><div class=\"form-overlay-wrapper animate-fade-in-out\" \nng-show=\"vm.isPreparing\"><div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\">\n<md-progress-circular md-diameter=\"20px\" class=\"md-warn\"></md-progress-circular><div class=\"padding-top-10\">\n{{vm.loadingMessage}}</div></div></div><div class=\"md-dialog-content\"><div layout=\"column\"><md-input-container \nclass=\"md-accent\" flex><label>Name</label><input name=\"name\" type=\"text\" placeholder=\"ex: Math\" required \nng-model=\"vm.data.name\"><div ng-messages=\"frmRequest.name.$error\"><div ng-message=\"required\">This is required!</div>\n</div></md-input-container><md-input-container class=\"md-accent\" flex><label>Description</label><input \nname=\"description\" type=\"text\" placeholder=\"ex: Math Category\" required ng-model=\"vm.data.description\"><div \nng-messages=\"frmRequest.description.$error\"><div ng-message=\"required\">This is required!</div></div>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout=\"start center\"><span \nng-show=\"vm.errorMessage\" class=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} </span><span flex></span>\n<md-button ng-click=\"vm.cancel()\">CLOSE</md-button><md-button ng-if=\"vm.dialogType === \'CREATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.submit($event, frmRequest)\">CREATE</md-button><md-button ng-if=\"vm.dialogType === \'UPDATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.update($event, frmRequest)\">UPDATE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/qa/qa-general/form/form.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-md=\"70\" class=\"qa-general-component-dialog\" md-theme=\"{{vm.theme}}\"><form \nname=\"frmRequest\" ng-cloak><md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 \nclass=\"text-capitalize\">{{vm.dialogType | titleCase }} Question</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"padding-0\" ng-init=\"vm.setForm(frmRequest)\"><div \nclass=\"form-overlay-wrapper animate-fade-in-out\" ng-show=\"vm.isLoading\"><div flex layout=\"column\" layout-fill \nlayout-align=\"center center\" class=\"text-overlay\"><md-progress-circular md-diameter=\"20px\" class=\"md-warn\">\n</md-progress-circular><div class=\"padding-top-10\">{{vm.loadingMessage}}</div></div></div><div \nclass=\"md-dialog-content\"><div layout=\"column\"><div layout-gt-xs=\"row\" layout=\"column\"><md-input-container \nclass=\"md-accent\" flex><label>Competency</label><md-select name=\"competency_id\" required ng-readonly=\"vm.errorInit\" \nplaceholder=\"Competency\" ng-model=\"vm.data.competency_id\"><md-option ng-value=\"val.id\" \nng-selected=\"vm.data.competency_id == val.id\" ng-repeat=\"val in vm.listCompetencies\">{{val.description}}</md-option>\n</md-select><div ng-messages=\"frmRequest.competency_id.$error\"><div ng-message=\"required\">This is required!</div></div>\n</md-input-container><md-input-container class=\"md-accent\" flex><label>Question Category</label><md-select \nname=\"category_id\" required ng-readonly=\"vm.errorInit\" placeholder=\"Question Category\" ng-model=\"vm.data.category_id\">\n<md-option ng-value=\"val.id\" ng-selected=\"vm.data.category_id == val.id\" ng-repeat=\"val in vm.listQuestionCategory\">\n{{val.description}}</md-option></md-select><div ng-messages=\"frmRequest.category_id.$error\"><div ng-message=\"required\">\nThis is required!</div></div></md-input-container><md-input-container class=\"md-accent\" flex><label>Question Pool\n</label><md-select name=\"pool_id\" required ng-readonly=\"vm.errorInit\" placeholder=\"Question Pool\" \nng-model=\"vm.data.pool_id\"><md-option ng-value=\"val.id\" ng-selected=\"vm.data.pool_id == val.id\" \nng-repeat=\"val in vm.listQuestionPool\">{{val.description}}</md-option></md-select><div \nng-messages=\"frmRequest.pool_id.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container>\n</div><div layout-gt-sm=\"row\" layout=\"column\" class=\"question-container\"><div flex-gt-sm=\"20\" layout=\"column\" \nclass=\"question-type\"><p>Question Type</p><md-radio-group layout-xs=\"row\" ng-model=\"vm.data.question_type\">\n<md-radio-button value=\"normal\" class=\"md-accent\">Multiple</md-radio-button><md-radio-button ng-disabled=\"true\" \nclass=\"md-accent\" value=\"math\">Math</md-radio-button></md-radio-group></div><text-angular flex-gt-sm=\"80\" \nng-model=\"vm.data.question\"></text-angular></div><div layout=\"column\" class=\"upload-field\"><div layout=\"row\" \nlayout-align=\"start\"><img ng-show=\"frmRequest.image_temp.$valid\" ngf-thumbnail=\"vm.data.image_temp\"><md-button \nclass=\"md-warn small-8\" ng-click=\"vm.data.image_temp = null\" ng-show=\"vm.data.image_temp\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon><span>remove</span></md-button></div><input type=\"file\" ngf-select \nng-model=\"vm.data.image_temp\" name=\"image_temp\" accept=\"image/*\" ngf-max-size=\"2MB\" ngf-model-invalid=\"vm.errorImage\">\n<div ng-show=\"frmRequest.image_temp.$error.maxSize\"><span class=\"text-boxed md-warn-fg\">\nFile too large {{errorImage.size / 1000000|number:1}} MB: max 2M</span></div></div><div layout=\"column\"><div \nlayout=\"row\" class=\"answer-container\" layout-align=\"start center\" ng-repeat=\"item in vm.data.answers\"><md-button \nng-click=\"vm.minAnswer($index)\" class=\"md-icon-button md-warn\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button><div layout=\"column\" flex layout-align-sm=\"start center\" layout-gt-sm=\"row\"><md-input-container \nclass=\"answer-content\" flex-gt-sm=\"80\" flex-xs=\"100\"><label>Answer {{vm.indexToAbjact($index)}}</label><textarea \nname=\"answer-{{$index}}\" required md-no-float placeholder=\"Your answer here\" ng-model=\"item.answer\" rows=\"1\">\n</textarea><div ng-messages=\"frmRequest[\'answer-\'+$index].$error\"><div ng-message=\"required\">This is required!</div>\n</div></md-input-container><md-checkbox ng-model=\"item.flag\" aria-label=\"Answer {{$index}}\" ng-true-value=\"1\" \nng-false-value=\"0\" class=\"md-warn md-align-top-left\" flex>{{item.flag == 1 ? \'Correct\' : \'Wrong\'}}</md-checkbox></div>\n</div><div layout=\"row\"><md-button flex=\"100\" ng-click=\"vm.addAnswer()\" \nclass=\"md-raised md-accent w-auto margin-left-0 margin-right-0\"><md-icon md-font-icon=\"icon-plus-circle\"></md-icon>\n</md-button></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout=\"start center\"><span \nng-show=\"vm.errorMessage\" class=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} </span><span flex></span>\n<md-button ng-click=\"vm.cancel()\">CLOSE</md-button><md-button ng-if=\"vm.dialogType === \'CREATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid || vm.errorInit || vm.isLoading\" md-autofocus \nclass=\"md-accent\" ng-click=\"vm.submit($event, frmRequest)\">CREATE</md-button><md-button \nng-if=\"vm.dialogType === \'UPDATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid || vm.errorInit || vm.isLoading\" md-autofocus \nclass=\"md-accent\" ng-click=\"vm.update($event, frmRequest)\">UPDATE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/qa/qa-general/upload/upload.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-md=\"70\" class=\"qa-general-upload-dialog\" md-theme=\"{{vm.theme}}\"><form \nname=\"frmRequest\" ng-cloak><md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 \nclass=\"text-capitalize\">Upload Question</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"padding-0\" ng-init=\"vm.setForm(frmRequest)\"><div \nclass=\"form-overlay-wrapper animate-fade-in-out\" ng-show=\"vm.isLoading\"><div flex layout=\"column\" layout-fill \nlayout-align=\"center center\" class=\"text-overlay\"><md-progress-circular md-diameter=\"20px\" class=\"md-warn\">\n</md-progress-circular><div class=\"padding-top-10\">{{vm.loadingMessage}}</div></div></div><div \nclass=\"md-dialog-content\"><div layout=\"column\"><div layout=\"row\"><md-input-container class=\"md-accent\" flex><label>\nQuestion Pool</label><md-select name=\"pool_id\" required ng-readonly=\"vm.errorInit\" placeholder=\"Question Pool\" \nng-model=\"vm.data.pool_id\"><md-option ng-value=\"val.id\" ng-selected=\"vm.data.pool_id == val.id\" \nng-repeat=\"val in vm.listQuestionPool\">{{val.description}}</md-option></md-select><div \nng-messages=\"frmRequest.pool_id.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container>\n</div><div layout=\"column\"><input type=\"file\" ngf-select required ng-model=\"vm.data.file\" name=\"file\" \nngf-pattern=\"\'.xls,.xlsx\'\" ngf-max-size=\"2MB\" ngf-model-invalid=\"vm.errorFile\"><div class=\"margin-top-10\" \nng-show=\"frmRequest.file.$error.maxSize\"><span class=\"text-boxed md-warn-fg margin-0\">\nFile too large {{errorFile.size / 1000000|number:1}} MB: max 2M</span></div><div class=\"margin-top-10\" \nng-show=\"frmRequest.file.$error.pattern\"><span class=\"text-boxed md-warn-fg margin-0\">\nFile Extension must be .xls or .xlsx</span></div></div><div class=\"margin-top-10 error-log-container\" \nng-if=\"vm.isErrorUpload\" layout=\"column\"><md-subheader class=\"md-warn\">Upload Logs</md-subheader><table class=\"simple\">\n<thead><tr><th>Issues</th><th>Status</th><th>Messages</th></tr></thead><tbody><tr class=\"clickable\" \nng-if=\"key !== \'status\'\" ng-repeat-start=\"(key, val) in vm.validationLog\"><td>{{key}}</td><td>\n{{val.status ? \'SUCCESS\' : \'FAIL\'}}</td><td><div>{{val.message}}</div><div class=\"text-center\" \nng-if=\"key === \'headers\'\"><span ng-repeat=\"head in val.validation\" class=\"md-warn-fg margin-horizontal-10\">{{head}}\n</span></div></td></tr><tr ng-repeat-end ng-if=\"key === \'data\' && !val.status\"><td colspan=\"3\"><md-list \nclass=\"md-dense\"><md-subheader>Details</md-subheader><md-list-item ng-repeat-start=\"item in val.validation\" \nng-click=\"item.isCollapse = !item.isCollapse\"><div layout=\"row\"><div class=\"w-50 margin-right-10\">Row - {{ item.no }}\n</div><div ng-class=\"{\'green-400-fg\': item.is_valid, \'red-400-fg\': !item.is_valid}\">\n{{item.is_valid ? \'SUCCESS\' : \'FAIL\'}}</div></div></md-list-item><md-divider></md-divider><md-list-item \nng-if=\"item.isCollapse\" ng-repeat=\"more in item.validation\"><div class=\"error-details\" layout=\"column\"><div \nlayout=\"row\"><div class=\"w-150 margin-right-10\">{{ more.key | uppercase }}</div><div class=\"w-70 margin-right-10\" \nng-class=\"{\'green-400-fg\': more.status, \'red-400-fg\': !more.status}\">{{more.status ? \'SUCCESS\' : \'FAIL\'}}</div><div \nng-class=\"{\'red-400-fg\': !more.status}\">{{ more.message }}</div></div></div></md-list-item><md-divider ng-repeat-end>\n</md-divider></md-list></td></tr></tbody></table></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout=\"start center\"><span ng-show=\"vm.errorMessage\" class=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} \n</span><span flex></span><md-button ng-click=\"vm.cancel()\">CLOSE</md-button><md-button \nng-disabled=\"vm.isLoading || frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.submit($event)\">UPLOAD</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/qa/qa-papikostik/form/form.html","<md-dialog aria-label=\"Form Dialog\" flex=\"60\" md-theme=\"{{vm.theme}}\"><form name=\"frmRequest\" ng-cloak><md-toolbar \nclass=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">\n{{vm.dialogType | titleCase }} Papikostik</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ng-init=\"vm.setForm(frmRequest)\"><div class=\"form-overlay-wrapper animate-fade-in-out\" \nng-show=\"vm.isLoading\"><div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\">\n<md-progress-circular md-diameter=\"20px\" class=\"md-warn\"></md-progress-circular><div class=\"padding-top-10\">\n{{vm.loadingMessage}}</div></div></div><div class=\"md-dialog-content\"><div layout=\"column\"><md-input-container \nclass=\"md-accent\" flex><label>Question placeholder</label><input ng-disabled=\"true\" name=\"question\" type=\"text\" \nplaceholder=\"ex: Math\" required ng-model=\"vm.data.text\"><div ng-messages=\"frmRequest.question.$error\"><div \nng-message=\"required\">This is required!</div></div></md-input-container><md-input-container \nng-repeat=\"item in vm.data.papikostik_answers\" class=\"md-accent\" flex><label>Point Answer {{item.abjact}}</label>\n<textarea placeholder=\"ex: saya seorang yang optimis\" name=\"text_{{item.abjact}}\" rows=\"2\" ng-model=\"item.text\" \nrequired>\n                        </textarea><div ng-messages=\"frmRequest[\'text_{{$index}}\'].$error\"><div \nng-message=\"required\">This is required!</div></div></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout=\"start center\"><span ng-show=\"vm.errorMessage\" \nclass=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} </span><span flex></span><md-button \nng-click=\"vm.cancel()\">CLOSE</md-button><md-button ng-if=\"vm.dialogType === \'UPDATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.update($event, frmRequest)\">UPDATE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/qa/category/form/form.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-md=\"60\" md-theme=\"{{vm.theme}}\"><form name=\"frmRequest\" ng-cloak>\n<md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">\n{{vm.dialogType | titleCase }} Category</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ng-init=\"vm.setForm(frmRequest)\"><div class=\"form-overlay-wrapper animate-fade-in-out\" \nng-show=\"vm.isPreparing\"><div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\">\n<md-progress-circular md-diameter=\"20px\" class=\"md-warn\"></md-progress-circular><div class=\"padding-top-10\">\n{{vm.loadingMessage}}</div></div></div><div class=\"md-dialog-content\"><div layout=\"column\"><md-input-container \nclass=\"md-accent\" flex><label>Code</label><input name=\"code\" type=\"text\" placeholder=\"ex: K\" required \nng-model=\"vm.data.code\"><div ng-messages=\"frmRequest.code.$error\"><div ng-message=\"required\">This is required!</div>\n</div></md-input-container><md-input-container class=\"md-accent\" flex><label>Name</label><input name=\"name\" \ntype=\"text\" placeholder=\"ex: Math\" required ng-model=\"vm.data.name\"><div ng-messages=\"frmRequest.name.$error\"><div \nng-message=\"required\">This is required!</div></div></md-input-container><md-input-container class=\"md-accent\" flex>\n<label>Description</label><input name=\"description\" type=\"text\" placeholder=\"ex: Math Category\" required \nng-model=\"vm.data.description\"><div ng-messages=\"frmRequest.description.$error\"><div ng-message=\"required\">\nThis is required!</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout=\"start center\"><span ng-show=\"vm.errorMessage\" class=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} \n</span><span flex></span><md-button ng-click=\"vm.cancel()\">CLOSE</md-button><md-button \nng-if=\"vm.dialogType === \'CREATE\'\" ng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus \nclass=\"md-accent\" ng-click=\"vm.submit($event, frmRequest)\">CREATE</md-button><md-button \nng-if=\"vm.dialogType === \'UPDATE\'\" ng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus \nclass=\"md-accent\" ng-click=\"vm.update($event, frmRequest)\">UPDATE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/report/general/view-detail/view-detail.html","<div id=\"app-layout\" class=\"page-layout\" layout=\"column\" block-ui=\"block-content\"><div \nclass=\"header md-primary-bg md-hue-1 md-whiteframe-10dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"header-title\"><div class=\"h2\">Detail Report {{vm.data.achievement.user.name | titleCase}}</div><div \nlayout=\"row\" class=\"sub-title\"><div class=\"achievement\">submitted at : {{vm.data.achievement.created_at}}</div></div>\n</div><div flex></div><div class=\"header-toolbox\"><md-button class=\"md-icon-button md-primary md-hue-3\"><md-icon \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><md-tooltip><span translate=\"PAGE.COMMON.TOOLBOX.HELP\">Help</span>\n</md-tooltip></md-button></div></div><md-toolbar layout=\"row\" layout-align=\"space-between center\" \nclass=\"md-background md-hue-3 toolbar\"><div class=\"md-toolbar-tools\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-button aria-label=\"back\" ng-click=\"vm.backToReport()\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button aria-label=\"reload\" ng-click=\"vm.loadData(1)\" \nclass=\"md-icon-button md-raised md-accent md-hue-2 small-8\"><md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button>\n</div></div></md-toolbar><md-toolbar layout=\"row\" ng-show=\"vm.showFilter\" layout-align=\"space-between center\" \nclass=\"md-hue-3 secondary-toolbar\"><div class=\"md-toolbar-tools\"><md-input-container flex class=\"wrapper-input\"><label>\nGroup Participant</label><md-select ng-model=\"vm.groupParticipant\" class=\"md-accent md-hue-1\" name=\"groupParticipant\">\n<md-option ng-selected=\"vm.groupParticipant == val.id\" ng-repeat=\"val in vm.listGroupParticipant\" ng-value=\"val.id\">\n{{val.description}}</md-option></md-select><div class=\"md-errors-spacer\"></div></md-input-container><md-input-container\n flex class=\"wrapper-input\"><label>Start Date</label><input type=\"date\" name=\"start_date\" ng-model=\"vm.tempStart\" \nclass=\"md-accent md-hue-1\"></md-input-container><md-input-container flex class=\"wrapper-input\"><label>End Date</label>\n<input type=\"date\" name=\"end_date\" ng-model=\"vm.tempEnd\" class=\"md-accent md-hue-1\"></md-input-container></div>\n</md-toolbar><div class=\"content md-background-bg\" ms-scroll><md-content layout=\"column\" class=\"container\"><div \nclass=\"simple-table-container md-whiteframe-4dp report-detail-table\"><div layout=\"column\" layout-gt-sm=\"row\" \nclass=\"table-title\"><md-button class=\"md-raised white-fg indigo-400-bg\" flex>\nQUESTION TOTAL : {{vm.data.achievement.question_total}}</md-button><md-button \nng-click=\"vm.filter.valid = !vm.filter.valid\" class=\"md-raised white-fg green-400-bg\" \nng-class=\"{\'black-bg\' : vm.filter.valid}\" flex>CORRECT : {{vm.data.achievement.correct_answer}}</md-button><md-button \nng-click=\"vm.filter.invalid = !vm.filter.invalid\" class=\"md-raised white-fg red-400-bg\" \nng-class=\"{\'black-bg\' : vm.filter.invalid}\" flex>INCORRECT : {{vm.data.achievement.wrong_answer}}</md-button><md-button\n ng-click=\"vm.filter.not_answered = !vm.filter.not_answered\" class=\"md-raised white-fg blue-grey-400-bg\" \nng-class=\"{\'black-bg\' : vm.filter.not_answered}\" flex>NOT ANSWERED : {{vm.data.achievement.not_answered}}</md-button>\n</div><table class=\"app-table condensed\" ms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th \nclass=\"text-center w-50\">NO</th><th class=\"text-start\">QUESTION</th><th class=\"text-start\">SERVER ANSWER</th><th \nclass=\"text-start\">USER ANSWER</th><th class=\"text-start\">FLAG</th></tr></thead><tbody><tr \nng-show=\"vm.pagination.is_loading\" class=\"animate-fade-in-out\"><td colspan=\"8\"><div flex layout-align=\"center center\" \nlayout=\"column\" class=\"padding-20\"><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"50\">\n</md-progress-circular></div></td></tr><tr ng-repeat=\"val in vm.data.detail | filter : vm.filteredFlag\"><td \nclass=\"text-center w-50\">{{$index + 1}}</td><td class=\"text-start\" style=\"max-width: 400px\">\n{{val.question_answers.question}}</td><td class=\"text-start\"><ul style=\"list-style: none; padding-inline-start: 5px\">\n<li ng-repeat=\"answer in val.answers\" ng-if=\"answer.source == \'USER\'\"><span class=\"badge md-accent-bg\">\n{{answer.abjact}}</span> <span class=\"margin-right-5\">.</span> {{ answer.answer_name}}</li></ul></td><td \nclass=\"text-start\"><ul style=\"list-style: none; padding-inline-start: 5px\"><li ng-repeat=\"answer in val.answers\" \nng-if=\"answer.source == \'SERVER\'\"><span class=\"badge md-accent-bg\">{{answer.abjact}}</span> <span \nclass=\"margin-right-5\">.</span> {{ answer.answer_name}}</li></ul></td><td class=\"text-start\"><md-icon \nmd-font-icon=\"{{vm.renderIconFlag(val.flag)}}\"></md-icon></td></tr></tbody></table></div></md-content></div></div>");
$templateCache.put("app/main/report/papikostik/view-detail/view-detail-papikostik.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-md=\"70\" flex-gt-sm=\"70\" class=\"view-detail-papikostik-dialog\" \nmd-theme=\"{{vm.theme}}\"><md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 \nclass=\"text-capitalize\">Papikostik Detail | {{vm.refData.nik}}-{{vm.refData.name}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"padding-0\"><div class=\"md-dialog-content\"><div \nlayout=\"column\" class=\"table-container\"><div class=\"divider\"></div><md-divider></md-divider><div class=\"divider\"></div>\n<div layout=\"row\" ng-repeat=\"item in vm.detail\"><div class=\"header-1\" layout=\"row\" layout-align=\"start center\"><div>\n{{item.name}}</div></div><div class=\"header-2\" layout=\"row\"><div layout=\"column\"><div class=\"header-2-child\" \nng-repeat=\"d in item.ref_detail\"><span class=\"abjact\">{{d.abjact}}</span>{{d.name}}</div></div><div layout=\"column\">\n<div class=\"score-wrapper\" ng-repeat=\"d in item.ref_detail\"><div class=\"score\" \nng-repeat=\"i in d.cell_color track by $index\"><span ng-class=\"i\" class=\"score-data\">{{$index}}</span></div></div></div>\n</div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout=\"start center\"><span flex></span>\n<md-button ng-click=\"vm.cancel()\">CLOSE</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/report/survey/view/view.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-md=\"70\" flex-gt-sm=\"70\" class=\"view-detail-survey-dialog\" \nmd-theme=\"{{vm.theme}}\"><md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 \nclass=\"text-capitalize\">Survey Detail | {{vm.refData.nik}}-{{vm.refData.name}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"padding-0\"><div layout=\"column\"><div \nng-repeat=\"item in vm.results\" class=\"simple-table-container padding-20\"><div class=\"table-title\">{{item.name}}</div>\n<table class=\"app-table condensed\" ms-responsive-table><thead><tr class=\"md-accent-bg md-hue-2\"><th \nclass=\"text-center w-50\">NO</th><th class=\"text-start\">STATEMENT</th><th class=\"text-center\">ANSWER</th></tr></thead>\n<tbody><tr ng-repeat=\"val in item.data\"><td class=\"text-center w-50\">{{val.survey_question.question_order}}</td><td \nclass=\"text-start\">{{val.survey_question.question}}</td><td class=\"text-center\">{{val.answer}}</td></tr></tbody>\n</table></div><div layout=\"row\" flex></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout=\"start center\"><span flex></span><md-button ng-click=\"vm.cancel()\">CLOSE</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/report/case-study/view/view.html","<md-dialog aria-label=\"Form Dialog\" flex-gt-md=\"70\" flex-gt-sm=\"70\" class=\"view-detail-study-dialog\" \nmd-theme=\"{{vm.theme}}\"><md-toolbar class=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 \nclass=\"text-capitalize\">Case Study Detail | {{vm.refData.nik}}-{{vm.refData.name}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"padding-0\"><div \nclass=\"form-overlay-wrapper animate-fade-in-out\" ng-show=\"vm.isLoading\"><div flex layout=\"column\" layout-fill \nlayout-align=\"center center\" class=\"text-overlay\"><md-progress-circular md-diameter=\"20px\" class=\"md-warn\">\n</md-progress-circular><div class=\"padding-top-10\">{{vm.loadingMessage}}</div></div></div><div \nclass=\"md-dialog-content\"><div layout=\"column\"><div layout=\"row\" ng-repeat=\"item in vm.results\" \nclass=\"frame-container\" layout-align=\"space-between center\"><div class=\"frame-question\" layout=\"column\"><div \nclass=\"frame-title\">{{item.case_study_question.name}}</div><iframe \nng-src=\"{{vm.getResource(item.case_study_question.filename)}}\" frameborder=\"0\"></iframe></div><div \nclass=\"frame-answer\" ng-bind-html=\"vm.trustResource(item.answer)\"></div></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout=\"start center\"><span flex></span><md-button ng-click=\"vm.cancel()\">CLOSE\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/survey/category/form/form.html","<md-dialog aria-label=\"Form Dialog\" flex=\"60\" md-theme=\"{{vm.theme}}\"><form name=\"frmRequest\" ng-cloak><md-toolbar \nclass=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">\n{{vm.dialogType | titleCase }} Category</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ng-init=\"vm.setForm(frmRequest)\"><div class=\"form-overlay-wrapper animate-fade-in-out\" \nng-show=\"vm.isLoading\"><div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\">\n<md-progress-circular md-diameter=\"20px\" class=\"md-warn\"></md-progress-circular><div class=\"padding-top-10\">\n{{vm.loadingMessage}}</div></div></div><div class=\"md-dialog-content\"><div layout=\"row\"><md-input-container \nclass=\"md-accent\" flex><label>Type</label><md-select ng-model=\"vm.data.type\" class=\"md-accent md-hue-1\" \nng-disabled=\"true\" name=\"type\"><md-option ng-selected=\"vm.data.type == val\" ng-repeat=\"val in vm.listType\" \nng-value=\"val\">{{val}}</md-option></md-select></md-input-container><md-input-container class=\"md-accent\" flex><label>\nName</label><input name=\"name\" type=\"text\" placeholder=\"ex: Math\" required ng-model=\"vm.data.name\"><div \nng-messages=\"frmRequest.name.$error\"><div ng-message=\"required\">This is required!</div></div></md-input-container>\n</div><div layout=\"column\"><md-input-container class=\"md-accent\" flex><label>Description</label><input \nname=\"description\" type=\"text\" placeholder=\"ex: Math Category\" required ng-model=\"vm.data.description\"><div \nng-messages=\"frmRequest.description.$error\"><div ng-message=\"required\">This is required!</div></div>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout=\"start center\"><span \nng-show=\"vm.errorMessage\" class=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} </span><span flex></span>\n<md-button ng-click=\"vm.cancel()\">CLOSE</md-button><md-button ng-if=\"vm.dialogType === \'CREATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.submit($event, frmRequest)\">CREATE</md-button><md-button ng-if=\"vm.dialogType === \'UPDATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.confirmUpdate($event, frmRequest)\">UPDATE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/survey/question/form/form.html","<md-dialog aria-label=\"Form Dialog\" flex=\"60\" md-theme=\"{{vm.theme}}\"><form name=\"frmRequest\" ng-cloak><md-toolbar \nclass=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">\n{{vm.dialogType | titleCase }} Question</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ng-init=\"vm.setForm(frmRequest)\"><div class=\"form-overlay-wrapper animate-fade-in-out\" \nng-show=\"vm.isLoading\"><div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\">\n<md-progress-circular md-diameter=\"20px\" class=\"md-warn\"></md-progress-circular><div class=\"padding-top-10\">\n{{vm.loadingMessage}}</div></div></div><div class=\"md-dialog-content\"><div layout=\"row\"><md-input-container \nclass=\"md-accent\" flex><label>Category</label><md-select ng-model=\"vm.selectedCategory\" class=\"md-accent md-hue-1\" \nname=\"selected_category\" ng-change=\"vm.onChangeCategory()\"><md-option ng-selected=\"vm.selectedCategory.id == val.id\" \nng-repeat=\"val in vm.listCategory\" ng-value=\"val\">{{val.description}} - {{val.type}}</md-option></md-select>\n</md-input-container></div><div layout=\"column\" ng-show=\"vm.showState.normal || vm.showState.essay\"><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container class=\"md-accent\" flex><label>Order</label><input \nname=\"question_order\" type=\"number\" required ng-model=\"vm.data.question_order\"><div \nng-messages=\"frmRequest.question_order.$error\"><div ng-message=\"required\">This is required!</div></div>\n</md-input-container><md-input-container ng-show=\"vm.showState.normal\" class=\"md-accent\" flex><label>Point Value\n</label><input name=\"point_value\" type=\"number\" required ng-model=\"vm.data.point_value\"><div \nng-messages=\"frmRequest.point_value.$error\"><div ng-message=\"required\">This is required!</div></div>\n</md-input-container></div><div layout=\"column\"><md-input-container class=\"md-accent\" flex><label>Question</label>\n<textarea name=\"point_value\" required cols=\"6\" rows=\"6\" ng-model=\"vm.data.question\">\n                                 \n</textarea><div ng-messages=\"frmRequest.question.$error\"><div ng-message=\"required\">This is required!</div></div>\n</md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout=\"start center\"><span \nng-show=\"vm.errorMessage\" class=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} </span><span flex></span>\n<md-button ng-click=\"vm.cancel()\">CLOSE</md-button><md-button ng-if=\"vm.dialogType === \'CREATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.submit($event, frmRequest)\">CREATE</md-button><md-button ng-if=\"vm.dialogType === \'UPDATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.update($event, frmRequest)\">UPDATE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/survey/scheme/form/form.html","<md-dialog aria-label=\"Form Dialog\" flex=\"60\" md-theme=\"{{vm.theme}}\"><form name=\"frmRequest\" ng-cloak><md-toolbar \nclass=\"md-accent-bg\"><div class=\"md-toolbar-tools md-accent-bg\"><h2 class=\"text-capitalize\">\n{{vm.dialogType | titleCase }} Scheme</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ng-init=\"vm.setForm(frmRequest)\"><div class=\"form-overlay-wrapper animate-fade-in-out\" \nng-show=\"vm.isLoading\"><div flex layout=\"column\" layout-fill layout-align=\"center center\" class=\"text-overlay\">\n<md-progress-circular md-diameter=\"20px\" class=\"md-warn\"></md-progress-circular><div class=\"padding-top-10\">\n{{vm.loadingMessage}}</div></div></div><div class=\"md-dialog-content\"><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container class=\"md-accent\" flex><label>Name</label><input name=\"name\" type=\"text\" \nplaceholder=\"ex: satisfaction scheme\" required ng-model=\"vm.data.name\"><div ng-messages=\"frmRequest.name.$error\"><div \nng-message=\"required\">This is required!</div></div></md-input-container><md-input-container class=\"md-accent\" flex>\n<label>Description</label><input name=\"description\" type=\"text\" placeholder=\"ex: satisfaction scheme description\" \nrequired ng-model=\"vm.data.description\"><div ng-messages=\"frmRequest.description.$error\"><div ng-message=\"required\">\nThis is required!</div></div></md-input-container></div><div layout=\"column\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"md-accent\" flex><label>Category</label><md-select \nng-model=\"vm.selectedCategory\" class=\"md-accent md-hue-1\" name=\"selected_category\" ng-change=\"vm.onChangeCategory()\">\n<md-option ng-selected=\"vm.selectedCategory.id == val.id\" ng-repeat=\"val in vm.listCategory\" ng-value=\"val\">\n{{val.description}} - {{val.type}}</md-option></md-select></md-input-container><span flex></span><md-button \nng-click=\"vm.doAddCategory(vm.selectedCategory)\" class=\"md-icon-button md-raised md-accent\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div layout=\"column\"><fieldset><legend>Categories</legend><md-list\n flex class=\"md-dense\"><md-list-item class=\"md-2-line\" ng-repeat-start=\"item in vm.data.survey_scheme_category\"><div \nclass=\"md-list-item-text\"><h3>{{ item.description }}</h3><p>{{ item.type }}</p></div><md-button \nclass=\"md-secondary md-icon-button\" ng-click=\"vm.doRemoveCategory($index)\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon></md-button></md-list-item><md-divider ng-repeat-end></md-divider></md-list></fieldset></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout=\"start center\"><span ng-show=\"vm.errorMessage\" \nclass=\"text-boxed md-warn-fg text-start\">{{vm.errorMessage}} </span><span flex></span><md-button \nng-click=\"vm.cancel()\">CLOSE</md-button><md-button ng-if=\"vm.dialogType === \'CREATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.submit($event, frmRequest)\">CREATE</md-button><md-button ng-if=\"vm.dialogType === \'UPDATE\'\" \nng-disabled=\"frmRequest.$pristine || frmRequest.$invalid\" md-autofocus class=\"md-accent\" \nng-click=\"vm.update($event, frmRequest)\">UPDATE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-11/template-11.html","<div class=\"template-11 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.group_name\">{{card.group_name}}</div><div class=\"event h2\" \nng-if=\"card.pool_name\">{{card.pool_name}}</div></div><div class=\"media ml-16\"><md-button ng-click=\"card.callback\">\n</md-button></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);